export default {
  "termsOfUse": "Podmienky používania",
  "goToHome": "Späť na hlavnú stránku",
  "choose": "Vybrať",
  "close": "Zavrieť",
  "yes": "Ano",
  "no": "Ne",
  "moreInfo": "Viac informácií",
  "send": "Odoslať",
  "sendProcess": "Odosielanie",
  "sendSuccess": "Odoslané",
  "actual": "Aktuálně",
  "question": "Poradiť sa s lekárom",
  "appointment": "Zadat požiadavku",
  "freeDownload": "Stiahnite si zadarmo našu aplikáciu",
  "downloadAppStore": "Download on the App Store",
  "downloadGooglePlay": "Get it on Google Play",
  "month": "Mesiac",
  "year": "Rok",
  "other": "Iné",
  "backToStart": "Späť na úvod",
  "backToOverview": "Späť na prehľad služieb",
  "or": "alebo",
  "czechLanguage": "Česky",
  "slovakLanguage": "Slovensky",
  "englishLanguage": "Anglicky",
  "goNext": "Pokračovať",
  "goPrev": "späť",
  "save": "Uložiť",
  "show": "Ukázať",
  "showMore": "Zobraziť viac",
  "showAll": "Ukázať všetky",
  "open": "Rozbalit",
  "saveChanges": "Uložiť zmeny",
  "saveChangesProcess": "Ukladanie",
  "saveChangesSuccess": "Uložené",
  "loginText": "Prihlásiť sa",
  "contact": "Kontakt",
  "done": "Hotovo",
  "finish": "Dokončiť",
  "skip": "Preskočiť",
  "legalDocuments": "Právne dokumenty",
  "new": "Novinka",
  "free": "Zadarmo",
  "tryAgain": "Skúste to znova",
  "until": "do",
  "pilot": "Videohovor",
  "here": "tu",
  "currency": "Kč",
  "subscribe": "Odoberať",
  "agree": "Súhlasím",
  "disagree": "Nesúhlasím",
  "alertInfo": {
    "title": "Služba uLekára.sk, s.r.o. nenahrádza záchrannú službu.",
    "text": "Pri akútnych problémoch volajte linku 155.",
    "iAgree": "Rozumiem",
    "errorText": "Toto pole je povinné."
  },
  "uLekare": {
    "title": "uLekára.sk"
  },
  "partners": {
    "specialSupport": "Speciální podpora",
    "generalPartners": "Generální partneři",
    "otherPartners": "Partneri",
    "thankYouPartners": "Děkujeme za podporu našim partnerům",
    "info": "Služby Virtuální čekárny \n<strong class='primary--text text-bold'>jsou v období pandemie zdarma</strong> \ndíky partnerům."
  },
  "questionForm": {
    "title": "Vaša otázka lekárovi",
    "subtitle": "Co vás trápí, jak dlouho problém trvá, berete nějaké léky, proběhlo již nějaké vyšetření, ...",
    "modalTitle": "Priložte foto alebo lekárske správy.",
    "send": "Odeslat lékaři",
    "back": "Zpět k dotazu",
    "sendTitle": "Děkujeme za zaslání dotazu",
    "next": "Pokračovať",
    "sendPerex": "Děkujeme za vaši návštěvu ve Virtuální čekárně.",
    "question": {
      "placeholder": "Sem napište, co vás trápí",
      "errorText": "Prosím vyplňte dotaz pro lékaře, aby vám mohl poradit."
    },
    "firstName": {
      "title": "Meno",
      "placeholder": "Zadajte meno",
      "helpText": "Krstné meno zobrazíme pri otázkach na stránkach.",
      "helpTextNotShowing": "Meno je potrebné pre komunikáciu so zdravotným tímom.",
      "errorText": "Meno je povinné, prosím, vyplňte ho.",
      "helpTextRealData": "Zadajte svoje skutočné meno na komunikáciu so zdravotníckym zariadením."
    },
    "lastName": {
      "title": "Priezvisko",
      "placeholder": "Zadajte priezvisko",
      "helpText": "Priezvisko je potrebné pre komunikáciu so zdravotným tímom.",
      "errorText": "Priezvisko je povinné, prosím, vyplňte ho.",
      "helpTextRealData": "Zadajte svoje skutočné priezvisko na komunikáciu so zdravotníckym zariadením."
    },
    "email": {
      "title": "E-mail",
      "placeholder": "meno@priklad.cz",
      "helpText": "Prostredníctvom e-mailu s vami budeme komunikovať.",
      "hrbHelpText": "Doporučujeme uviesť súkromný e-mail.",
      "errorText": "E-mailová adresa je povinná prosím, vyplňte ju.",
      "errorEmailText": "E-mailová adresa nie je v správnom formáte.",
      "errorEmailNotExisting": "Prosím, vyplňte existujúcu e-mailovú adresu.",
      "invalidBenefitEmail": "Neplatný e-mail"
    },
    "phone": {
      "title": "Telefón",
      "placeholder": "123 456 789",
      "helpText": "Poradíme, na koho sa obrátiť.",
      "errorText": "Telefónne číslo je povinné, prosím, vyplňte ho.",
      "errorPhoneText": "Zadajte telefónne číslo ({exampleNumber})."
    },
    "emailphone": {
      "errorEmailText": "E-mailová adresa je povinný údaj, prosíme o vyplnění.",
      "errorPhoneText": "Telefonní číslo je povinný údaj, prosíme o vyplnění."
    },
    "birthYear": {
      "title": "Rok narodenia",
      "titleRegistered": "Rok narodenia pacienta",
      "helpText": "Rok narodenia osoby, ktorej sa problém týka.",
      "errorText": "Rok narodenia je povinný, prosím, vyplňte ho.",
      "errorLengthText": "Rok narodenia napíšte v štvorcifernom formáte.",
      "errorBetweenText": "Napíšte skutočný rok narodenia."
    },
    "pastYear": {
      "errorLengthText": "Rok narození napište ve formátu xxxx (např. 1989)",
      "errorBetweenText": "Napište skutečný rok. :)",
      "errorText": "Rok narození je povinný údaj, prosíme o vyplnění."
    },
    "zipCode": {
      "title": "PSČ",
      "helpText": "Podľa PSČ vám odporučíme, kam sa objednať.",
      "errorText": "PSČ je povinné, prosím, vyplňte ho.",
      "errorZipCodeText": "PSČ nemá správny formát."
    },
    "insuranceCompany": {
      "title": "Poisťovňa",
      "errorText": "Pole je povinné. Prosím, vyberte poisťovňu.",
      "selectInsuranceCompany": "Vyberte svoju poisťovňu"
    },
    "timeAvailability": {
      "title": "Vaša časová dostupnosť",
      "errorText": "Pole je povinné. Prosím vyplňte časovú dostupnosť.",
      "placeholder": "Napíšte, aké sú vaše časové možnosti v nasledujúcich dňoch."
    },
    "selectedBranchValue": {
      "title": "Ordinace",
      "selectInsuranceCompany": "Vyberte ordinaci"
    },
    "personalId": {
      "title": "Číslo pojištěnce",
      "helpText": "Slouží k ověření, že patříte k tomuto praktickému lékaři.",
      "errorText": "Číslo pojištěnce je povinný údaj, prosíme o vyplnění."
    },
    "checkedMyDoctor": "Potvrzuji, že jde o mého praktického lékaře",
    "thankYou": {
      "title": "Otázka bola odoslaná.",
      "perex": "Ďakujeme za položenie otázky, hneď ako bude zodpovedaná, dostanete upozornenie."
    }
  },
  "fileUpload": {
    "initial": "Kliknutím vyberte súbory alebo ich presuňte myšou.",
    "send": "Odoslať",
    "uploadAgain": "Skúste to znova.",
    "addFiles": "Priložte foto alebo lekárske správy.",
    "acceptedTypes": "Povolené typy sú obrázky (.jpg, .png). Maximálna povolená veľkosť súboru je 20 MB, maximálna povolená veľkosť všetkých súborov dohromady je 100 MB.",
    "typeError": "Tento typ súboru nie je podporovaný. Súbory nahrajte v uvedených formátoch .jpg, .png.",
    "sizeError": "Prekročená maximálna povolená veľkosť. Maximálna povolená veľkosť súboru je 20 MB, maximálna povolená veľkosť všetkých súborov dohromady je 100 MB.",
    "totalSizeError": "Maximálna veľkosť všetkých súborov je 100Mb"
  },
  "results": {
    "title": "Spojte se se svým praktickým lékařem",
    "resultInfoStart": "Na hledaný výraz",
    "resultInfoEnd": "bylo nalezeno {count} výsledků",
    "noResultInfoEnd": "nebyl nalezen žádný lékař",
    "noResultInfoPerex": "Zkontrolujte, že jste jméno lékaře zadali správně, případně můžete zkusit hledat méně konkrétně (např. dle křestního jména) a výsledky můžete v dalším kroku filtrovat podle lokality.",
    "startSearch": "Zadejte hledaný výraz",
    "moreResults": "Zobrazit další lékaře",
    "doctorNotInResults": "Můj praktický lékař není v seznamu",
    "filterInfo": "Výsledky vyhledávání můžete upřesnit zadáním <strong>lokality ordinace svého praktického lékaře</strong>",
    "filterDefaultText": "Celá Česká republika",
    "loadingInfo": "Vyhledávám...",
    "showAll": "Zobrazit všechny výsledky ({totalCount})"
  },
  "iDontHaveDoctor": {
    "title": "Nemáte praktického lékaře? Nevadí!",
    "perex": "Díky našim sponzorům můžete zdarma využít možnost vzdáleně řešit jakýkoli zdravotní problém s jedním z 350 lékařů týmu uLékaře.cz, kteří jsou připraveni vám pomoci.",
    "sendQuestion": "Položit dotaz našim lékařům"
  },
  "doctorIsNotInList": {
    "title": "Nenašli jste svého praktického lékaře v naší čekárně? Nevadí!",
    "sendQuestion": "Položit dotaz našim lékařům"
  },
  "virtualOffice": {
    "info": "Od 1.6. se budete moci podívat do své virtuální ordinace"
  },
  "footer": {
    "copyright": "&copy; 2007-{thisYear} uLékaře.cz, s.r.o.",
    "issn": "ISSN 1802-5544",
    "companyTitle": "Spoločnosť uLekára.sk",
    "companyList": [
      {
        "title": "Kontakt"
      },
      {
        "title": "Kariéra",
        "linkType": "external",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "Inzercia",
        "link": "https://www.ulekare.cz/inzerce",
        "linkType": "external",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "Zdravie a prevencia vo firme",
        "link": "index",
        "partnerLink": "forCompanies",
        "thematicCounsellingLink": "forCompanies",
        "target": "_blank",
        "forCompanies": "false",
        "aeskulab": "false"
      },
      {
        "title": "Zásady spracovania osobných údajov",
        "link": "personalDataProcessing",
        "partnerLink": "hrbPersonalDataProcessing",
        "thematicCounsellingLink": "thematicCounsellingPersonalDataProcessing",
        "forCompaniesLink": "forCompaniesPersonalDataProcessing",
        "aeskulabLink": "aeskuLabPersonalDataProcessing"
      },
      {
        "title": "Podmienky používania",
        "link": "termsAndConditions",
        "partnerLink": "hrbTermsAndConditions",
        "thematicCounsellingLink": "thematicCounsellingTermsAndConditions",
        "forCompaniesLink": "forCompaniesTermsAndConditions",
        "aeskulabLink": "aeskuLabTermsAndConditions"
      },
      {
        "title": "Prehlásenie o cookies",
        "link": "cookies",
        "partnerLink": "hrbCookies",
        "thematicCounsellingLink": "thematicCounsellingCookies",
        "forCompaniesLink": "forCompaniesCookies",
        "aeskulabLink": "aeskuLabCookies"
      }
    ],
    "perex": {
      "rsAssistant": "Největší česká medicínská online poradna a průkopník v oblasti telemedicíny si klade za cíl zefektivnit a zkvalitnit české zdravotnictví.<br/><br/>CZ2212160829/12/2022",
      "astmaHelp": "Největší česká medicínská online poradna a průkopník v oblasti telemedicíny si klade za cíl zefektivnit a zkvalitnit české zdravotnictví.",
      "default": "V uLékara.sk veríme, že zdravie je vaše. Prostredníctvom technológie, ľudského prístupu a lekárskej expertízy pomáhame ľuďom riadiť si svoje zdravie. Tím viac než 350 lekárov všetkých špecializácií každý mesiac vyrieši v priemere 15 000 požiadaviek. Klientská zóna je používateľom k dispozícii 24 hodín denne, 7 dní v týždni nielen na webe, ale aj v mobilnej aplikácii a ponúka online lekársku poradňu, odborné články a tipy pre zdravie, zdravotného sprievodca a kalendár preventívnych prehliadok a očkovaní.",
      "forCompanies": "uLékaře.cz věříme, že zdraví je vaše. Prostřednictvím technologie, lidského přístupu a lékařské expertízy pomáháme lidem řídit si své zdraví. Tým 350+ lékařů všech specializací je každý den k dispozici více než  100 tis. zaměstnanců."
    },
    "mottos": [
      "Lidskost",
      "Nadšení",
      "Odbornost",
      "Inovace"
    ]
  },
  "dataProcessing": {
    "iAgree": "Súhlasím so",
    "iAgreeWith": "Súhlasím s",
    "privacyPolicy": "spracovaním osobných údajov",
    "privacyPolicyTitle": "Súhlas so spracovaním osobných údajov vrátane osobitnej kategórie osobných údajov",
    "newsletterProcessing": "zasielaním noviniek a zliav uLekára.sk.",
    "newsletterText": "Súhlasím so zasielaním Spravodaja uLekára.sk (so správami o spoločnosti a projekte uLekára.sk, s.r.o., alebo o produktoch a službách spolupracujúcich tretích osôb). Súhlas so zasielaním odvoláte voľbou v Spravodajovi alebo na adrese <a href='mailto:osobniudaje@ulekare.cz'>osobniudaje@ulekare.cz</a>.",
    "conferenceNewsletterAgreement": "zasíláním sdělení týkajících se předmětu konference",
    "conferenceNewsletterTitle": "Súhlas so zasielaním informačných emailov(newsletterov)",
    "conferenceDataTitle": "Súhlasím so spracovaním osobných údajov",
    "termsConditions": "podmienkami používania",
    "privacyPolicyInAccordance": "Osobné údaje sú spracovávané v súlade so"
  },
  "termsAndConditions": {
    "title": "Podmienky používania"
  },
  "personalDataProcessing": {
    "title": "Súhlas so spracovaním osobných údajov"
  },
  "newsletter": {
    "title": "Súhlas so zasielaním marketingových oznámení"
  },
  "days": {
    "monday": "Po",
    "tuesday": "Út",
    "wednesday": "St",
    "thursday": "Čt",
    "friday": "Pá",
    "saturday": "So",
    "sunday": "Ne"
  },
  "error": {
    "400": "Chyba 400",
    "404": "Stránka nenalezena",
    "500": "Chyba 500",
    "universal": "Vyskytla sa chyba",
    "sms": "Aktuálna doba doručenia sms je maximálne 5&nbsp;minút. Ďakujeme za trpezlivosť."
  },
  "errorLayout": {
    "title": "Ups! Niekde sa stala chyba.",
    "text": "Ospravedlňujeme sa, služba je dočasne nedostupná. Na oprave pracujeme. Prosíme, skúste to neskôr.",
    "button": "Späť na hlavnú stránku"
  },
  "meta": {
    "partnerNavigation": {
      "title": "Partnerská navigácia"
    },
    "cookies": {
      "title": "Prohlášení o cookies"
    },
    "termsAndConditions": {
      "title": "Podmienky používania"
    },
    "personalDataProcessing": {
      "title": "Zásady spracovania osobných údajov"
    },
    "rsasistant": {
      "title": "RS asistent",
      "description": "Program nabízí praktickou podporu v léčbě a doplňkovou péči, různorodé informace k celkové podpoře zdraví a života se závažným autoimunitním onemocněním.",
      "ogTitle": "RS ASISTENT pomáhá pacientům s roztroušenou sklerózou"
    },
    "conference": {
      "title": "Zdravé firmy, zdravé Česko",
      "description": "Zveme vás na konferenci o firemním zdraví a prosperitě, zaměřenou na důležitost pohybu a jeho provázanost s psychickou i fyzickou pohodou. Doplňte své HR vitamíny a rozpohybujte firemní zdraví podporou každodenní prevence."
    },
    "emergency": {
      "title": "Kedy vyhľadať pohotovosť",
      "description": "Stručný soupis akutních nebo život ohrožujících stavů, na které chceme upozornit pacienty s cílem nasměrovat to nejurgentnější na pohotovost."
    },
    "evaluation": {
      "order": {
        "title": "Hodnocení návštěvy lékaře",
        "description": "Hodnocení návštěvy lékaře"
      }
    },
    "companies": {
      "title": "Zdraví a prevence ve firmě",
      "description": "Pomáháme s péčí o zdraví zaměstnanců. V naší online lékařské poradně mohou řešit své zdravotní potíže bezodkladně a odkudkoliv. V případě potřeby fyzické návštěvy lékaře každého objednáme na přesné místo i čas dle požadavků."
    },
    "mastercard": {
      "title": "Mastercard"
    },
    "eon": {
      "title": "E.ON"
    },
    "sporthelp": {
      "title": "SportHelp"
    },
    "overview": {
      "title": "Radíme, objednávame, pomáhame s prevenciou",
      "description": "Opýtajte sa našich lekárov na svoje zdravotné problémy alebo sa nechajte objednať k lekárovi. Pomôžeme vám so starostlivosťou o vaše zdravie. Online, zadarmo a kedykoľvek potrebujete."
    },
    "philips-sonicare": {
      "title": "Philips",
      "description": "Službu můžete mít zdarma jako benefit od svého zaměstnavatele, města, karetní společnosti, neziskové organizace a dalších firem. Pokud si nejste jistí, zkuste vyhledávač v záložce \"Jiný benefit\"."
    },
    "hrbOrderPage": {
      "title": "Objednáme vás k lekárovi",
      "description": "Hľadáte lekára, ktorý vás vyšetrí? Neviete, ku ktorému špecialistovi sa objednať? Nechajte to na nás. Objednávame k lekárom po celej ČR. Zadarmo a kedykoľvek potrebujete."
    },
    "hrbQuestionPage": {
      "title": "Opýtajte sa v našej online poradni",
      "description": "Zverte sa našim lekárom, do 6 hodín dostanete odpoveď na akúkoľvek vášu otázku týkajúcu sa fyzického aj duševného zdravia. Online, zadarmo a kedykoľvek potrebujete."
    },
    "hrbPreventionPage": {
      "title": "Prevencia",
      "description": "Pomáhame s prevenciou. Poraďte sa s našimi lekármi v otázkach starostlivosti o zdravie, získajte odporúčania týkajúce sa prevencie a objednajte sa na potrebné preventívne prehliadky."
    },
    "hrbArticlePagePrevention": {
      "title": "Prevence nebolí, prevence pomáhá",
      "description": "Preventivní prohlídky jsou velmi důležité, mohou dokonce zachránit život. Zaregistrujete se do našeho preventivního programu a pečujte tak lépe o své zdraví."
    },
    "hrbArticlePageInsuranceCompanies": {
      "title": "Zdravotní pojišťovny a prevence",
      "description": "Co vám v rámci prevence v letošním roce hradí vaše zdravotní pojišťovna? Máme pro vás přehlednou nabídku všech pojišťoven včetně výše příspěvků."
    },
    "hrbArticlePageVyzkousejteSiNas": {
      "title": "Vyzkoušejte si nás"
    },
    "vozpRegistration": {
      "title": "VoZP",
      "description": "Zaregistrujte se prostřednictvím online formuláře a neomezeně využívejte služby uLékaře.cz: poradnu, objednání k lékaři a pomoc s prevencí. Pro klienty VoZP je služba na 3 měsíce zdarma."
    },
    "migraine": {
      "title": "Linka o migréně"
    },
    "psoriasis": {
      "title": "Jak vyzrát na lupénku"
    },
    "putinSucks": {
      "title": "Bezplatná lékařská poradna pro Ukrajince",
      "description": "Pomáháme Ukrajině. Poradíme a objednáme po celé České republice. Lékaři a sestry hovoří ukrajinsky a rusky."
    },
    "astmaHelp": {
      "title": "Pacientský program AstmaHelp",
      "description": "Registrovaným pacientům AstmaHelp nabízí podporu v léčbě a neomezený přístup do specializované online poradny."
    },
    "login": {
      "title": "Prihlásenie",
      "description": "Registrujte sa a majte na dosah ruky viac ako 350 lekárov všetkých špecializácií. Pomôžeme vám s objednaním k lekárovi po celej ČR. Zdravie je vaše."
    },
    "aeskulab": {
      "title": "Moje laboratórne výsledky",
      "description": "Získate interpretáciu vyšetrenia absolvovanú v laboratóriu Unilabs"
    },
    "dashboard": {
      "title": "Zdravie online"
    },
    "dashboardQuestions": {
      "title": "Poradňa"
    },
    "dashboardAppointments": {
      "title": "Sprievodca zdravím"
    },
    "dashboardArticles": {
      "title": "Magazín Objavujte"
    },
    "dashboardConsultations": {
      "title": "Zodpovedané lékarmi"
    },
    "dashboardPrevention": {
      "title": "Moja prevencia"
    },
    "dashboardProfile": {
      "title": "Môj zdravotný profil"
    },
    "lostPassword": {
      "title": "Zabudnuté heslo"
    },
    "passwordReset": {
      "title": "Obnovenie hesla"
    },
    "emailVerification": {
      "title": "Overenie e-mailu"
    },
    "registration": {
      "title": "Registrácia"
    },
    "homepage": {
      "title": "uLekára.sk - Zdraví zamestnanci. Od hlavy až po päty.",
      "description": "Vytvárame tie najzdravšie pracovné prostredia po celom svete a poskytujeme špičkovú starostlivosť o zdravie riadenú údajmi. Pomáhame firmám dlhodobo a systematicky udržiavať zdravie ich zamestnancov."
    },
    "servicePage": {
      "title": "Služba uLekára.sk"
    },
    "ePrescription": {
      "title": "Ako funguje vystavenie eReceptu v uLekára.sk",
      "description": "Pravidlá pre e-recept…"
    }
  },
  "rsAssistant": {
    "projectPartner": "Partner projektu",
    "hello": {
      "title": "Váš <strong>RS ASISTENT</strong>",
      "perex": "Vítejte na stránce programu <strong>RS ASISTENT</strong>, který vám nabízí doplňkovou péči a praktickou podporu v nové léčbě Vašeho onemocnění. Program zahrnuje pravidelná SMS a telefonická připomenutí užití léku a možnost objednání u fyzioterapeuta a psychologa. Dále nabízí různorodé informace k celkové podpoře Vašeho zdraví a života s onemocněním na <a href='https://www.zivotvhlavniroli.cz' target='_blank'>pacientském webu</a>.<br/><br/>Registrovat se do programu můžete prostřednictvím online formuláře na této stránce. Pokud s jeho vyplněním potřebujete pomoci nebo máte jakékoliv dotazy související s registrací, pomůžeme vám na tel. <a href='tel:00420227072722'>227 072 722</a> či na e-mailu <a href='mailto:rs-asistent@ulekare.cz'>rs-asistent@ulekare.cz</a>.",
      "imgTitle": "Sestra Novartis"
    },
    "scrollToRegistration": "Přejít na registraci do programu",
    "registerForm": {
      "title": "Registrace do programu",
      "checkTitle": "Jakou léčbou vás budeme provázet? (Výběr léku)",
      "formTitle": "Vyplňte své kontaktní údaje",
      "send": "Odeslat",
      "sendTitle": "Registrace do programu RS ASISTENT proběhla úspěšně",
      "sendPerex": "Těší nás Vaše registrace do podpůrného programu RS ASISTENT.<br/>Vyčkejte na telefonát zdravotní sestřičky, která s vámi domluví podrobnosti související s nastavením programu na míru Vašim potřebám.",
      "sendNextmessage": "Poslat novou zprávu",
      "firstName": {
        "title": "Jméno",
        "errorText": "Jméno je povinné, prosím, vyplňte ho."
      },
      "lastName": {
        "title": "Příjmení",
        "errorText": "Příjmení je povinné, prosím, vyplňte ho."
      },
      "email": {
        "title": "E-mail",
        "errorText": "E-mail je povinný, prosím, vyplňte ho.",
        "errorEmailText": "E-mail nemá správný formát.",
        "errorEmailNotExisting": "Prosím vyplňte existující e-mail."
      },
      "phone": {
        "title": "Telefon",
        "errorText": "Telefonní číslo je povinné, prosím, vyplňte ho.",
        "errorPhoneText": "Zadejte telefonní číslo (+420 123456789)."
      },
      "birthYear": {
        "title": "Rok narození",
        "titleRegistered": "Rok narození pacienta",
        "errorText": "Rok narození je povinný, prosím, vyplňte ho.",
        "errorLengthText": "Rok narození napište v čtyřčíselném formátu.",
        "errorBetweenText": "Napište skutečný rok narození."
      },
      "zipCode": {
        "title": "PSČ",
        "errorText": "PSČ je povinné, prosím, vyplňte ho.",
        "errorZipCodeText": "PSČ nemá správný formát."
      },
      "treatmentCenter": {
        "title": "Ve kterém MS centru pro diagnostiku a léčbu roztroušené sklerózy se aktuálně léčíte?",
        "selectMsCentrum": "Vyberte centrum",
        "errorText": "Tato položka je vyžadována"
      },
      "medication": {
        "mayzent": "Mayzent",
        "gilenya": "Gilenya",
        "kesimpta": "Kesimpta",
        "errorText": "Tato položka je vyžadována"
      },
      "medicationCheckBox": "Potvrzuji, že mě budete provázet léčbou přípravkem Kesimpta"
    },
    "dataProcessing": {
      "iAgree": "Zaškrtnutím tohoto políčka souhlasíte",
      "iAgreePersonal": "Souhlasím se zpracováním mých osobních údajů, a to včetně zvláštní kategorie údajů o zdravotním stavu tak, jak je uvedeno v ",
      "personalDataProcessing": "Zásadách zpracování osobních údajů",
      "personalDataTitle": "Zaškrtnutím tohoto políčka souhlasíte s podmínkami užití služby RS Asistent.",
      "personalDataText": "Správce zpracovává osobní údaje uživatelů, a to včetně údajů zvláštní kategorie, které mu uživatelé sdělí, pro účely využití služby uLékaře.cz (jak je popsána na webu ulekare.cz či v mobilní aplikaci a v souladu s Podmínkami užití, které naleznete zde. \nZpracování osobních údajů uživatelů probíhá vždy a pouze na základě uděleného souhlasu se zpracováním osobních údajů (včetně zpracování údajů zvláštní kategorie), jehož text naleznete zde a který je udělován uživatelem (subjektem údajů) při registraci do služby uLékaře.cz.",
      "conditionsAgreement": "s podmínkami užití služby RS Asistent",
      "modalTitle": "Souhlasím s podmínkami užití služby RS Asistent"
    },
    "personalModal": {
      "modalTitle": "Souhlasím se zpracováním osobních údajů služby RS Asistent"
    },
    "alertInfo": "Vše, co potřebujete vědět o programu RS ASISTENT, se <a href='https://www.ulekare.cz/media/rs_asistent_letak_new_2023.pdf' target='_blank'>dočtete zde</a>.",
    "formInfo": "\"SMS připomínka\" užití léků je služba pouze informačního charakteru. Prosím, berte na vědomí, že pro užívání léků jsou zásadní a rozhodující informace, které jste obdržel od svého lékaře nebo lékárníka. Poskytovatel služby \"SMS připomínka\" nenese odpovědnost za stav vašeho telefonu nebo signálu pro příjem sms zpráv.",
    "willCloseRegistration": "Program “RS Asistent” bude ukončen 31. 12. 2023, od 1.10. se již nebude možné do programu registrovat.",
    "willClose": "Program “RS Asistent” bude ukončen 31. 12. 2023, od 1.10. se již není možné do programu registrovat."
  },
  "astmaHelp": {
    "closed": {
      "title": "Registrace do programu AstmaHelp byla ukončena",
      "text": "Registrace do pacientského programu AstmaHelp byla ukončena k 31.&nbsp;5.&nbsp;2022. Pokud se chcete poradit o svém zdravotním stavu s lékařem, můžete navštívit"
    },
    "projectPartner": "Partner projektu:",
    "hello": {
      "title": "AstmaHelp",
      "subTitle": "Vítejte na stránce programu",
      "perex": "Rádi bychom vám usnadnili léčbu a přispěli k vašemu plnohodnotnému životu s astmatem. Prostřednictvím pravidelných SMS a telefonických připomenutí vám pomůžeme v nastavení léčby. V naší specializované lékařské poradně se můžete zkušených odborníků neomezeně ptát na své zdraví.\nZaregistrovat se do programu můžete prostřednictvím online formuláře na této stránce. Potřebujete-li s registrací pomoci, volejte na tel.&nbsp;<a href='tel:00420800800281'>+420&nbsp;800&nbsp;800&nbsp;281</a> nebo nám napište na <a href='mailto:astmahelp@ulekare.cz'>astmahelp@ulekare.cz</a>.",
      "imgTitle": "Sestra Novartis",
      "bottomText": "Chcete o programu AstmaHelp vědět víc? <a href='https://www.ulekare.cz/media/astmahelp_letak_1.pdf' target='_blank'>Přečtěte si podrobnosti</a>"
    },
    "scrollToRegistration": "Přejít na registraci do programu",
    "registerForm": {
      "title": "Registrace do programu",
      "checkTitle": "Jakou léčbou vás budeme provázet? (Výběr léku)",
      "formTitle": "Vyplňte své kontaktní údaje",
      "send": "Odeslat",
      "sendTitle": "Registrace do programu RS ASISTENT proběhla úspěšně",
      "sendPerex": "Těší nás Vaše registrace do podpůrného programu RS ASISTENT.<br/>Vyčkejte na telefonát zdravotní sestřičky, která s vámi domluví podrobnosti související s nastavením programu na míru Vašim potřebám.",
      "sendNextmessage": "Poslat novou zprávu",
      "firstName": {
        "title": "Jméno",
        "errorText": "Jméno je povinné, prosím, vyplňte ho."
      },
      "lastName": {
        "title": "Příjmení",
        "errorText": "Příjmení je povinné, prosím, vyplňte ho."
      },
      "email": {
        "title": "E-mail",
        "errorText": "E-mail je povinný, prosím, vyplňte ho.",
        "errorEmailText": "E-mail nemá správný formát.",
        "errorEmailNotExisting": "Prosím vyplňte existující e-mail."
      },
      "phone": {
        "title": "Telefon",
        "errorText": "Telefonní číslo je povinné, prosím, vyplňte ho.",
        "errorPhoneText": "Zadejte telefonní číslo (+420 123456789)."
      }
    },
    "dataProcessing": {
      "iAgree": "Zaškrtnutím tohoto políčka souhlasíte",
      "iAgreePersonalPrefix": "Souhlasím se zpracováním mých osobních údajů správcem AstraZeneca Czech Republic s.r.o. za účelem zajištění SMS připomínky a vybraných elektronických informací o ASTMAHELP, a to včetně zvláštní kategorie údajů o zdravotním stavu tak, jak je uvedeno v",
      "personalDataProcessing": "Oznámení o ochraně osobních údajů",
      "iAgreePersonalSuffix": "Souhlasím s předáním osobních údajů společnosti MeDitorial, s.r.o. za účelem zajištění bezplatných konzultací a podpory „uLékaře.cz“. <strong class='text-underline'>Mám právo kdykoliv odvolat souhlas či podat námitky proti provádění přímého marketingu</strong>.",
      "personalDataTitle": "Zaškrtnutím tohoto políčka souhlasíte s podmínkami užití služby RS Asistent.",
      "personalDataText": "Správce zpracovává osobní údaje uživatelů, a to včetně údajů zvláštní kategorie, které mu uživatelé sdělí, pro účely využití služby uLékaře.cz (jak je popsána na webu ulekare.cz či v mobilní aplikaci a v souladu s Podmínkami užití, které naleznete zde. \nZpracování osobních údajů uživatelů probíhá vždy a pouze na základě uděleného souhlasu se zpracováním osobních údajů (včetně zpracování údajů zvláštní kategorie), jehož text naleznete zde a který je udělován uživatelem (subjektem údajů) při registraci do služby uLékaře.cz.",
      "iAgreeConditionsPrefix": "Prohlašuji, že jsem se seznámil(a) se všemi dokumenty a souhlasím s",
      "conditionsAgreement": "Podmínkami",
      "iAgreeConditionsSuffix": "služby „uLékaře.cz“.",
      "modalTitle": "Souhlasím s podmínkami užití služby AstmaHelp"
    },
    "personalModal": {
      "modalTitle": "Oznámení o ochraně osobních údajů AstmaHelp"
    },
    "alertInfo": "Chcete o programu AstmaHelp vědět víc? <a class='text-underline' href='#'>Přečtěte si podrobnosti</a>",
    "formInfo": "\"SMS připomínka\" užití léků je služba pouze informačního charakteru. Prosím, berte na vědomí, že pro užívání léků jsou zásadní a rozhodující informace, které jste obdržel od svého lékaře nebo lékárníka. Poskytovatel služby \"SMS připomínka\" nenese odpovědnost za stav vašeho telefonu nebo signálu pro příjem sms zpráv."
  },
  "companies": {
    "menu": {
      "ourService": "Naše služba",
      "stories": "Říkají o nás",
      "pricing": "Ceník",
      "faq": "FAQ",
      "iWant": "Chci zdraví do firmy"
    },
    "hero": {
      "title": "Zdraví je business každé firmy",
      "subtitle": "Originální služba pro zaměstnance, která vašim kolegům výrazně zjednoduší péči o zdraví, a ušetří tak čas jim i vaší firmě.",
      "buttons": {
        "iWant": "Chci zdraví do firmy",
        "ourService": "Naše služba"
      },
      "items": [
        {
          "icon": "$checkCircle",
          "iconColor": "white",
          "text": "Poradíme vašim zaměstnancům v otázkách zdraví."
        },
        {
          "icon": "$checkCircle",
          "iconColor": "white",
          "text": "Zařídíme objednání k lékaři, kamkoliv."
        },
        {
          "icon": "$checkCircle",
          "iconColor": "white",
          "text": "Pečujeme o váš život ve zdraví - prevencí."
        }
      ]
    },
    "partnersCarousel": {
      "title": "Důvěřují nám malí i velcí",
      "subtitle": "+ více než 150 dalších"
    },
    "companyPresentation": {
      "title": "Naše služba ",
      "benefitList": [
        {
          "icon": "doctor",
          "title": "350+ lékařů všech specializací"
        },
        {
          "icon": "rodina",
          "title": "Péče pro celou rodinu"
        },
        {
          "icon": "clock",
          "title": "Máme více než 14&nbsp;let zkušeností"
        },
        {
          "icon": "phone",
          "title": "Pohodlně i&nbsp;v&nbsp;mobilní aplikaci"
        },
        {
          "icon": "globus",
          "title": "Vše je dostupné i&nbsp;v&nbsp;angličtině"
        }
      ],
      "boxContent": [
        {
          "image": "company_box_2.jpg",
          "text": "Na dotaz zaměstnance odpoví praktický lékař pro dospělé, nebo pediatr."
        },
        {
          "image": "company_box_1.jpg",
          "text": "Zaměstnanci zajistíme také vyjádření specialisty kteréhokoliv oboru, například dermatologie, ortopedie, gynekologie, či psychologie."
        },
        {
          "image": "company_box_3.jpg",
          "text": "Doporučí-li lékař zaměstnanci osobní návštěvu, náš zdravotní tým se o vše potřebné postará. Místo a čas objednání se odvíjí od preference zaměstnance."
        },
        {
          "image": "company_box_4.jpg",
          "text": "V rámci naší služby zajistíme preventivní prohlídky a přednášky ve vaší firmě. Připravíme materiály pro vaši interní komunikaci na téma zdraví."
        }
      ],
      "infoBox": {
        "title": "Věděli jste, že...",
        "text": "Zaměstnanec se s naší službou v téměř 40% případů vyhne cestě k lékaři? Většinu zdravotních otázek vyřeší ve své klientské zóně a o vše ostatní se postaráme."
      }
    },
    "billing": {
      "title": "Přehled balíčků a cena",
      "companySize": "Velikost firmy",
      "employees": "zaměstnanců",
      "star": "*Pro firmy o velikosti 40 - 50 zaměstnanců. Účtováno měsíčně.",
      "content": "Obsah balíčků",
      "tariffsMatrix": {
        "title": "Obsah",
        "pricing": {
          "title": "Ceny",
          "subtitleFirstLine": "Pro firmy o velikosti {companySize}.",
          "subtitleSecondLine": "Účtováno měsíčně.",
          "perEmployee": "za zaměstnance",
          "currency": "Kč"
        },
        "rows": [
          {
            "title": "Platforma uLékaře.cz 24/7",
            "subtitle": "Klientská zóna a péče zdravotního týmu",
            "basic": "true",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Názor praktického lékaře či pediatra",
            "subtitle": "Lékař odpoví do 6h",
            "basic": "true",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Názor specialisty",
            "subtitle": "Specialista odpoví do 48h",
            "basic": "false",
            "premium": "Pouze po vyžádání praktickým lékařem",
            "exclusive": "true"
          },
          {
            "title": "Objednání na doporučení lékaře",
            "subtitle": "Sestřička volá do následujícího pracovního dne",
            "basic": "false",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Objednání na vlastní žádost",
            "subtitle": "Sestřička volá do následujícího pracovního dne",
            "basic": "false",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Kontakty na zdravotnická zařízení",
            "subtitle": "V případě, že se chcete objednat sám",
            "basic": "false",
            "premium": "false",
            "exclusive": "true"
          },
          {
            "title": "Prevence",
            "subtitle": "Preventivní profil, kalendář prohlídek, preventivní tipy e-mailem, tematické preventivní poradny",
            "basic": "true",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Sdílení služby s rodinou",
            "basic": "Dotaz na jinou osobu",
            "premium": "Dotaz na jinou osobu",
            "exclusive": "true"
          },
          {
            "title": "Webchat se zákaznickou péčí",
            "basic": "true",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Dedikovaný corporate care tým",
            "basic": "true",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Implementace služby do firmy",
            "basic": "true",
            "premium": "true",
            "exclusive": "true"
          },
          {
            "title": "Pravidelný reporting",
            "basic": "true",
            "premium": "true",
            "exclusive": "true"
          }
        ]
      },
      "basic": {
        "title": "Basic",
        "subtitle": "Lékař vždy po ruce"
      },
      "premium": {
        "title": "Premium",
        "subtitle": "Specialista a objednání"
      },
      "exclusive": {
        "title": "Exclusive",
        "subtitle": "Kompletní péče uLékaře.cz"
      },
      "individualPricing": {
        "title": "Pro firmu Vaší velikosti máme individuální ceník",
        "perex": "Vše s vámi rád probere náš obchodní konzultant Martin Čuba.",
        "interested": "Mám zájem"
      },
      "try": "Vyzkoušet 30 dní zdarma",
      "tryShort": "Vyzkoušet"
    },
    "faq": {
      "title": "Často kladené otázky",
      "faqList": [
        {
          "title": "Co přinese uLékaře.cz firmě?",
          "bodyText": "Víme, že firmám se péče o zdraví jejich zaměstnanců vyplácí. Šetří čas, zajišťuje přítomnost zaměstnanců na pracovišti a jejich lepší soustředěnost i výkonnost. S naší službou si zaměstnanec může v rámci online lékařské poradny vše vyřídit rychle odkudkoliv, a když potřebuje fyzickou návštěvu, k lékaři ho objednáme na jím vybrané místo i čas. <br/><br/>Zaměstnanci dokážeme poradit na dálku, navíc není mnohdy nutná návštěva lékaře, ani zdlouhavé vyhledávání informací na internetu. Šetříme tak zaměstnavateli náklady, které by musel jinak vynaložit za čas, kdy zaměstnanec nepracuje, nebo z důvodu jeho nepřítomnosti musí být zajištěna jeho náhrada. <br/><br/>Nemocem je nejlepší předcházet, proto zajišťujeme také komplexní preventivní program a Dny zdraví."
        },
        {
          "title": "Co přinese uLékaře.cz zaměstnancům?",
          "bodyText": "Služba uLékaře.cz přináší pro uživatele mnoho benefitů. Registrací získají 350 lékařů všech specializací na dosah ruky, včetně pediatrů a praktických lékařů. Jsou připraveni pomoci s rychlou orientací ve zdravotním problému, který právě řeší zaměstnanec nebo jeho blízcí. V našem týmu máme také 50 zdravotních sestřiček na telefonu pro pomoc s vyhledáním nového lékaře či odborníka ve vyhovujícím čase a lokalitě. V komunikaci se zaměstnanci setkají s profesionálním, diskrétním a lidským přístupem celého zdravotního týmu. Komunikovat mohou v českém, nebo anglickém jazyce."
        },
        {
          "title": "Jak službu uLékaře.cz pro zaměstnance objednat?",
          "bodyText": "Pokud máte méně než 100 zaměstnanců, můžete si službu do firmy objednat online. Pro firmy s větším počtem zaměstnanců je tu naše obchodní oddělení. Rádi vám připravíme cenovou nabídku."
        },
        {
          "title": "Vztahuje se na službu daňové zvýhodnění?",
          "bodyText": "Služba uLékaře.cz je daňově uznatelným nákladem ve smyslu Zákona č. 586/1922 Sb. o daních z příjmů, protože slouží k zajištění a udržení zdanitelných příjmů, a to formou úspory mzdových nákladů za zaměstnance."
        },
        {
          "title": "Jak je zajištěna bezpečnost služby?",
          "bodyText": "Uživatelé služby uLékaře.cz využívají ve své klientské zóně, která je šifrovaná a tedy vše okolo otázek kolem zdraví vidí pouze oni sami a lékař, se kterým konkrétní dotaz řeší. Zároveň splňujeme veškeré legislativní požadavky o Obecném nařízení EU 2016/679 o ochraně osobních údajů (GDPR) a získali jsme certifikaci ISO/IEC 27001 pro oblast řízení bezpečnosti informací. <br/><br/>Všechny požadavky jsou řešeny pouze mezi vámi a příslušnými osobami z týmu uLékaře.cz, případně vámi zvoleným zdravotnickým zařízením. Dokonce i lékař, který vám odpovídá, vidí kromě vašeho dotazu jen vaše křestní jméno a věk. K dalším informacím uvedeným v rámci vašeho požadavku má přístup jenom náš vlastní zdravotnický tým, jenž vám pomáhá s objednáním nebo dalším zpracováním dotazu. Záznamy o vaší péči nejsou dále s nikým sdíleny."
        },
        {
          "title": "Musí zaměstnanci pro registraci do služby uLékaře.cz změnit svého praktického lékaře?",
          "bodyText": "Registrací do naší služby neměníte svého praktického lékaře. Lékaři v naší poradně odpoví na každý požadavek a v případě zájmu zaměstnance k lékaři objednáme."
        },
        {
          "title": "Může služba zkrátit čekací lhůtu vyšetření, které jsou obvykle velmi dlouhé?",
          "bodyText": "Rychlost objednání vždy závisí na vytížení systému zdravotnictví. Záleží na lokalitě a kapacitách lokální lékařské péče. Často jsme schopni požadované vyšetření zařídit v kratší lhůtě než té, kterou byste získali při objednávání vy sami. Objednáváme totiž do všech zdravotních zařízení, státních i soukromých, a máme velmi dobře zmapované aktuální kapacity lékařů a čekací lhůty po celé České republice."
        },
        {
          "title": "Budou zaměstnanci platit lékaři, ke kterému je objednáváte?",
          "bodyText": "Rozhodnutí je na vás. Naše sestřičky vás mohou objednat jak do státních, tak i soukromých zdravotnických zařízení. Snaží se vždy najít toho nejvhodnějšího lékaře s ohledem na termín návštěvy a dostupnost lékařů dané odbornosti, vše podle vašich preferencí. O případné platbě vás informujeme před návštěvou lékaře."
        },
        {
          "title": "Zajišťuje služba uLékaře.cz vystavení eRecept?",
          "bodyText": "Když lékař určí z vašeho dotazu, že je potřeba předepsat léky, zprostředkujeme eRecept. Předtím vám ještě zavolá zdravotní sestřička, která ověří váš aktuální stav a zájem."
        },
        {
          "title": "Můžu službu zařídit i pro výrobní firmu?",
          "bodyText": "Ano, můžete. Naše služba je určena pro všechny zaměstnance, bez rozdílu předmětu podnikání nebo pracovního zařazení. Mezi našimi klienti jsou jak banky, tak výrobní firmy, jako například Continental, Unipetrol, Cemex, Metrans, MND, Ideal Standard, Lasvit, a mnoho dalších."
        },
        {
          "title": "Lze službu nabídnout jen určité skupině zaměstnanců?",
          "bodyText": "Zakládáme si na tom, že naše péče je pro každého. Naší vizí je dostupnost naší péče pro všechny. Víme, že pomáháme všem bez rozdílu, ať už se jedná o manuální pracovníky, nebo kancelářské profese. Proto nabízíme naší službu vždy jen jako benefit pro celou firmu."
        },
        {
          "title": "Jaké množství práce musí personalisté pravidelně vynaložit, aby byla služba zaměstnanci využívaná?",
          "bodyText": "Minimální. Po zakoupení služby je klíčové informování zaměstnanců o dostupnosti služby a navedení k registraci, aby měli službu kdykoliv po ruce. Je možné využít námi připravené komunikační materiály. Se zaměstnanci registrovanými do klientské zóny už komunikujeme napřímo."
        },
        {
          "title": "Jak se dozvím, že zaměstnanci službu využívají?",
          "bodyText": "Z pravidelného reportingu, který od nás obdržíte. Jeho součástí je počet zaměstnanců registrovaných do služby, počet využití jednotlivých služeb, ale i nejčastější specializace nebo regionální využití. Vše je samozřejmě plně anonymizováno."
        },
        {
          "title": "Jak probíhá platba?",
          "bodyText": "Platit za službu začínáte po podpisu smlouvy. Fakturu vám budeme pravidelně zasílat dle domluvené frekvence."
        },
        {
          "title": "Je možné změnit balíček objednaných služeb?",
          "bodyText": "Ano, balíček můžete změnit kdykoliv prostřednictvím <a href=\"mailto:zdravi@ulekare.cz\">zdravi@ulekare.cz</a>. Náš corporate care tým se postará o vše potřebné."
        },
        {
          "title": "Jak je to s výpovědí smlouvy?",
          "bodyText": "Smlouva se uzavírá na dobu neurčitou s výpovědní dobou jeden měsíc."
        }
      ]
    },
    "letsTalk": {
      "title": "Chci zdraví a prevenci do firmy",
      "subtitle": "Zanechte na sebe kontakt, ozveme se vám co nejdříve."
    },
    "contactForm": {
      "title": "Nezávazná poptávka služby uLékaře.cz",
      "thankYou": {
        "title": "Vaši poptávku jsme přijali. Děkujeme.",
        "text": "Velmi nás těší váš zájem o naše služby. Do dvou pracovních dní se vám ozve náš obchodní konzultant a probere s vámi detaily."
      },
      "contact": {
        "name": "Martin Čuba",
        "position": "Head of Sales",
        "email": "partner@ulekare.cz",
        "phone": "+420&nbsp;603&nbsp;841&nbsp;995"
      },
      "companyName": {
        "title": "Název společnosti",
        "errorText": "Název společnosti je povinný, prosím, vyplňte ho."
      },
      "companyEmployees": {
        "title": "Počet zaměstnanců Vaší firmy",
        "errorText": "Počet zaměstnanců je povinný, prosím, vyplňte ho.",
        "badFormatError": "Počet zaměstnanců musí být číslo.",
        "minValueError": "Minimální počet zaměstnanců je 5."
      },
      "send": "Odeslat",
      "sendTitle": "Ozveme se vám co nejdříve.",
      "sendPerex": "Děkujeme vám za projevený zájem o službu Zdraví a prevence ve firmě pro Vaše zaměstnance."
    },
    "orderForm": {
      "title": "Fakturační údaje",
      "sendOrder": "Odeslat objednávku",
      "sendRequest": "Odeslat poptávku",
      "companyName": {
        "title": "Název firmy",
        "placeholder": "Vaše firma s.r.o.",
        "errorText": "Název firmy je povinný, prosím, vyplňte ho."
      },
      "ico": {
        "title": "IČO",
        "placeholder": "1234567890",
        "errorText": "Údaj IČO je povinný, prosím, vyplňte ho."
      },
      "fullName": {
        "title": "Kontaktní osoba",
        "placeholder": "Jan Zdravý",
        "errorText": "Údaj o kontaktní osobě je povinný, prosím, vyplňte ho."
      },
      "email": {
        "label": "Pracovní e-mail",
        "placeholder": "firemni@mail.cz"
      },
      "termsConds": "obchodními podmínkami",
      "thankYou": {
        "title": "Přijali jsme vaši objednávku. Děkujeme.",
        "back": "Zpět na Hlavní stránku",
        "message": {
          "title": "Martin Pospíšil, CEO uLékaře.cz",
          "name": "Martin Pospíšil",
          "welcome": "Vítejte v komunitě zdravých firem!",
          "subtitle": "Od teď můžete všechno ohledně zdraví nechat na nás. Co bude následovat?",
          "items": [
            {
              "icon": "$checkCircle",
              "iconColor": "success",
              "text": "Na e-mail jsme vám zaslali rekapitulaci vaší objednávky"
            },
            {
              "icon": "$checkCircle",
              "iconColor": "success",
              "text": "Nejpozději do dvou pracovních dnů obdržíte smlouvu a autorizační kód spolu s pokyny pro přístup ke službě uLékaře.cz"
            },
            {
              "icon": "$checkCircle",
              "iconColor": "success",
              "text": "Před uplynutím 30 denní zkušební doby vám pošleme fakturu k úhradě služby na další měsíc."
            },
            {
              "imgType": "icon",
              "icon": "$checkCircle",
              "iconColor": "success",
              "text": "Pokud z nějakého důvodu nebudete s naší službou spokojeni, fakturu jednoduše neplaťte. "
            }
          ]
        }
      }
    },
    "disclaimer": "V tomto formuláři není možné položit dotaz nebo se objednat k lékaři.",
    "stories": [
      {
        "name": "Karolína Kašparová",
        "position": "Head of Operations, Bridgewater",
        "image": "karolina_kasparova.jpeg",
        "perex": "uLékaře.cz nám umožňuje kdykoliv se poradit s lékařem o zdravotním problému, a to nejen vlastním, ale kohokoliv z rodiny. Služba funguje 24 hodin denně, může být anonymní a umí rychle propojit s nejbližším lékařem a domluvit osobní konzultaci. Bez zbytečného trápení v čekárně. Děkujeme."
      },
      {
        "name": "Radka Pučelíková",
        "position": "HR manager, Aimtec",
        "image": "radka_pucelikova.png",
        "perex": "Službu jsme zavedli jako benefit 9. 10. 2018 pro všech 185 zaměstnanců. Oceňujeme, že šetří čas, řeší zdravotní komplikace našich zaměstnanců (i v zahraničí), dokáže vyhledat specialistu, učí preventivnímu chování či pečuje o rodiny zaměstnanců. Máme radost, že tuto službu už docenili i mladí lidé, kteří ji zpočátku považovali s ohledem na svůj věk a zdraví nadbytečnou."
      },
      {
        "name": "Scott Marlowe",
        "position": "HR Director, Česká Spořitelna",
        "image": "scott_marlowe.png",
        "perex": "Zdraví našich zaměstnanců je pro nás vždy důležité téma. Od dubna 2020 nabízíme našim zaměstnancům a jejich blízkým služby uLékaře.cz – 24hodinové online lékařské poradny a možnosti objednat se k lékaři bez nutnosti osobní návštěvy a dlouhé čekací doby. Doporučujeme!"
      }
    ]
  },
  "companiesOrder": {
    "headerText": "Krok {currentStep}/2",
    "firstStep": {
      "title": "Výběr balíčku",
      "subtitle": "uLékaře.cz máte 30 dní zdarma a zcela bez závazků.",
      "back": "Zpět na zdraví ve firmě",
      "testimony": {
        "name": "Karolína Kašparová",
        "position": "Head of operations, Bridgewater",
        "text": "“uLékaře.cz nám umožňuje kdykoli se poradit s lékařem o zdravotním problému, a to nejen vlastním, ale i kohokoliv z rodiny. Služba funguje 24 hodin denně, může být anonymní a umí rychle propojit s nejbližším lékařem a domluvit osobní konzultaci. Bez zbytečného trápení v čekárně. Děkujeme.”"
      },
      "orderSummary": {
        "tariff": "Balíček",
        "price": "Cena: <strong>{price} Kč</strong> za zaměstnance na měsíc",
        "finalPrice": "Celkové měsíční náklady pro {companyEmployees} zaměstnanců: {finalPrice} Kč",
        "star": "Ceny jsou uvedeny bez DPH"
      },
      "setup": {
        "companyTitle": "Velikost firmy",
        "tariffTitle": "Zvolte si balíček",
        "tariffSubTitle": "Cena platí pro jednoho zaměstance. Účtováno měsíčně.",
        "familyTitle": "Rodinné sdílení",
        "familySubTitle": "Sdílené účty pro rodinu zaměstnance",
        "nothing": "Nic",
        "family": {
          "title": "Rodinné sdílení",
          "subTitle": "+{price} Kč/zaměstnanec"
        },
        "fastReplyTitle": "Přednostní odpovědi",
        "fastReplySubTitle": "Praktický lékař do 3h",
        "fastReplyPremiumSubTitle": "lékař specialista do 24h",
        "fastReply": {
          "title": "Přednostní odpověď",
          "subTitle": "+{price} Kč/zaměstnanec"
        },
        "nextButton": "Pokračovat k objednání",
        "tariffs": {
          "basic": {
            "title": "Basic",
            "subTitle": "Lékař vždy po ruce"
          },
          "premium": {
            "title": "Premium",
            "subTitle": "Specialista a objednání"
          },
          "exclusive": {
            "title": "Exclusive",
            "subTitle": "Kompletní péče uLékaře.cz "
          }
        }
      },
      "formTitle": "Pro firmu vaší velikosti máme individuální ceník",
      "formPerex": "Vše s vámi rád probere náš obchodní konzultant Martin."
    },
    "secondStep": {
      "title": "Objednávka služby uLékaře.cz",
      "back": "Zpět na Výběr balíčku",
      "summary": {
        "topText": "Vaše cena po 30 denním zkušebním období"
      },
      "disclaimer": {
        "title": "We speak English!",
        "subtitle": "Are you interested in our service but your employees don’t speak Czech? <strong>No worries!</strong> <br/><br/>We offer uLékaře.cz in English as well. Please contact us at <a href=\"mailto:partner@ulekare.cz\" class=\"link--inline\">partner@ulekare.cz</a> for more information."
      }
    }
  },
  "conference": {
    "figureAlt": "HRajeme dál je aktivita, ktorá pomáha začleniť starostlivosť o zdravie a prevenciu medzi základné firemné stratégie.",
    "hrajemeDal092020": {
      "hello": {
        "title": "HRajeme dál",
        "perex": "Když se daří zaměstnancům, daří se firmě jako celku. Děkujeme za to, že se stáváte ambasadory „zdraví ve vlastních rukou“. Máme radost, že vás téma zajímá, a&nbsp;snad vám, kdo ještě váháte jak, pomůžeme začlenit zdraví a&nbsp;prevenci mezi základní firemní strategie.",
        "companiesText": "Chcete službu Zdraví a prevence do své firmy?",
        "actionButton": "Mám zájem",
        "helloImgName": "hello-conference-main-img"
      },
      "infoBox": {
        "items": [
          "Online",
          "Platforma ZOOM",
          "4. 11. 2020, 15.00–18.00 h."
        ]
      },
      "speakers": {
        "title": "Co zaznělo na konferenci",
        "list": [
          {
            "photo": "speakers/petr_smejkal.png",
            "name": "MUDr. Petr Smejkal",
            "perex": "Zploštění křivky vysvětlil na příkladu kladivo a tanec Petr Smejkal. „Když křivku oploštíme kladivem, musíme tancovat, tedy testovat. Je lepší dobře tancovat, aby se nemuselo použít kladivo, které jsme u nás použili už dvakrát.“",
            "videoUrl": "https://youtu.be/dN5XtBkTZYc"
          },
          {
            "photo": "speakers/daniel_stach.png",
            "name": "Daniel Stach",
            "perex": "Daniel Stach měl za úkol zodpovědět na tři otázky. Nejdůležitější byla, jak zajistit, aby lidé nepanikařili a situaci zvládli: „Řešte jen to, co je klíčové, pro vás důležité, ne drobnosti. Důležitá je jednoznačnost komunikace. Dospělý ve stresu vnímá jako 12letý (Vymětal). Podle toho podávejte informace.“",
            "videoUrl": "https://youtu.be/yeATVGhsE7s"
          },
          {
            "photo": "speakers/tomas_sebek.jpg",
            "name": "MUDr. Tomáš Šebek",
            "perex": "„Řídit si zdraví může každý z nás – snažíme se to propagovat. Máme radost, že toto ve firmách chápete a přidáváte se k nám,“ vyzdvihl etickou otázku tzv. nulté prevence Tomáš Šebek.",
            "videoUrl": "https://youtu.be/U2NFN7XWHtY"
          },
          {
            "photo": "speakers/martin_palicka.png",
            "name": "Martin Palička",
            "perex": "„V dnešní komplikované době je důležité, aby firmy myslely prvně na své zaměstnance a až potom na své marže. Lidé ve firmě by se neměli bát říkat své názory a potřebují dostat odpovědi na své otázky,“ vyzdvihuje Martin Palička přístup, který vidí napříč firemním sektorem.",
            "videoUrl": "https://youtu.be/b5iPAFQwpNM"
          },
          {
            "photo": "speakers/sona_bouskova.png",
            "name": "MUDr. Soňa Boušková",
            "perex": "„Hodně řešíme, jak důležité je nyní neodkládat i běžné zdravotní problémy. Avšak stejně tak důležité je nemocem předcházet. Proto na vás chci apelovat – myslete na prevenci, ta nebolí, za to vás významně ochrání do budoucna. Rádi vám pomůžeme a vždycky si na vás uděláme čas,“ vyzvala Soňa Boušková.",
            "videoUrl": "https://youtu.be/XcaDRji_RWA"
          },
          {
            "photo": "speakers/hana_smidtova.png",
            "name": "Hana Šmidtová",
            "perex": "V Alze došlo během dvou týdnů ke zdvojnásobení počtu zaměstnanců v provozu. „Objevil se přirozeně strach u provozních zaměstnanců, zda nepřijdou o práci z důvodu karantény. Prodávat znamená možnost postarat se o zaměstnance, ale také povinnost postarat se o jejich zdraví,“ připomněla Hana Šmidtová.",
            "videoUrl": "https://youtu.be/63PvjkoSUXM"
          },
          {
            "photo": "speakers/jaroslava_rezlerova.png",
            "name": "Jaroslava Rezlerová",
            "perex": "O podstatě sdílení informací mluvila i Jaroslava Rezlerová: „Poslední průzkum ukázal pozitivnější náladu zaměstnavatelů, než jsme čekali. Viděli jsme to na tisících případů výrobních firem. Je to neuvěřitelné. Ekonomický vývoj politiku předbíhá.“",
            "videoUrl": "https://youtu.be/gLzSV9yulgA"
          },
          {
            "photo": "speakers/tereza_kucerova.png",
            "name": "Tereza Kučerová",
            "perex": "Z 50 na 600 lidí vyrostla firma Prusa Research: „Doba covidová přinesla i dobré věci. Zlepšila se komunikace, firemní kultura. HR má podpůrnou roli a pomáhá stmelovat kolektiv, důležitá je pro nás hrdost - Průša jsme my,“ ukázala Tereza Kučerová.",
            "videoUrl": "https://youtu.be/3lrbuUFao9s"
          },
          {
            "photo": "speakers/pavla_mendlova.jpg",
            "name": "Pavla Mendlová",
            "perex": "Jak v České spořitelně řešili počáteční nedostatek informací? Podle Pavly Mendlové spoluprací od Aše po Jablunkov, třeba tím, že si pomohli s trasováním. „Důležité bylo pro zaměstnance vědět, proč se co dělá. Zapojili jsme se do systému chytré karantény a sami jsme v regionech trasovali kolegy.“",
            "videoUrl": "https://youtu.be/-uFAJ8YBVeY"
          }
        ]
      },
      "disclaimer": {
        "title": "HRajte s námi dál navzdory okolnostem!",
        "subtitle": "Kdo si konferenci nenechá ujít?",
        "text": "Každý personalista, který se nyní stává hlavním hybatelem HR strategie zaměřené na lidi. Právě zaměstnanci, jejich stabilita a schopnost pracovat ať už vzdáleně z domova, nebo za zpřísněných podmínek na pracovišti, jsou nejcennějším kapitálem podniku. Společným cílem je udržení ekonomiky. Proto jsou HR oddělení dnes klíčová pro udržení efektivního fungování firmy, přičemž nároky se stále zvyšují nejen v každodenní agendě, ale zejména v péči a komunikaci."
      },
      "program": {
        "subtitle": "Stáhněte si <a href=\"https://www.ulekare.cz/media/hrajeme_dal_program.pdf\" target=\"_blank\">aktuální program</a>",
        "items": [
          {},
          {
            "icon": "care",
            "time": "16.00–17.00",
            "title": "Role médií a komunikace",
            "speakers": [
              {
                "photo": "speakers/daniel_stach.png",
                "name": "Danies Stach"
              },
              {
                "photo": "speakers/jaroslava_rezlerova.png",
                "name": "Jaroslava Rezlerová"
              },
              {
                "photo": "speakers/tereza_kucerova.png",
                "name": "Tereza Kučerová"
              }
            ]
          },
          {
            "time": "17.00–18.00",
            "title": "O zdraví a telemedicíně",
            "speakers": [
              {
                "photo": "speakers/tomas_sebek.jpg",
                "name": "MUDr. Tomáš Šebek"
              },
              {
                "photo": "speakers/petr_smejkal.png",
                "name": "MUDr. Petr Smejkal"
              },
              {
                "photo": "speakers/sona_bouskova.png",
                "name": "MUDr. Soňa Boušková"
              }
            ]
          }
        ]
      },
      "contacts": [
        {
          "name": "Táňa Lálová",
          "email": "tana.lalova@ulekare.cz",
          "phone": "+420 725 826 072"
        },
        {
          "name": "Kateřina Nováková",
          "email": "katerina.novakova@ulekare.cz",
          "phone": "+420 773 107 142"
        },
        {
          "name": "Šimon Šebek",
          "email": "simon.sebek@ulekare.cz",
          "phone": "+420 602 311 867"
        }
      ],
      "logos": {
        "items": [
          {
            "link": "https://www.prusa3d.cz",
            "image": "logos/prusaresearch.png",
            "name": "Prusa Research"
          },
          {
            "link": "https://zasilkovna.cz",
            "image": "logos/zasilkovna.png",
            "name": "Zásilkovna"
          },
          {
            "link": "https://www.manpowergroup.cz",
            "image": "logos/mpg.png",
            "name": "Manpower Group"
          }
        ]
      }
    },
    "hrajemeDal042021": {
      "hello": {
        "title": "HRajeme dál II",
        "perex": "Registrujte se na konferenci, která vás inspiruje v tom, jak realitu dneška přečkat nejen ve zdraví fyzickém, ale i duševním. Návod na perpetuum mobile nemáme, ale poradíme vám, jak si udržet všech pět poHRomadě.",
        "companiesText": "Chcete se stát ve vaší firmě ambasadorem zdraví ve vlastních rukou?",
        "actionButton": "Registrovat se",
        "helloImgName": "hello-conference-main-img"
      },
      "infoBox": {
        "items": [
          "Online",
          "Platforma ZOOM",
          "31. 3. 2021, 14.30-17.30 h."
        ]
      },
      "speakers": {
        "title": "S kým se setkáte?",
        "list": [
          {
            "photo": "speakers/tomas_sebek.jpg",
            "name": "MUDr. Tomáš Šebek",
            "perex": "Vystudoval všeobecné lékařství na 1. lékařské fakultě Univerzity Karlovy. Poté začal pracovat jako chirurg v Nemocnici Hořovice, v irském Dublinu a v současnosti v Nemocnici Na Františku v Praze."
          },
          {
            "photo": "default-avatar.png",
            "name": "MUDr. Tereza Filová",
            "perex": "TBA"
          },
          {
            "photo": "default-avatar.png",
            "name": "doc. MUDr. Rastislav Maďar",
            "perex": "TBA"
          },
          {
            "photo": "default-avatar.png",
            "name": "Martin Rozhoň",
            "perex": "TBA"
          },
          {
            "photo": "default-avatar.png",
            "name": "Tomáš Ervín Dombrovský",
            "perex": "TBA"
          },
          {
            "photo": "default-avatar.png",
            "name": "zástupce HRB - Johnson & Johnson",
            "perex": "TBA"
          },
          {
            "photo": "default-avatar.png",
            "name": "Petr Koubský",
            "perex": "TBA"
          },
          {
            "photo": "default-avatar.png",
            "name": "Jana Chudlíková",
            "perex": "TBA"
          },
          {
            "photo": "default-avatar.png",
            "name": "Jan Lukačevič",
            "perex": "TBA"
          }
        ]
      },
      "disclaimer": {
        "title": "Prakticky: Jak si udržet všech pět poHRomadě?",
        "text": "Čím vším jsme se za poslední rok stali? Učiteli, vedoucími kroužků pro děti, pečovateli, ekonomy, psychology, zdravotníky, opraváři, řemeslníky, … A vedle toho pečujeme o své rodiny – partnery, prarodiče, děti. HRdiny potkáváme na každém rohu, jenomže nám to trochu zevšednělo. Je v pořádku přiznat si, že život v současnosti je vyčerpávající a oprávněně se ptáme: Jak dlouho ještě?\n<br /><br />Odpovědět neumíme. Můžeme vás ale inspirovat v tom, jak sdílenou realitu přečkat nejen ve zdraví fyzickém, ale i duševním. Abychom s trpělivostí a racionalitou prožili současnost. Abychom s nadějí a optimismem nahlédli do budoucnosti.\n<br /><strong>Proč to děláme? Protože zdraví je naše.</strong>"
      },
      "program": {
        "subtitle": "TBA"
      },
      "contacts": [
        {
          "name": "Táňa Lálová",
          "email": "tana.lalova@ulekare.cz",
          "phone": "+420 725 826 072"
        },
        {
          "name": "Lenka Petrašová",
          "email": "lenka.petrasova@ulekare.cz",
          "phone": "+420 775 854 239"
        },
        {
          "name": "Šimon Šebek",
          "email": "simon.sebek@ulekare.cz",
          "phone": "+420 602 311 867"
        }
      ],
      "conferenceForm": {
        "title": "Registrace zdarma",
        "subtitle": "Nenechte si ujít HR online konferenci, která fakty a daty usměrňuje paniku.",
        "sendTitle": "Jsme rádi, že i vy HRajete dál!",
        "sendPerex": "Potvrzení registrace najdete ve svém e-mailu. Případně prosím zkontrolujte složku nevyžádané pošty."
      }
    },
    "hrajemeDal052022": {
      "notificationBar": "Připojte se na konferenci zde",
      "notificationLink": "https://zoom.us/j/91477678728",
      "hello": {
        "title": "<span>Konference</span><br/><span style=\"color: #3ca091\">Zdravé firmy, zdravé Česko</span>",
        "actionButton": "Registrujte se zdarma",
        "moreInfoLink": "Sledovat záznam",
        "helloImgName": "hero-conference.png"
      },
      "program": {
        "subtitle": "Rezervovat vstupenku",
        "moderator": {
          "photo": "martin_cuba.png",
          "text": "Moderuje Martin Čuba"
        },
        "items": [
          {},
          {
            "paragraph": "9:00-9:20",
            "perex": "Přivítání moderátorem <br />"
          },
          {
            "heading": "Přednáška: Z práce rovnou do hrobu? Už ne!",
            "paragraph": "9:20-9:50",
            "perex": "Tomáš Šebek <br />",
            "link": "Češi odcházejí do důchodu ve stále pozdějším věku, jenže v jakém zdravotním a psychickém stavu? České firmy proto začínají intenzivně řešit, jak zaměstnancům prodloužit léta strávená ve zdraví. Přednáška o naději a možných postupech, včetně budoucích, které už fungují u téměř 250 firem v Česku."
          },
          {
            "heading": "Panelová diskuze: Chytrá řešení pro zdraví zaměstnanců",
            "paragraph": "9:50-10:30",
            "perex": "<strong>Hosté:</strong> Vlastimil Hrabal, Lukáš Krčil, Martin Pospíšil, Tomáš Mixa <br />",
            "moderator": "<strong>Moderátor:</strong> Tomáš Šebek <br />",
            "link": "S konkrétními dodavateli produktů a služeb, které inovativním způsobem podporují zdraví zaměstnanců, budeme diskutovat o tom, jak konkrétně lze podporovat zdraví na pracovišti a jaké jsou aktuální trendy v této oblasti."
          },
          {
            "heading": "Přestávka: networking",
            "paragraph": "10:30-11:00",
            "perex": "Coffee break <br />"
          },
          {
            "heading": "Přednáška: V Téčku můžeme být sami sebou",
            "link": "Co to znamená být v korporaci sám sebou, opravdu to lze? A jaký to má vliv na well-being zaměstnanců? Dá se vůbec dopad měřit? Povíme si také, proč nefunguje řešení „one size fits all“ nebo jestli mají zaměstnanecké komunity vliv na well-being.",
            "perex": "Lukáš Ondřej, T-Mobile Czech Republic <br />",
            "paragraph": "11:00-11:30"
          },
          {
            "heading": "Panelová diskuze: Legislativa a zdraví zaměstnanců nejen z pohledu ESG",
            "paragraph": "11:30-12:10",
            "perex": "<strong>Hosté:</strong> Lucie Dryáková, Eva Karásková, Marie Zemanová, Aneta Kovářová, Nikol Michl <br />",
            "moderator": "<strong>Moderátor:</strong> Barbora Dubanská <br />",
            "link": "Tématem diskuse budou aktuality a chystané změny v legislativních normách a regulacích, které souvisí s podporou zdraví zaměstnanců (ESG, daňové aspekty, novela Zákona č. 373 - podpora zdraví zaměstnanců, pracovně lékařské služby)."
          },
          {
            "heading": "Oběd",
            "paragraph": "12:10-13:10",
            "perex": "Catering, networking <br />"
          },
          {
            "heading": "Přednáška: Zdraví není benefit!",
            "paragraph": "13:10-13:40",
            "perex": "Lenka Kučerová, Ministr Zdraví <br />",
            "link": "Zdraví skutečně není pouhý benefit navíc, se kterým je život příjemnější. Zdraví se stává skutečnou investicí do budoucna pro stát, jednotlivce i firmy. Jak efektivní je ale české zdravotnictví? A může se každý z nás stát ministrem vlastního zdraví? V přednášce se zaměříme na klíčové kroky, které firmy potřebují učinit, aby udržely své lidi angažované a zdravé do vysokého věku. Protože zdravé firmy = zdraví zaměstnanci."
          },
          {
            "heading": "Panelová diskuze: Praxí osvědčeno aneb co funguje?",
            "paragraph": "13:40-14:20",
            "perex": "<strong>Hosté:</strong> Pavla Mendlová, Helena Horská, Tomáš Talaš, Klára Černá <br />",
            "moderator": "<strong>Moderátor:</strong> Martin Pospíšil <br />",
            "link": "Cílem diskuze zástupců významných zaměstnavatelů bude sdílet praktické zkušenosti s péčí o zdraví zaměstnanců a hledat odpověď na otázku, proč je téma podpory zdraví v současné době pro zaměstnavatele aktuální a proč by se jím měli aktivně zabývat."
          },
          {
            "heading": "Přestávka: networking",
            "paragraph": "14:20-14:50",
            "perex": "Coffee break <br />"
          },
          {
            "heading": "Přednáška: Podpora duševního zdraví bez stigmatizace",
            "perex": "Dominika Čechová, CorporateSouls.com <br />",
            "link": "Duševní zdraví hraje v pracovním prostředí stále větší roli, protože má přímý dopad na výkon, spokojenost i celkovou atmosféru ve firmě. Jak však může management efektivně podporovat své zaměstnance, aniž by to vedlo ke stigmatizaci? V této přednášce se zaměříme na praktické způsoby, jak vytvořit pracovní prostředí, ve kterém zaměstnanci cítí bezpečí a podporu i v obtížných situacích.",
            "paragraph": "14:50-15:20"
          },
          {
            "heading": "Přednáška: Šance a limity pracovního uplatnění v ČR",
            "paragraph": "15:20-15:50",
            "perex": "Tomáš Ervín Dombrovský, Alma Career <br />",
            "link": "Víte, jaký má vliv prezentismus na vaši práci? Data mluví jasně: vývoj pracovního trhu přináší více změn než „jen“ nedostatek lidí a je potřeba na ně reagovat už teď. Například se umět ptát zaměstnanců, abyste včas a správně změřili zdraví firmy."
          },
          {
            "heading": "Závěr konference",
            "paragraph": "15:50-16:00",
            "perex": "Vyhlášení 3 nejzdravějších firem v rámci „Komunity zdravých firem“ <br />"
          }
        ]
      },
      "keepUpdating": {
        "program": "Program pravidelně aktualizujeme",
        "speakers": "Speakery pravidelně aktualizujeme"
      },
      "contacts": [
        {
          "name": "Adéla Wellalage",
          "email": "adela.wellalage@ulekare.cz"
        }
      ],
      "logos": {
        "items": {
          "mainPartner": {
            "name": "Jobka",
            "link": "https://www.jobka.cz/",
            "image": "logos/jobka.png"
          },
          "partners": {
            "bigLogos": [
              {
                "name": "Unicare",
                "link": "https://www.unicare.cz/cs/",
                "image": "logos/unicare.svg"
              },
              {
                "name": "Ministr zdraví",
                "link": "https://www.ministrzdravi.cz/",
                "image": "logos/ministr_zdravi.png"
              },
              {
                "name": "Biomefix",
                "link": "http://www.biomefix.eu",
                "image": "logos/biomefix.png"
              },
              {
                "image": "logos/imi.png",
                "link": "https://www.imi.cz/",
                "name": "Imi"
              },
              {
                "link": "https://www.healthyoffice.eu/",
                "image": "logos/healthy_office.png",
                "name": "Healthy Office"
              }
            ]
          },
          "charityPartners": {
            "smallLogos": [
              {
                "name": "Nadace Rodiny vlčkových",
                "link": "http://www.nrv.org/",
                "image": "logos/nrv.png"
              }
            ]
          }
        }
      },
      "partnerTypes": {
        "mainPartners": "Hlavní partner",
        "partners": "Partneři konference",
        "charityPartners": "Charity partner"
      },
      "conferenceForm": {
        "title": "Registrace zdarma",
        "subtitle": "Registrací na konferenci získáváte jako poděkování uLékaře.cz možnost vyzkoušet naši službu bezplatně do 19. 6. 2022.",
        "sendTitle": "Jsme rádi, že i vy HRajete dál!",
        "sendPerex": "Potvrzení registrace najdete ve svém e-mailu. Případně prosím zkontrolujte složku nevyžádané pošty."
      },
      "speakers": {
        "list": [
          {
            "isHidden": "true"
          },
          {},
          {},
          {},
          {
            "name": "Martina Klecker Kněžourová",
            "perex": "Výkonná ředitelka řízení lidských zdrojů Letiště Praha, a. s. ",
            "photo": "speakers/martina_klecker.webp"
          },
          {
            "photo": "speakers/jana_ogounova.webp",
            "perex": "HR Manager Schäfer-Sudex s.r.o",
            "name": "Jana Ogounová"
          },
          {
            "name": "Zuzana Volková",
            "perex": "Členka think tanku Ministr zdraví, finanční ředitelka Delirest a Primirest CZ & SK",
            "photo": "speakers/zuzana_volkova.webp"
          },
          {
            "name": "Veronika Urban",
            "perex": "Head of Sales, JOBka services s.r.o.",
            "photo": "speakers/veronika_urban.webp"
          },
          {
            "name": "Petr Kuf",
            "perex": "Head of Human Resources, Körber Pharma"
          },
          {
            "name": "Dalibor Pastucha",
            "perex": "Dětský a tělovýchovný lékař, vysokoškolský pedagog, Klinika rehabilitace a tělovýchovného lékařství, FN Ostrava",
            "photo": "speakers/dalibor_pastucha.webp"
          },
          {
            "name": "Barbora Vágnerová",
            "perex": "Programová manažerka v oblasti zdraví zaměstnanců, vzdělávání a mezinárodní spolupráce, Ministr zdraví",
            "photo": "speakers/barbora_vagnerova.webp"
          }
        ]
      }
    },
    "infoBox": {
      "titles": [
        "DATUM",
        "ČAS",
        "MÍSTO"
      ]
    },
    "whyPurchaseItems": {
      "sectionTitle": "Proč si koupit vstupenku?",
      "titles": [
        "Inspirativní speakeři",
        "Praktické tipy",
        "Networking",
        "Skvělý catering"
      ]
    },
    "video": "Záznam přednášek",
    "getTicket": "Rezervovat vstupenku",
    "tickets": "Vstupenky",
    "moreInfo": "Více informací",
    "registerForFree": "Registrujte se zdarma",
    "poweredBy": "Powered by:",
    "conference": "Program",
    "logos": {
      "title": "Partneři konference"
    },
    "speakersText": "Řečníci",
    "program": {
      "title": "Program"
    },
    "registration": {
      "title": "Registrace zdarma",
      "subtitle": "Nenechte si ujít HR online konferenci, která fakty a daty usměrňuje paniku."
    },
    "registrationText": "Registrace",
    "contact": "Kontakt",
    "gallery": "Fotogalerie",
    "partners": "Partneři"
  },
  "emergency": {
    "title1": "Kedy vyhľadať pohotovosť",
    "perex": "Ide o stručný súpis akútnych alebo život ohrozujúcich stavov, na ktoré chceme upozorniť pacientov s cieľom nasmerovať to nejurgentnějšie na pohotovosť, aby nedošlo k omeškaniu v ošetrení čakaním na odpoveď lekára v poradni. Najväčší obozretnosť je treba u detí.",
    "list": [
      {
        "title": "Úrazy a krvácanie",
        "body": [
          "veľké krvácenie, alebo <strong>jasné červené krvácanie, ktoré strieka</strong>",
          "veľmi silné krvácanie z genitálií mimo menštruačný cyklus alebo z konečníka",
          "otvorená či inak zrejmá zlomenina",
          "<strong>otvorené poranenia</strong> v hrudníku alebo v bruchu",
          "<strong>úrazy hlavy</strong> so stratou vedomia, zmenami správania, bolesťami hlavy, vracaním, rôzne veľkými zornicami, poruchami reči, zraku alebo hybnosti",
          "<strong>popáleniny u detí</strong>, zvlášť na hlave a rukách, genitálií alebo na väčšej ploche tela u dospelého",
          "úrazy <strong>elektrickým prúdom alebo bleskom</strong>"
        ]
      },
      {
        "title": "Bolesť na hrudi a pocity v hrudi",
        "body": [
          "bolesť v hrudníku, ktorá <strong>neprestáva</strong>, nereaguje na bežné lieky proti bolesti, či sa stupňuje, je <strong>zvieravá</strong>",
          "<strong>vystreľuje</strong> do ľavej ruky alebo do krku",
          "bolesť či <strong>porucha rytmu sprevádzaná zmenami vedomia</strong>, mdlobami",
          "ak máte podobné prejavy opakovane, alebo máte chorobu srdca a obehového systému",
          "bolesť na hrudi s dýchavičnosťou a významnými zmenami tlaku"
        ]
      },
      {
        "title": "Dýchavičnosť",
        "body": [
          "nemožnosť chytiť dych, pocit <strong>nedostatočnosti dychu</strong>",
          "<strong>lapavé dýchanie</strong> (ako ryba), dýchavičnosť, hvízdavý výdych",
          "nemožnosť dokončiť vetu bez nádychu, potreba sedieť alebo oprieť sa o ruky pre zlepšenie dýchania, prepadávanie jamky na krku a medzi ramenami a krkom",
          "<strong>zmena farby</strong> pier, uší alebo prstov na fialovú"
        ]
      },
      {
        "title": "Bolesť hlavy",
        "body": [
          "bolesť je <strong>krutá, nezvyklá, náhle</strong> vzniknutá, nereaguje na lieky",
          "<strong>budí v noci</strong>, prípadne nastupuje hneď po prebudení",
          "náhlej bolesti predchádzala veľká fyzická námaha vrátane sexuálnych aktivít",
          "bolesť je sprevádzaná tuhosťou šije, malátnosťou, spavosťou, poruchami vedomia, horúčkou",
          "bolesť hlavy v najbližších dňoch po úrazoch hlavy, zvlášť s poruchou vedomia, vracaním, motaním",
          "sprevádzaná <strong>poruchami zraku, reči, hybnosti</strong>"
        ]
      },
      {
        "title": "Bolesť brucha a prejavy v oblasti trávenia",
        "body": [
          "<strong>krutá alebo kolikovitá</strong> bolesť brucha",
          "<strong>zástava odchodu stolice</strong> alebo plynov s nadýmaním brucha, bolesti",
          "čierna stolica",
          "<strong>vracanie krve</strong>",
          "<strong>hrče na bruchu</strong>, v slabinách, na semenníku, ktorá bolí, nejde zatlačiť (nepokúšajte sa o to), je farebne zmenená oproti okoliu"
        ]
      },
      {
        "title": "Mdloby, porucha vedomia, kŕče",
        "body": [
          "náhle vzniknutá mdloba, pád, po ktorom sa dotyčný nebudí alebo nechová ako normálne",
          "stavy s <strong>poruchou vedomia, reči, videnia, hybnosti končatín</strong>",
          "celkové <strong>kŕče tela</strong>"
        ]
      },
      {
        "title": "Infekcie a horúčky",
        "body": [
          "stavy sprevádzané <strong>horúčkou nad 40°C, ktorá nejde znížiť váhe zodpovedajúcou dávkou lieku</strong>",
          "<strong>zimnica u detí, kŕče u detí pri horúčke</strong>",
          "opakované <strong>neztišitelné zvracanie a hnačky u detí</strong>, nedostatočný príjem tekutín u detí",
          "infekcie sprevádzané celkovými zmenami stavu/správania, ako výrazná spavosť, nevôľa, neschopnosť jesť, piť"
        ]
      },
      {
        "title": "Alergie a opuchy",
        "body": [
          "<strong>opuch tváre, krku a vo vnútri hrdla, opuch jazyka</strong>",
          "<strong>dýchavičnosť</strong>",
          "<strong>ťažkosti s prehĺtaním</strong>",
          "celotelové prejavy ako vyrážka alebo opuch",
          "jednostranný, hlavne bolestivý opuch končatiny sprevádzaný prípadne dýchavičnosťou alebo suchým kašľom"
        ]
      },
      {
        "title": "Zubná pohotovosť",
        "body": [
          "bolesť zubov s výraznou bolesťou hlavy",
          "bolesť zubov s horúčkami",
          "opuchy tváre a v oblasti zubov postupujúce na krk alebo sprevádzané ťažkosťami s prehĺtaním"
        ]
      },
      {
        "title": "Trestné činy",
        "body": [
          "v prípade, že máte podozrenie na trestný čin, volajte 112",
          "pokiaľ ide o život vám alebo niekomu z blízkych v dôsledku trestného činu, volajte 112",
          "ak ide o šikanovanie, ubližovanie na tele i na duši, volajte 112"
        ]
      },
      {
        "title": "Psychika",
        "body": [
          "pokiaľ ide o náhly stav zmätenosti, zmeny správania, agresivitu, volajte sanitku",
          "pokiaľ ide o hroziacu samovraždu, volajte sanitku"
        ]
      }
    ],
    "title2": "Volajte 155",
    "title": "Kedy vyhľadať pohotovosť"
  },
  "emergencyInfo": {
    "titleQuestion": "Skôr, než položíte otázku",
    "titleonco-prevention": "Skôr, než položíte otázku",
    "titleOrder": "Skôr, než položíte objednávku",
    "subtitle": "Služba uLekára.sk nenahrádza Zdravotnicku záchrannú službu.<br /><a href=\"{link}\" target=\"_blank\" class=\"black--text link--inline\">Kedy vyhľadať pohovotosť?</a>",
    "services": "Pri akútnych a život ohrozujúcích stavoch vždy <a href=\"tel:155\" class=\"link--inline black--text\">volajte 155 alebo 112</a>.",
    "continueQuestion": "Pokračovať v otázke",
    "continueOrder": "Pokračovať v objednávke",
    "dynamicForms": {
      "text": "uLekára.sk nenahrádza záchrannú službu. Pri život ohrozujúcich stavoch vždy volajte 155. {emergencyLink}",
      "linkText": "Kedy vyhľadať pohotovosť"
    }
  },
  "evaluation": {
    "title": "Hodnocení návštěvy lékaře",
    "orderInfo": {
      "zz": "Zdravotnické zařízení",
      "orderDate": "Datum objednávky",
      "doctor": "Lékař"
    },
    "error": {
      "title": "Ohodnotit návštěvu lékaře můžete pouze jednou.",
      "perex": "Děkujeme, Vaše hodnocení jsme již obdrželi."
    },
    "form": {
      "sendTitle": "Děkujeme za ohodnocení návštěvy lékaře.",
      "title": "Byl/a jste spokojen/a s návštěvou lékaře?",
      "noVisit": "Lékaře jsem nenavštívil/a.",
      "moreInfo": "Doplňující informace",
      "evaluationError": "Prosíme o zpětnou vazbu.",
      "messageTitle": "Napište cokoliv dalšího, chcete-li nám něco sdělit."
    }
  },
  "partnerb2b": {
    "mastercard": {
      "hello": {
        "title": "Online poradňa a&nbsp;objednanie k&nbsp;lekárovi",
        "perex": "Ako držiteľ prémiovej alebo firemnej karty Mastercard<sup>®</sup> môžete plne využívať služby uLekára, medzi ktoré patrí online lekárska poradňa, objednanie k lekárovi po celej ČR a celkovo lepšia starostlivosť o vaše zdravie."
      },
      "question": {
        "perex": "Váš dotaz zodpoví praktický lékař, popřípadě specialista."
      },
      "howItWorks": {
        "items": [
          {
            "icon": "chat",
            "title": "Spýtajte sa kedykoľvek",
            "perex": "Odpoveď praktického lekára či pediatra dostanete do 6 hodín od položenia svojej otázky.",
            "footer": "Často sme rýchlejší."
          },
          {
            "icon": "mail",
            "title": "Počkajte na odpovede",
            "perex": "Praktický lekár môže požiadať o doplnenie odpovede špecialisty, napríklad dermatológa, ortopéda&nbsp;a pod.",
            "footer": "Pokrývame všetky špecializácie."
          },
          {
            "icon": "calendar/date-31",
            "title": "Nechajte sa objednať",
            "perex": "Ak naši odborníci odporučia osobnú návštevu lekára, objednáme vás.",
            "footer": "Objednať sa môžete aj priamo, bez položenia dotazu."
          }
        ]
      }
    },
    "eon": {
      "hello": {
        "title": "Online lékař pro zákazníky E.ONu",
        "perex": "Věrní zákazníci E.ONu teď mají lékařskou poradnu úplně zdarma. Pro sebe i&nbsp;celou rodinu. Ptejte se, konzultujte nebo se rovnou objednejte ke specialistovi po celé republice."
      },
      "howItWorks": {
        "items": [
          {
            "icon": "chat",
            "title": "Spýtajte sa kedykoľvek",
            "perex": "Odpověď praktického lékaře či pediatra dostanete do 6 hodin od položení svého dotazu.",
            "footer": "Často jsme rychlejší."
          },
          {
            "icon": "mail",
            "title": "Počkejte na odpověď",
            "perex": "Praktický lékař může požádat o doplnění odpovědi specialistu, například dermatologa, ortopeda aj.",
            "footer": "Pokrýváme všechny specializace."
          },
          {
            "icon": "calendar/date-31",
            "title": "Nechte se objednat",
            "perex": "Pokud specialista doporučí osobní návštěvu lékaře, pomůžeme vám s objednáním.",
            "footer": "Objednat se můžete i přímo, bez položení dotazu."
          }
        ]
      },
      "question": {
        "perex": "Váš dotaz zodpoví praktický lékař, popřípadě specialista."
      },
      "faq": {
        "title": "Časté dotazy a odpovědi ke službě uLékaře.cz",
        "perex": "Možná i&nbsp;vás napadají otázky související s&nbsp;využitím služby lékařské online poradny a&nbsp;objednání k&nbsp;lékaři. Nabízíme vám odpovědi na nejčastější z&nbsp;nich.",
        "items": [
          {
            "title": "Můžu se zeptat na cokoliv?",
            "bodyText": "ANO, na vše, co se týká fyzického a&nbsp;duševního zdraví."
          },
          {
            "title": "Opravdu objednáváte ke všem lékařům?",
            "bodyText": "ANO, sestřičky z&nbsp;uLékaře.cz vás objednají k&nbsp;praktickému lékaři i&nbsp;specialistům všech oborů."
          },
          {
            "title": "Musím změnit svého lékaře?",
            "bodyText": "NEMUSÍTE, službu můžete využít i&nbsp;třeba jen pro získání dalšího lékařského názoru."
          },
          {
            "title": "Dozví se něco můj stávající lékař?",
            "bodyText": "NEDOZVÍ, vaše dotazy s&nbsp;nikým nesdílíme. Vše probíhá online a&nbsp;jen mezi vámi a&nbsp;lékařem z&nbsp;poradny, který na dotaz odpovídá."
          },
          {
            "title": "Budu něco platit za využití služby?",
            "bodyText": "Ne, služba je pro věrné zákazníky dostupná zdarma."
          },
          {
            "title": "Budu platit něco lékaři, ke kterému mě objednáte?",
            "bodyText": "Rozhodnutí je na vás. Sestřičky objednávají do státních i&nbsp;nestátních zdravotnických zařízení, hledají nejvhodnějšího lékaře s&nbsp;ohledem na termín návštěvy a&nbsp;dostupnost lékaře dané odbornosti, vše podle vašich preferencí. O&nbsp;případné platbě budete informován/a ještě před samotnou návštěvou lékaře."
          },
          {
            "title": "Jak je zajištěna diskrétnost?",
            "bodyText": "Váš dotaz, křestní jméno a&nbsp;věk vidí pouze lékař, který vám odpovídá. K&nbsp;dalším informacím uvedeným v&nbsp;rámci vašeho požadavku má přístup pouze zdravotnický tým, jenž vám pomáhá s&nbsp;objednáním nebo zodpovídá dotaz. Vaše dotazy/objednávky nejsou dále s&nbsp;nikým sdíleny.<br/><br/> V&nbsp;případě, že přikládáte lékařskou zprávu či jiný dokument, doporučujeme nejprve začernit viditelné osobní údaje a&nbsp;až poté přílohu nahrát k&nbsp;dotazu, aby byla dodržena naprostá anonymita i&nbsp;z&nbsp;vaší strany."
          },
          {
            "title": "Na webu uLékaře.cz jsou ale dotazy zobrazeny, budou tam i moje?",
            "bodyText": "Nebudou."
          },
          {
            "title": "Je využití služby bezpečné?",
            "bodyText": "ANO, je. Služba je v&nbsp;souladu s&nbsp;obecným nařízením ochrany osobních údajů tzv.&nbsp;GDPR. Všechny požadavky jsou řešeny pouze mezi vámi a&nbsp;určenými osobami služby uLékaře.cz, případně zvoleným zdravotnickým zařízením."
          }
        ]
      }
    },
    "sporthelp": {
      "hello": {
        "title": "Online poradna a objednání k lékaři",
        "perex": "SportHelp je komplexní služba pro amatérské sportovce. Zaměřuje se primárně na péči o jejich zdraví. Využití služeb online poradny uLékaře.cz je součástí vašeho členství SportHelp."
      },
      "howItWorks": {
        "items": [
          {
            "icon": "chat",
            "title": "Spýtajte sa kedykoľvek",
            "perex": "Odpoveď praktického lekára či pediatra dostanete do 6 hodín od položenia svojej otázky.",
            "footer": "Často jsme rychlejší."
          },
          {
            "icon": "mail",
            "title": "Počkejte na odpověď",
            "perex": "Praktický lékař může požádat o doplnění odpovědi specialistu, například dermatologa, ortopeda aj.",
            "footer": "Pokrýváme všechny specializace."
          },
          {
            "icon": "calendar/date-31",
            "title": "Nechte se objednat",
            "perex": "Pokud specialista doporučí osobní návštěvu lékaře, pomůžeme vám s objednáním.",
            "footer": "Objednat se můžete i přímo, bez položení dotazu."
          }
        ]
      },
      "question": {
        "perex": "Váš dotaz zodpoví praktický lékař, popřípadě specialista."
      },
      "faq": {
        "title": "Časté dotazy a odpovědi ke službě uLékaře.cz",
        "perex": "Možná i&nbsp;vás napadají otázky související s&nbsp;využitím služby lékařské online poradny a&nbsp;objednání k&nbsp;lékaři. Nabízíme vám odpovědi na nejčastější z&nbsp;nich.",
        "items": [
          {
            "title": "Můžu se zeptat na cokoliv?",
            "bodyText": "ANO, na vše, co se týká fyzického a&nbsp;duševního zdraví."
          },
          {
            "title": "Opravdu objednáváte ke všem lékařům?",
            "bodyText": "ANO, sestřičky z&nbsp;uLékaře.cz vás objednají k&nbsp;praktickému lékaři i&nbsp;specialistům všech oborů."
          },
          {
            "title": "Musím změnit svého lékaře?",
            "bodyText": "NEMUSÍTE, službu můžete využít i&nbsp;třeba jen pro získání dalšího lékařského názoru."
          },
          {
            "title": "Dozví se něco můj stávající lékař?",
            "bodyText": "NEDOZVÍ, vaše dotazy s&nbsp;nikým nesdílíme. Vše probíhá online a&nbsp;jen mezi vámi a&nbsp;lékařem z&nbsp;poradny, který na dotaz odpovídá."
          },
          {
            "title": "Budu něco platit za využití služby?",
            "bodyText": "Ne, využívání služby uLékaře.cz je součástí vašeho členství SportHelp."
          },
          {
            "title": "Budu platit něco lékaři, ke kterému mě objednáte?",
            "bodyText": "Rozhodnutí je na vás. Sestřičky objednávají do státních i&nbsp;nestátních zdravotnických zařízení, hledají nejvhodnějšího lékaře s&nbsp;ohledem na termín návštěvy a&nbsp;dostupnost lékaře dané odbornosti, vše podle vašich preferencí. O&nbsp;případné platbě budete informován/a ještě před samotnou návštěvou lékaře."
          },
          {
            "title": "Jak je zajištěna diskrétnost?",
            "bodyText": "Váš dotaz, křestní jméno a&nbsp;věk vidí pouze lékař, který vám odpovídá. K&nbsp;dalším informacím uvedeným v&nbsp;rámci vašeho požadavku má přístup pouze zdravotnický tým, jenž vám pomáhá s&nbsp;objednáním nebo zodpovídá dotaz. Vaše dotazy/objednávky nejsou dále s&nbsp;nikým sdíleny.<br/><br/> V&nbsp;případě, že přikládáte lékařskou zprávu či jiný dokument, doporučujeme nejprve začernit viditelné osobní údaje a&nbsp;až poté přílohu nahrát k&nbsp;dotazu, aby byla dodržena naprostá anonymita i&nbsp;z&nbsp;vaší strany."
          },
          {
            "title": "Na webu uLékaře.cz jsou ale dotazy zobrazeny, budou tam i moje?",
            "bodyText": "Nebudou."
          },
          {
            "title": "Je využití služby bezpečné?",
            "bodyText": "ANO, je. Služba je v&nbsp;souladu s&nbsp;obecným nařízením ochrany osobních údajů tzv.&nbsp;GDPR. Všechny požadavky jsou řešeny pouze mezi vámi a&nbsp;určenými osobami služby uLékaře.cz, případně zvoleným zdravotnickým zařízením."
          }
        ]
      }
    },
    "philips-sonicare": {
      "hello": {
        "title": "Online poradna a objednání k lékaři",
        "perex": "Jako předplatitelé hlavic Sonicare můžete kdykoliv naplno využívat online lékařskou poradnu s více jak 350 lékaři různých specializací, vyhledání a objednání k lékařům po celé ČR."
      },
      "question": {
        "perex": "Váš dotaz zodpoví praktický lékař, popřípadě specialista."
      },
      "howItWorks": {
        "items": [
          {
            "icon": "chat",
            "title": "Spýtajte sa kedykoľvek",
            "perex": "Odpoveď praktického lekára či pediatra dostanete do 6 hodín od položenia svojej otázky.",
            "footer": "Často jsme rychlejší."
          },
          {
            "icon": "mail",
            "title": "Počkejte na odpověď",
            "perex": "Praktický lékař může požádat o doplnění odpovědi specialistu, například dermatologa, ortopeda aj.",
            "footer": "Pokrýváme všechny specializace."
          },
          {
            "icon": "calendar/date-31",
            "title": "Nechte se objednat",
            "perex": "Pokud specialista doporučí osobní návštěvu lékaře, pomůžeme vám s objednáním.",
            "footer": "Objednat se můžete i přímo, bez položení dotazu."
          }
        ]
      },
      "faq": {
        "items": [
          {
            "title": "Můžu se zeptat na cokoliv?",
            "bodyText": "ANO, na vše, co se týká fyzického a duševního zdraví."
          },
          {
            "title": "Opravdu objednáváte ke všem lékařům?",
            "bodyText": "ANO, sestřičky z uLékaře.cz vás objednají k praktickému lékaři i specialistům všech oborů."
          },
          {
            "title": "Musím změnit svého lékaře?",
            "bodyText": "NEMUSÍTE, službu můžete využít i třeba jen pro získání dalšího lékařského názoru."
          },
          {
            "title": "Dozví se něco můj stávající lékař?",
            "bodyText": "NEDOZVÍ, vaše dotazy s nikým nesdílíme. Vše probíhá online a jen mezi vámi a lékařem z poradny, který na dotaz odpovídá."
          },
          {
            "title": "Budu něco platit za využití služby?",
            "bodyText": "NE, za využití lékařské online poradny nebo objednání k lékaři nic neplatíte. Nárok na využití služby zdarma získáte, pokud jste předplatitel výměnných hlavic Philips Sonicare."
          },
          {
            "title": "Budu platit něco lékaři, ke kterému mě objednáte?",
            "bodyText": "Rozhodnutí je na vás. Sestřičky objednávají do státních i nestátních zdravotnických zařízení, hledají nejvhodnějšího lékaře s ohledem na termín návštěvy a dostupnost lékaře dané odbornosti, vše podle vašich preferencí. O případné platbě budete informován/a ještě před samotnou návštěvou lékaře."
          },
          {
            "title": "Jak je zajištěna diskrétnost?",
            "bodyText": "Váš dotaz, křestní jméno a věk vidí pouze lékař, který vám odpovídá. K dalším informacím uvedeným v rámci vašeho požadavku má přístup pouze zdravotnický tým, jenž vám pomáhá s objednáním nebo zodpovídá dotaz. Vaše dotazy/objednávky nejsou dále s nikým sdíleny.<br/><br/> V případě, že přikládáte lékařskou zprávu či jiný dokument, doporučujeme nejprve začernit viditelné osobní údaje a až poté přílohu nahrát k dotazu, aby byla dodržena naprostá anonymita i z vaší strany."
          },
          {
            "title": "Na webu uLékaře.cz jsou ale dotazy zobrazeny, budou tam i moje?",
            "bodyText": "NEBUDOU, dotazy předplatitelů výměnných hlavic Philips Sonicare nejsou na stránkách zveřejňovány."
          },
          {
            "title": "Je využití služby bezpečné?",
            "bodyText": "ANO, je. Služba je v souladu s obecným nařízením ochrany osobních údajů tzv. GDPR. Všechny požadavky jsou řešeny pouze mezi vámi a určenými osobami služby uLékaře.cz, případně zvoleným zdravotnickým zařízením."
          }
        ]
      }
    }
  },
  "masterCard": {
    "faq": "Často kladené otázky",
    "useService": "Využiť službu",
    "menu": {
      "question": "Poradiť sa s lekárom",
      "appointment": "Objednat k lékaři",
      "contact": "Kontakt"
    },
    "howItWorks": {
      "title": "Sme tu pre vás nonstop",
      "items": [
        {
          "icon": "chat",
          "title": "Spýtajte sa kedykoľvek",
          "perex": "Odpoveď praktického lekára či pediatra dostanete do 6 hodín od položenia svojej otázky.",
          "footer": "Často sme rýchlejší."
        },
        {
          "icon": "mail",
          "title": "Počkajte na odpovede",
          "perex": "Do 48 hodín obdržíte vyjadrenie tiež od špecialistu (napríklad dermatológa, ortopéda ai.).",
          "footer": "Pokrývame všetky špecializácie."
        },
        {
          "icon": "calendar/date-31",
          "title": "Nechte se objednat",
          "perex": "Pokud specialista doporučí osobní návštěvu lékaře, pomůžeme vám s objednáním.",
          "footer": "Objednať sa môžete aj priamo, bez položenia dotazu."
        }
      ]
    },
    "question": {
      "title": "Poradiť sa s lekárom",
      "perex": "Na vašu otázku odpovie praktický lekár a špecialista."
    },
    "appointment": {
      "title": "Objednať k lekárovi",
      "perex": "Sestra vám zavolá, vyhľadá lekára a objedná vás."
    },
    "authorization": {
      "title": "Overte si vašu kartu Mastercard<sup>®</sup>",
      "subtitle": {
        "question": "Potrebujeme overiť prvých 6 čísel vašej karty <strong>Mastercard<sup>®</sup> Premium</strong>. Nejedná sa o platbu, po úspešnom zadaní budete môcť využiť služieb uLekára.sk zadarmo.",
        "appointment": "Potrebujeme overiť prvých 6 čísel vašej karty <strong>Mastercard<sup>®</sup> Premium</strong>. Nejedná sa o platbu, po úspešnom zadaní budete môcť využiť služieb uLekára.sk zadarmo."
      },
      "codeLabel": "Vložte prvých 6 čísel svojej karty",
      "codeError": "Je nám ľúto, ale vami zadaná kombinácia číslic nezodpovedá prémiovej alebo firemnej karte Mastercard<sup>®</sup>.",
      "sendButton": "Overiť"
    }
  },
  "reauthorizationDashboard": {
    "heading": "Vaša bezplatná služba končí za {daysLeft} dní, dňa {dayFormat}.",
    "partnerText": "Služba uLékaře.cz je stále hradená spoločnosťou {currentPartnerName}.",
    "prolongText": "Predĺžte si výhody služby uLékaře.cz, aby ste ich mali naďalej zadarmo.",
    "prolongFamilyText": "Připomeňte svému blízkému, že byste chtěli službu prodloužit.",
    "buttonText": "Predĺžte si bezplatne",
    "inDay": "deň",
    "inDaysLow": "deň",
    "inDaysHigh": "dní",
    "selfPayNowHeading": "Teraz ste samoplatiteľom. Ale nemusíte byť.",
    "selfPayNowPartnerText": "Kto zaplatí za uLékaře.cz? Môže to byť váš zamestnávateľ, poisťovňa atď.",
    "selfPayNowProlongText": "Rozšírte si svoje výhody a získajte službu zadarmo. Rovnako ako predtým.",
    "selfPayNowFamilyPartnerText": "Pripomeňte svojmu blízkemu {currentPartnerName}.",
    "selfPayNowFamilyPartnerInfoText": "Keď obnoví svoju službu uLékaře.cz, dostanete všetky svoje výhody späť zadarmo."
  },
  "thematicCounselling": {
    "partnerText": "Partner poradny"
  },
  "migraine": {
    "closed": {
      "title": "Pacientský program byl ukončen",
      "description": "Pacientský program Linka o migréně byl ukončen k 15.&nbsp;1.&nbsp;2022. Pokud se chcete poradit o svém zdravotním stavu s lékařem, můžete navštívit ",
      "link": "online poradnu uLékaře.cz"
    },
    "helloImage": "hello-migraine-figure.svg",
    "helloImageAlt": "Naša špecializovaná poradňa Linka o migréne vám môže pomôcť od bolestí hlavy a sprievodných prejavov migrenóznych záchvatov. Poradíme vám a nasmerujeme vás k účinnej liečbe.",
    "partnerLogo": "mluvme-o-migrene",
    "dataProcessing": {
      "privacyPolicyTitle": "Souhlas se zpracováním mých osobních údajů, včetně osobních údajů zvláštní kategorie"
    },
    "menu": {
      "question": "Vyplnit dotazník",
      "helpWith": "S čím pomůžeme",
      "howItWorks": "Jak to funguje",
      "contact": "Kontakt"
    },
    "subTitle": "Linka o migréně",
    "perex": "Bojujete s migrénou, avšak neúspěšně? Díky spolupráci s partnerem Novartis vám nabízíme možnost zdarma a z bezpečí vašeho domova využít specializovanou poradnu. Vyplňte dotazník a zeptejte se na vše, co vás v souvislosti s migrénou a dalšími bolestmi hlavy trápí. Naši odborníci na bolesti hlavy udělají vše pro to, aby vás nasměrovali k účinné pomoci.",
    "infoTitle": "Jak vám pomůžeme?",
    "doctors": {
      "title": "Naši lékaři v poradně",
      "items": [
        "MUDr. Magdaléna Hlavačková",
        "MUDr. Markéta Bartoňová"
      ]
    },
    "infoList": [
      {
        "icon": "check_circle",
        "text": "Vyplňte prosím dotazník pro upřesnění svých potíží."
      },
      {
        "icon": "check_circle",
        "text": "Náš lékař na základě Vašich odpovědí posoudí, o jaký typ bolestí hlavy se jedná, a poradí, jak na ně."
      },
      {
        "icon": "check_circle",
        "text": "Reakci lékaře obdržíte e-mailem do 48 hodin."
      },
      {
        "icon": "check_circle",
        "text": "Nasměrujeme vás dále k léčbě nebo objednání k patřičnému odborníkovi do ambulance či specializovaného centra."
      }
    ],
    "question": "Vyplnit dotazník",
    "rules": "Pravidla poradny \"Linka o migréně\"",
    "howItWorks": {
      "title": "Jak naše služba funguje?",
      "items": [
        {
          "icon": "chat",
          "title": "Tematická poradna je zdarma."
        },
        {
          "icon": "mail",
          "title": "Lékař vám odpoví e-mailem do 48 hodin."
        },
        {
          "icon": "calendar/date-31",
          "title": "Naše sestřičky vám pomohou s objednáním."
        }
      ]
    },
    "form": {
      "title": "Dotazník",
      "thankYou": {
        "title": "Váš dotazník byl úspěšně odeslán",
        "perex": "Vaše odpovědi vyhodnotí lékař a doporučí další postup.",
        "bannerImg": "omigrene-banner.jpg",
        "button": "Pro více informací navštivte web omigrene.cz",
        "buttonLink": "https://omigrene.cz"
      }
    },
    "agreements": {
      "privacyPolicy": "<p>Souhlasím, aby společnost uLékaře.cz, s.r.o., se sídlem Šafaříkova 201/17, 120 00 Praha 5, IČO 05341051 (dále jen „Společnost“), zpracovávala mé osobní údaje pro účely mé registrace a využití služeb v rámci projektu uLékaře.cz, jehož součástí je projekt Linka o migréně. Projekt uLékaře.cz je tvořen zejména specializovanými internetovými stránkami, mobilními aplikacemi a profily na sociálních sítích (dále jen “projekt uLékaře.cz”). Projekt Linka o migréně je potom tvořen obsahem s&nbsp;informacemi a poradenstvím pro uživatele v&nbsp;oblasti uvedeného onemocnění. Projekt uLékaře.cz je provozovaný Společností v souladu se zákonem č. 101/2000 Sb., o ochraně osobních údajů (dále jen „zákon o ochraně osobních údajů“) ve znění pozdějších předpisů a v souladu s nařízením č. 2016/679 Evropského parlamentu a Rady EU o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a o volném pohybu těchto údajů (dále jen „obecné nařízení o ochraně osobních údajů“). Souhlas se zpracováním dávám maximálně na období 10 let od mé poslední aktivity nebo do odvolání tohoto mého souhlasu.</p><p>Současně souhlasím, aby Společnost zpracovávala mé osobní údaje zvláštní kategorie, konkrétně pak o mém zdravotním stavu, a to za účelem:</p><ul><li>vypracování odpovědi odborníka v rámci projektu uLékaře.cz, a/nebo</li><li>předání vhodnému zdravotnickému zařízením za účelem dalších konzultací či spolupráce ve věci mého zdravotnického stavu.</li></ul><p>Výslovně tedy souhlasím, aby Společnost mnou poskytnuté osobní údaje, a to jak jmenné a adresné, tak osobní údaje zvláštní kategorie týkající se mého zdravotního stavu, zpracovávala a dále poskytla spolupracujícím&nbsp;<a href=\"https://www.ulekare.cz/nasi-lekari\" target=\"_blank\">zdravotnickým zařízením</a>, se kterými má Společnost uzavřená zvláštní ujednání o zárukách při zpracování osobních údajů a zvláštní kategorie osobních údajů. Aktuální seznam spolupracujících zdravotnických zařízení shledávám v rámci uvedeného hyperlinku.</p><p>Dále souhlasím, aby Společnost mnou poskytnuté osobní údaje, a to jak jmenné a adresné, tak osobní údaje zvláštní kategorie týkající se mého zdravotního stavu, zpracovávala a dále poskytla&nbsp;<a href=\"https://www.ulekare.cz/nasi-lekari\" target=\"_blank\">spolupracujícím odborníkům</a>, kteří se budou zabývat mými dotazy v rámci poradny projektu uLékaře.cz na základě mého výslovného požadavku.</p><p>Dále souhlasím, že v&nbsp;případě, budu-li ze strany Společnosti kontaktován ve věci užití služeb Společnosti telefonicky, budou takovéto telefonáty nahrávány za účelem zajištění informací o uzavírání smlouvy či kvality poskytovaných služeb.</p><p>Potvrzuji, že jsem obeznámen se svými právy související se zpracováním dle výše zmíněných právních předpisů, a to jak ve vztahu k osobním údajům, tak i ke zvláštní kategorii osobních údajů, zejména pak:</p><ul><li>s právem na přístup ke svým osobním údajům, jejich opravu nebo jejich výmaz, popřípadě s omezením zpracování;</li><li>s právem vznést námitku proti zpracování;</li><li>s právem na přenositelnost údajů ve strukturovaném, běžně používaném a strojově čitelném formátu;</li><li>s právem kdykoliv souhlas se zpracováním odvolat;</li><li>a s právem podat stížnost u dozorového úřadu, kterým je Úřad pro ochranu osobních údajů.</li></ul><p>Současně potvrzuji, že jsem obeznámen se způsobem nakládání s mými osobními údaji a jejich zpracováním vč. zvláštní kategorie osobních údajů, zejména že:</p><ul><li>mé osobní údaje jsou zpracovány pouze v rozsahu, ve kterém byly mnou poskytnuty a pouze pro shora uvedené účely;</li><li>Společnost provádí s mými údaji následující úkony: ukládá je do databáze uživatelů, upravuje je v případě, že je doplním nebo se dožádám úpravy, vyhledává je v rámci své databáze, třídí je dle jednotlivých kritérií pro dotazy poradny a likviduje je po uplynutí shora uvedené lhůty pro zpracování nebo po odvolání mého souhlasu.</li><li>mé údaje Společnost poskytuje zpracovatelům z řad <a href=\"https://www.ulekare.cz/nasi-lekari\" target=\"_blank\">zdravotnických zařízení nebo odborníkům</a> zpracovávajícím mé výslovně položené dotazy.</li><li>partnerem projektu Linka o migréně je společnost Novartis; tato společnost však není zpracovatelem osobních údajů z&nbsp;projektu Linka o migréně, z&nbsp;tohoto projektu jsou jí dostupná pouze anonymizovaná základní data o použití poradny (bez jmenných a adresných údajů uživatelů či bez zvláštní kategorie údajů o zdravotním stavu uživatelů) v&nbsp;podobě přehledu počtu položených dotazů a objednání.</li></ul><p>Současně beru na vědomí, že se v případě jakýchkoliv dotazů ohledně zpracování mých osobních údajů nebo v případě uplatnění výše uvedených práv mohu obrátit na pověřence pro ochranu osobních údajů Společnosti, kontakt <a href=\"mailto:stankova@stankovapartneri.cz\">stankova@stankovapartneri.cz</a>, nebo po další komunikaci ohledně mých osobních údajů, příp. odvolání souhlasu s jejich zpracováním mohu také využít adresu <a href=\"mailto:osobniudaje@ulekare.cz\">osobniudaje@ulekare.cz</a>.</p><p>Potvrzuji, že tímto dávám Společnosti výslovný souhlas a zákonný důvod pro zpracování mých osobních údajů vč. zvláštní kategorie údajů v souladu se zněním zákona o ochraně osobních údajů a obecným nařízením o ochraně osobních údajů.</p>"
    },
    "footer": "Společnost NOVARTIS s.r.o. je prezentována pouze logem na stránce poradny a marketingových materiálech pro uživatele. Získává pouze anonymizovaná, základní data o užití poradny v podobě přehledu počtu položených dotazů a objednání. Téma poradny, výběr lékaře či dalšího zdravotnického personálu a veškerá komunikace s pacienty je plně v režii společnosti uLékaře.cz."
  },
  "psoriasis": {
    "helloImage": "hello-psoriasis-figure.svg",
    "helloImageAlt": "Naša špecializovaná poradňa Ako vyzrieť na lupienku vám môže pomôcť s liečbou psoriázy. Poradíme vám a nasmerujeme vás k účinnej liečbe.",
    "partnerLogo": "novartis",
    "dataProcessing": {
      "personalDataTitle": "Souhlas se zpracováním mých osobních údajů, včetně osobních údajů zvláštní kategorie"
    },
    "closed": {
      "title": "Pacientský program Jak vyzrát na lupénku byl ukončen",
      "description": "Pacientský program Jak vyzrát na lupénku byl ukončen k 15.&nbsp;9.&nbsp;2022. Pokud se chcete poradit o svém zdravotním stavu s lékařem, můžete navštívit"
    },
    "menu": {
      "question": "Poradit se",
      "helpWith": "S čím pomůžeme",
      "howItWorks": "Jak to funguje",
      "contact": "Kontakt"
    },
    "subTitle": "Jak vyzrát na lupénku",
    "perex": "Léčíte se s lupénkou, avšak neúspěšně? Chcete o své nemoci vědět něco dalšího? Nebo máte kožní problémy a podezření, že by mohlo jít o lupénku? Pojďte vyplnit dotazník a zeptat se našich kožních lékařů v poradně uLékaře.cz.",
    "infoTitle": "Poradit se",
    "doctors": {
      "title": "Kdo na dotazy odpovídá?",
      "items": [
        "MUDr. Andrea Vocilková",
        "MUDr. Jitka Dobešová",
        "MUDr. Eva Dogoši"
      ]
    },
    "infoList": [
      {
        "icon": "register",
        "text": "Vyplňte prosím dotazník pro upřesnění svých potíží."
      },
      {
        "icon": "mail",
        "text": "Reakci lékaře obdržíte e-mailem do 48 hodin."
      },
      {
        "icon": "nurse",
        "text": "Nasměrujeme vás dále k léčbě nebo objednání k patřičnému odborníkovi do ambulance či specializovaného centra."
      }
    ],
    "question": "Vyplnit dotazník",
    "rules": "Pravidla poradny \"Linka o migréně\"",
    "howItWorks": {
      "title": "Jak služba funguje?",
      "items": [
        {
          "icon": "chat",
          "title": "Tematická poradna je zdarma, ptát se můžete opakovaně."
        },
        {
          "icon": "mail",
          "title": "Odpověď lékaře na svůj dotaz obdržíte e-mailem do 48 hodin."
        },
        {
          "icon": "calendar/date-31",
          "title": "Doporučí-li náš odborník osobní návštěvu lékaře, objednáme vás."
        }
      ]
    },
    "agreements": {
      "termsConditions": "<p>Tyto podmínky užití upravují práva a povinnosti návštěvníků a uživatelů (dále jen „Vy“ nebo „Uživatel“) webových stránek <a href=\"https://www.ulekare.cz\" target=\"_blank\">www.ulekare.cz</a>, část služba Jak vyzrát na lupénku, provozovaných společností uLékaře.cz, s.r.o., IČO 05341051, sídlem Praha 2, Šafaříkova 201/17, zapsanou v obchodním rejstříku Městského soudu v Praze pod sp. zn. C 262183 (dále jen „Provozovatel“), a dalších platforem (např. mobilní aplikace či stránek na sociálních sítích) provozovaných Provozovatelem, na které se tyto podmínky uplatní přiměřeně (dále společně jen „Web“) a služeb prostřednictvím Webu v rámci služby Jak vyzrát na lupénku poskytovaných (dále jen „Služby“, Web a Služby dále společně jen „uLékaře.cz“). Uživatel užitím služby uLékaře.cz vyjadřuje, že se seznámil s těmito podmínkami a souhlasí s nimi.</p><p><strong>1. Obsah Webu.</strong> Obsahem Webu jsou informace určené pro Uživatele z řad široké veřejnosti. Jedná se zejména o články z oboru zdravotnictví a zdravotnické péče určené pro širokou veřejnost, informace o probíhajících akcích spjatých s tématem zdraví a odkazy na jiné odborné stránky, organizace, odborníky a zdravotnická zařízení a dále informace poskytované na dotazy pokládané ze strany široké veřejnosti. Služba Jak vyzrát na lupénku je potom specializovaná služba v rámci Webu zaměřena na uživatele zajímající se o problém psoriázy, obsahuje dotazník určující potřeby těchto uživatelů, umožňuje objednání uživatelů do specializovaných center k léčbě psoriázy či umožňuje položit dotazy odborníkům v oblasti psoriázy.</p><p><strong>2. Účel uLékaře.cz.</strong> Účelem uLékaře.cz je zvyšovat informovanost široké veřejnosti v oblasti zdraví a zdravotnictví. Obsah uLékaře.cz má informativní charakter a v žádném případě nenahrazuje lékařskou péči; slouží jako alternativní a nezávazný zdroj informací. Provozovatel důrazně doporučuje vyhledat v případě zdravotních obtíží lékařskou či jinou odbornou péči. Užitím uLékaře.cz bere Uživatel na vědomí, že informace poskytnuté prostřednictvím uLékaře.cz mají obecnou platnost, přičemž nezohledňují individuální potřeby a zdravotní stav Uživatele a v případě, že má Uživatel zdravotní potíže, měl by se obrátit na lékaře či jiného odborníka.</p><p><strong>3. Registrace a uživatelský účet.</strong> Pro využívání některých služby Jak vyzrát na lupénku je nutná registrace Uživatele (dále jen „Registrace“), na základě které dochází k vytvoření účtu Uživatele (dále jen „Účet“). Registrace se provádí prostřednictvím formuláře a vyžaduje poskytnutí osobních údajů alespoň v rozsahu nezbytném pro využití dané Služby. Pro úspěšné dokončení registrace je třeba učinit kroky popsané na Webu vč. vyplnění dotazníku.</p><p><strong>4. Práva a povinnosti Uživatele.</strong> Užíváním uLékaře.cz Uživatel vyjadřuje seznámení se s těmito podmínkami a souhlas s nimi. Uživatel výslovně bere na vědomí a souhlasí s tím, že porušení těchto podmínek či právních předpisů může být důvodem pro odepření přístupu k uLékaře.cz a zrušení Účtu. Užíváním uLékaře.cz Uživatel prohlašuje a zaručuje, že je plně svéprávný a veškeré údaje poskytované prostřednictvím uLékaře.cz jsou úplné, pravdivé, přesné a správné. Uživatel je při užívání uLékaře.cz povinen jednat v souladu s těmito podmínkami a právními předpisy, zejména poškozovat či jinak nezasahovat do práva Provozovatele, Uživatelů či třetích osob a nezneužívat, neblokovat, neměnit či jiným způsobem nezasahovat do fungování uLékaře.cz. Uživatel je oprávněn prostřednictvím uLékaře.cz sdělovat informace o jiných osobách než je sám Uživatel pouze se souhlasem těchto osob; v případě, že Uživatel sděluje prostřednictvím uLékaře.cz informace o jiné osobě než je sám Uživatel, prohlašuje a zaručuje vůči Provozovateli, že má od těchto osob předchozí dobrovolný souhlas ke sdělení takových informací, Uživatel odpovídá za jakoukoliv újmu, která by mohla Provozovateli či jiným osobám vzniknout v případě, že by vyšlo najevo, že Uživateli souhlas se sdělením informací nebyl udělen.</p><p><strong>5. Poradna.</strong> Součástí uLékaře.cz je i poradna, v jejímž rámci odpovídají na dotazy Uživatelů lékaři a v případě některých oblastí další pracovníci v oblasti zdravotnictví (např. fyzioterapeuti, lékárníci či výživoví poradci) (dále jen „Spolupracovníci“) spolupracující s Provozovatelem (dále jen „Poradna“). V rámci Poradny jsou zodpovídány dotazy Uživatelů z oblasti zdraví a zdravotnictví, přičemž odpovědi jsou poskytovány na základě informací dostupných zodpovídajícímu Spolupracovníkovi. V rámci Poradny jsou vždy poskytovány obecné informace z oblasti zdraví, nemocí či jiných zdravotních obtíží, přičemž nedochází ke stanovení individuální diagnózy Uživatele, stanovení individuálního léčebného plánu či plánu prevence Uživatele, a to i s ohledem na omezené možnosti online komunikace. Poradna nenahrazuje lékařskou či jinou odbornou péči a nejedná se o individuální konzultaci s lékařem či jiným odborníkem ve zdravotnictví, Poradna slouží jako alternativní a nezávazný zdroj informací. Provozovatel Uživatelům důrazně doporučuje vyhledat v případě zdravotních obtíží lékařskou či jinou odbornou péči. Uživatel nese odpovědnost za následky způsobené nenavštívením lékaře či jiného odborníka.</p><p><strong>6. Využití Poradny.</strong> Pro položení dotazu v rámci Poradny je třeba vyplnit formulář umístěný na Webu a potvrdit seznámení se s těmito podmínkami užití. Pro poskytnutí Služby Poradny je nezbytné zpracovat osobní údaje Uživatele, včetně zvláštní kategorie údajů o zdravotním stavu, z tohoto důvodu potřebuje Provozovatel souhlas Uživatele k takovému zpracování osobních údajů. Se zásadami ochrany osobních údajů uLékaře.cz se můžete seznámit zde.</p><p><strong>7. Placení Poradny.</strong> Využití Poradny je zpoplatněno, nicméně pro uživatele služby Jak vyzrát na lupénku je poradna poskytována bezúplatně.</p><p><strong>8. Rychlost odpovědi.</strong> Odpovědi na dotaz položený v rámci Poradny jsou sdělovány ve standardní době jako v rámci poradny uLékaře.cz.</p><p><strong>9. Objednání.</strong> V rámci uLékaře.cz je poskytována Služba objednání Uživatele k lékaři. Provozovatel pak zprostředkuje kontakt mezi Uživatelem zvoleným poskytovatelem zdravotních služeb a Uživatelem (dále jen „Objednání“). Cena Objednání je zpoplatněna, nicméně pro uživatele v rámci služby Jak vyzrát na lupénku je poskytována bezúplatně. V rámci Objednání pro Uživatele Provozovatel zajistí zprostředkování kontaktu s Uživatelem zvoleným poskytovatelem zdravotních služeb, včetně domluvení vhodného termínu návštěvy poskytovatele zdravotních služeb. Poskytovatel zdravotních služeb z kapacitních či jiných důvodů může odmítnout využití Objednání a poskytnutí následných zdravotních služeb. Pro vyloučení pochybností se uvádí, že Objednání zahrnuje pouze zprostředkování kontaktu mezi Uživatelem a poskytovatelem zdravotních služeb. Následná komunikace mezi Uživatelem a zvoleným poskytovatelem zdravotních služeb, jakož i další poskytování služeb ze strany poskytovatele zdravotních služeb a podmínky poskytování zdravotních služeb je součástí vztahu Uživatele s daným poskytovatelem, do nějž není Provozovatel žádným způsobem zapojen.</p><p><strong>10. Autorský obsah.</strong> Web a jeho obsah jsou chráněny zejména zákonem č. 121/2000 Sb., o právu autorském, ve znění pozdějších předpisů a zákonem č. 89/2012 Sb., občanského zákoníku, ve znění pozdějších předpisů. Zveřejňování či jiné užití obsahu Webu pro komerční účely je možné pouze se souhlasem Provozovatele.</p><p><strong>11. Reklama.</strong> Web může obsahovat obchodní sdělení, která jsou označována v souladu s platnou právní úpravou, zejména pak v souladu se zákonem č. 40/1995. Sb., o regulaci reklamy, ve znění pozdějších předpisů.</p><p><strong>12. Spotřebitel.</strong> V případech, kdy je Uživatel ve vztahu k Provozovateli spotřebitelem a vznikne spotřebitelský spor, který se nepodaří vyřešit vzájemnou dohodou, může takový Uživatel podat návrh na mimosoudní řešení spotřebitelského sporu České obchodní inspekci (Ústřední inspektorát – oddělení ADR, sídlem Štěpánská 15, 120 00 Praha 2, e-mail: adr@coi.cz, web: adr.coi.cz). V těchto případech také může uživatel v postavení spotřebitele využít platformu pro řešení spotřebitelských sporů online, která je zřízena Evropskou komisí a je dostupná na internetové adrese: http://ec.europa.eu/consumers/odr/. Od smlouvy o dodání Služeb a obsahu prostřednictvím Webu dle těchto podmínek není možné odstoupit v souladu s ust. § 1837 písm. l) zákona č. 89/2012 Sb., občanský zákoník, ve znění pozdějších předpisů, podle nějž nemůže spotřebitel odstoupit od smlouvy o dodání digitálního obsahu.</p><p><strong>13. Odlišná ujednání.</strong> Tyto podmínky upravují užívání uLékaře.cz v rozsahu pro užití služby Jak vyzrát na lupénku.</p><p><strong>14. Změna webu.</strong> Provozovatel si vyhrazuje právo na změnu obsahu a přístupu k uLékaře.cz. K plánovaným zásadním změnám obsahu stránek a ke změnám jejich užívání bude vždy připojeno datum změny.</p><p><strong>15. Platnost podmínek užití.</strong> Platnost podmínek užití. Tyto podmínky, jakož i jejich případné změny, nabývají platnosti a účinnosti okamžikem jejich zveřejnění. Provozovatel může obchodní podmínky jednostranně měnit zveřejněním nových obchodních podmínek, přičemž změnou nejsou dotčena nabytá práva Uživatele.</p><p>Datum zveřejnění: 15. června 2021</p><p>uLékaře.cz, s.r.o.</p>",
      "privacyPolicy": "<p>Souhlasím, aby společnost uLékaře.cz, s.r.o., se sídlem Šafaříkova 201/17, 120 00 Praha 5, IČO 05341051 (dále jen „Společnost“), zpracovávala mé osobní údaje pro účely mé registrace a využití služeb v rámci projektu uLékaře.cz, jehož součástí je projekt Jak vyzrát na lupénku. Projekt uLékaře.cz je tvořen zejména specializovanými internetovými stránkami, mobilními aplikacemi a profily na sociálních sítích (dále jen “projekt uLékaře.cz”). Projekt Jak vyzrát na lupénku je potom tvořen obsahem s informacemi a poradenstvím pro uživatele v oblasti uvedeného onemocnění. Projekt uLékaře.cz je provozovaný Společností v souladu se zákonem č. 101/2000 Sb., o ochraně osobních údajů (dále jen „zákon o ochraně osobních údajů“) ve znění pozdějších předpisů a v souladu s nařízením č. 2016/679 Evropského parlamentu a Rady EU o ochraně fyzických osob v souvislosti se zpracováním osobních údajů a o volném pohybu těchto údajů (dále jen „obecné nařízení o ochraně osobních údajů“). Souhlas se zpracováním dávám maximálně na období 10 let od mé poslední aktivity nebo do odvolání tohoto mého souhlasu.</p><p>Současně souhlasím, aby Společnost zpracovávala mé osobní údaje zvláštní kategorie, konkrétně pak o mém zdravotním stavu, a to za účelem:</p><ul><li>vypracování odpovědi odborníka v rámci projektu uLékaře.cz, a/nebo</li><li>předání vhodnému zdravotnickému zařízením za účelem dalších konzultací či spolupráce ve věci mého zdravotnického stavu.</li></ul><p>Výslovně tedy souhlasím, aby Společnost mnou poskytnuté osobní údaje, a to jak jmenné a adresné, tak osobní údaje zvláštní kategorie týkající se mého zdravotního stavu, zpracovávala a dále poskytla spolupracujícím <a href=\"https://www.ulekare.cz/nasi-lekari\" target=\"_blank\">zdravotnickým zařízením</a>, se kterými má Společnost uzavřená zvláštní ujednání o zárukách při zpracování osobních údajů a zvláštní kategorie osobních údajů. Aktuální seznam spolupracujících zdravotnických zařízení shledávám v rámci uvedeného hyperlinku.</p><p>Dále souhlasím, aby Společnost mnou poskytnuté osobní údaje, a to jak jmenné a adresné, tak osobní údaje zvláštní kategorie týkající se mého zdravotního stavu, zpracovávala a dále poskytla <a href=\"https://www.ulekare.cz/nasi-lekari\" target=\"_blank\">spolupracujícím odborníkům</a>, kteří se budou zabývat mými dotazy v rámci poradny projektu uLékaře.cz na základě mého výslovného požadavku.</p><p>Dále souhlasím, že v případě, budu-li ze strany Společnosti kontaktován ve věci užití služeb Společnosti telefonicky, budou takovéto telefonáty nahrávány za účelem zajištění informací o uzavírání smlouvy či kvality poskytovaných služeb.</p><p>Potvrzuji, že jsem obeznámen se svými právy související se zpracováním dle výše zmíněných právních předpisů, a to jak ve vztahu k osobním údajům, tak i ke zvláštní kategorii osobních údajů, zejména pak:</p><ul><li>s právem na přístup ke svým osobním údajům, jejich opravu nebo jejich výmaz, popřípadě s omezením zpracování;</li><li>s právem vznést námitku proti zpracování;</li><li>s právem na přenositelnost údajů ve strukturovaném, běžně používaném a strojově čitelném formátu;</li><li>s právem kdykoliv souhlas se zpracováním odvolat;</li><li>a s právem podat stížnost u dozorového úřadu, kterým je Úřad pro ochranu osobních údajů.</li></ul><p>Současně potvrzuji, že jsem obeznámen se způsobem nakládání s mými osobními údaji a jejich zpracováním vč. zvláštní kategorie osobních údajů, zejména že:</p><ul><li>mé osobní údaje jsou zpracovány pouze v rozsahu, ve kterém byly mnou poskytnuty a pouze pro shora uvedené účely;</li><li>Společnost provádí s mými údaji následující úkony: ukládá je do databáze uživatelů, upravuje je v případě, že je doplním nebo se dožádám úpravy, vyhledává je v rámci své databáze, třídí je dle jednotlivých kritérií pro dotazy poradny a likviduje je po uplynutí shora uvedené lhůty pro zpracování nebo po odvolání mého souhlasu.</li><li>mé údaje Společnost poskytuje zpracovatelům z řad <a href=\"https://www.ulekare.cz/nasi-lekari\" target=\"_blank\">zdravotnických zařízení nebo odborníkům</a> zpracovávajícím mé výslovně položené dotazy.</li><li>partnerem projektu Jak vyzrát na lupénku je společnost Novartis; tato společnost však není zpracovatelem osobních údajů z projektu Jak vyzrát na lupénku, z tohoto projektu jsou jí dostupná pouze anonymizovaná základní data o použití poradny (bez jmenných a adresných údajů uživatelů či bez zvláštní kategorie údajů o zdravotním stavu uživatelů) v podobě přehledu počtu položených dotazů a objednání.</li></ul><p>Současně beru na vědomí, že se v případě jakýchkoliv dotazů ohledně zpracování mých osobních údajů nebo v případě uplatnění výše uvedených práv mohu obrátit na pověřence pro ochranu osobních údajů Společnosti, kontakt <a href=\"mailto:stankova@stankovapartneri.cz\">stankova@stankovapartneri.cz</a>, nebo po další komunikaci ohledně mých osobních údajů, příp. odvolání souhlasu s jejich zpracováním mohu také využít adresu <a href=\"mailto:osobniudaje@ulekare.cz\">osobniudaje@ulekare.cz</a>.</p><p>Potvrzuji, že tímto dávám Společnosti výslovný souhlas a zákonný důvod pro zpracování mých osobních údajů vč. zvláštní kategorie údajů v souladu se zněním zákona o ochraně osobních údajů a obecným nařízením o ochraně osobních údajů.</p>"
    },
    "form": {
      "title": "Dotazník",
      "thankYou": {
        "title": "Program Jak vyzrát na lupénku",
        "perex": "<p>Děkujeme za vyplnění dotazníku. Všechny údaje jsme právě odeslali ke zpracování.</p><p>Reakce lékaře vám bude zaslána na vámi zadaný e-mail do 48 h.</p><p>Dle doporučení lékaře vás bude kontaktovat zdravotní sestra a pomůže vám s objednáním k lékaři.</p>",
        "button": "Pro více informací navštivte web \"kuzeaklouby.cz\"",
        "buttonLink": "https://kuzeaklouby.cz"
      }
    },
    "footer": "Společnost NOVARTIS s.r.o. je prezentována pouze logem na stránce poradny a marketingových materiálech pro uživatele. Získává pouze anonymizovaná, základní data o užití poradny v podobě přehledu počtu položených dotazů a objednání. Téma poradny, výběr lékaře či dalšího zdravotnického personálu a veškerá komunikace s pacienty je plně v režii společnosti uLékaře.cz."
  },
  "hrbPage": {
    "hello": {
      "title": "Sme vaším sprievodcom na ceste za zdravím",
      "items": [
        {
          "text": "Sme lekári všetkých špecializácií.",
          "icon": "doctor"
        },
        {
          "text": "Sme dostupní 24 hodín denne, 7 dní v týždni.",
          "icon": "clock"
        },
        {
          "text": "Sme tu pre vás i vašu rodinu.",
          "icon": "rodina"
        }
      ],
      "itemsVoZP": [
        {
          "text": "24 hodin denně, 7 dnů v týdnu",
          "icon": "clock"
        },
        {
          "text": "350 lékařů všech specializací",
          "icon": "prakrik"
        },
        {
          "text": "3 měsíce zdarma, dále za zvýhodněné předplatné",
          "icon": "checked"
        }
      ]
    },
    "advisory": "Poradňa",
    "order": "Sprievodca zdravím",
    "myHealth": "Na zdravie",
    "infolines": "Infolinky",
    "contact": "Kontakt",
    "registration": "Registrácia",
    "notification": {
      "title": "Od 25. - 17. novembra bude probiehať deň zdravia vo vašej firme"
    },
    "hrbArticles": {
      "title": "Buďte zdraví",
      "items": [
        {
          "icon": "shield",
          "title": "Prevencia nebolí",
          "perex": "Majte svoj život pod kontrolou vďaka pravidelnej starostlivosti o vlastné zdravie. Zistite si všetko o prevencii a jej možnostiach.",
          "linkName": "Zistiť viac",
          "link": "hrbArticles",
          "params": {
            "slug": "prevence"
          },
          "lang": "cs"
        },
        {
          "icon": "umbrella",
          "title": "Poisťovne pomáhajú",
          "perex": "Zmapovali sme príspevky a benefity všetkých 7 zdravotných poisťovní na rok 2021. Viete, čo ponúkajú?",
          "linkName": "Získať prehľad",
          "link": "hrbArticles",
          "params": {
            "slug": "pojistovny-pomahaji"
          },
          "lang": "cs"
        },
        {
          "icon": "news",
          "title": "Čítate? Čítajte!",
          "perex": "Bude ma baviť? Dozviem sa niečo nové? Dá sa mu veriť? Trikrát áno. Náš časopis je zdraviu prospešný na všetkých svojich stránkach.",
          "linkName": "Čítať časopis",
          "linkType": "external",
          "link": "https://www.ulekare.cz/novy-casopis-ulekare-cz"
        }
      ],
      "itemsVoZP": [
        {
          "icon": "shield",
          "title": "Prevence nebolí",
          "perex": "Mějte svůj život pod kontrolou díky pravidelné péči o vlastní zdraví. Zjistěte si vše o prevenci a jejích možnostech.",
          "linkName": "Zjistit víc",
          "link": "hrbArticles",
          "params": {
            "slug": "prevence"
          },
          "lang": "cs"
        },
        {
          "icon": "umbrella",
          "title": "Vyzkoušejte si nás",
          "perex": "Po dobu 3 měsíců od aktivace služby je tu pro vás uLékaře.cz neomezeně a zdarma. Následně můžete získat zvýhodněné předplatné.",
          "linkName": "Zjistit víc",
          "link": "hrbArticles",
          "params": {
            "slug": "vyzkousejte-si-nas"
          },
          "lang": "cs"
        },
        {
          "icon": "news",
          "title": "Čtete? Čtěte!",
          "perex": "Bude mě bavit? Dozvím se něco nového? Dá se mu věřit? Třikrát ano. Náš časopis je zdraví prospěšný na všech svých stránkách.",
          "linkName": "Číst časopis",
          "linkType": "external",
          "link": "https://www.ulekare.cz/novy-casopis-ulekare-cz"
        }
      ]
    },
    "serviceVideo": {
      "title": "Nikdy nemáme zatvorené a nemusíte klopať",
      "videoUrl": "https://www.youtube.com/embed/z8YK3f1GXpI"
    },
    "counseling": {
      "title": "Poradňa",
      "question": "Praktický lekár alebo pediater odpovie do 6 hodín od položenia otázky.",
      "specialist": "Vyjadrenie špecialistu získate do 72 hodín.",
      "specialistVoZP": "Vyjádření specialisty získáte do 48 hodin.",
      "order": "Ak naši odborníci odporučia osobnú návštevu lekára, objednáme vás.",
      "linkTitle": "Poradiť sa"
    },
    "ordering": {
      "title": "Objednání",
      "perex": [
        "Popíšte svoj zdravotný problém alebo uveďte, ktorého lekára hľadáte.",
        "Nájdeme vhodného odborníka vo vašom okolí.",
        "Objednáme vás na základe vašich časových možností."
      ],
      "linkTitle": "Objednať sa"
    },
    "prevention": {
      "title": "Na zdravie",
      "perex": [
        "S našim preventívnym programom predchádzate chorobám.",
        "Staráme sa, aby vaše telo i duša boli spokojné.",
        "Nasmerujeme vás, stačí uviesť niekoľko základných informácií."
      ],
      "linkTitle": "Idem do toho"
    },
    "faq": {
      "title": "Čo vás zaujíma?",
      "faqList": [
        {
          "title": "Čo je uLekára.sk?",
          "bodyText": "ANO, na vše, co se týká fyzického a duševního zdraví."
        },
        {
          "title": "Musím zmeniť svojho lekára?",
          "bodyText": "NEMUSÍTE, službu môžete využiť \"iba\" pre druhý lekársky názor."
        },
        {
          "title": "Dozvie sa niečo môj existujúci lekár?",
          "bodyText": "NEDOZVIE, vaše otázky s nikým nezdieľame. Všetko prebieha online a len medzi vami a lekárom z poradne, ktorý na  otázku odpovedá."
        },
        {
          "title": "Budem niečo platiť za využitie služby?",
          "bodyText": "NIE, za využitie lekárskej online poradne nič neplatíte. Neodpočítajú sa vám ani kredity z benefitného programu, ak ho  firma má."
        },
        {
          "title": "Môžem sa opýtať na čokoľvek?",
          "bodyText": "ÁNO, na všetko, čo sa týka fyzického a duševného zdravia."
        },
        {
          "title": "Objednávate k slovenským lekárom?",
          "bodyText": "NIE, služba uLekára.sk na Slovensku slúži výhradne na online konzultáciu vášho zdravotného stavu."
        },
        {
          "title": "V rámci online konzultácií mi odpovedá slovenský lekár?",
          "bodyText": "NIE, na vašu otázku odpovedajú predovšetkým lekári pracujúci v Českej Republike a prevažne v češtine."
        },
        {
          "title": "Ako je zaistená diskrétnosť?",
          "bodyText": "Vašu otázku, krstné meno a vek vidí iba lekár, ktorý vám odpovedá. K ďalším informáciám uvedeným v rámci Vašej  požiadavky má prístup iba zdravotnícky tím, ktorý vám odpovedá na otázku. Vaše otázky nie sú ďalej s nikým  zdieľané. V prípade, že prikladáte lekársku správu či iný dokument, odporúčame najprv začierniť viditeľné osobné  údaje a až potom prílohu nahrať k otázke, aby bola dodržaná úplná anonymita aj z Vašej strany."
        },
        {
          "title": "Na webe uLekára.sk sú ale otázky zobrazené, budú tam i moje?",
          "bodyText": "NEBUDÚ, otázky osôb, ktoré majú službu aktívnu vďaka zamestnávateľovi, a to vrátane rodinných príslušníkov, nie sú  na stránkach zverejnené."
        }
      ],
      "faqListVoZP": [
        {
          "title": "Můžu se zeptat na cokoliv?",
          "bodyText": "ANO, na vše, co se týká fyzického a duševního zdraví."
        },
        {
          "title": "Opravdu objednáváte ke všem lékařům?",
          "bodyText": "ANO, sestřičky z uLékaře.cz vás objednají k praktickému lékaři i specialistům všech oborů."
        },
        {
          "title": "Musím změnit svého lékaře?",
          "bodyText": "NEMUSÍTE, službu můžete využít i třeba jen pro získání dalšího lékařského názoru."
        },
        {
          "title": "Dozví se něco můj stávající lékař?",
          "bodyText": "NEDOZVÍ, vaše dotazy s nikým nesdílíme. Vše probíhá online a jen mezi vámi a lékařem z poradny, který na dotaz odpovídá."
        },
        {
          "title": "Budu něco platit za využití služby?",
          "bodyText": "Služba je pro vás coby pojištěnce VoZP neomezeně dostupná po dobu 3 měsíců od registrace k využívání služby. Za využití lékařské online poradny nebo objednání k lékaři tedy po tuto dobu nic neplatíte. Pro další využívání služby vám následně bude poskytnuto zvýhodněné předplatné."
        },
        {
          "title": "Budu platit něco lékaři, ke kterému mě objednáte?",
          "bodyText": "Rozhodnutí je na vás. Sestřičky objednávají do státních i nestátních zdravotnických zařízení, hledají nejvhodnějšího lékaře s ohledem na termín návštěvy a dostupnost lékaře dané odbornosti, vše podle vašich preferencí. O případné platbě budete informován/a ještě před samotnou návštěvou lékaře."
        },
        {
          "title": "Jak je zajištěna diskrétnost?",
          "bodyText": "Váš dotaz, křestní jméno a věk vidí pouze lékař, který vám odpovídá. K dalším informacím uvedeným v rámci vašeho požadavku má přístup pouze zdravotnický tým, jenž vám pomáhá s objednáním nebo zodpovídá dotaz. Vaše dotazy/objednávky nejsou dále s nikým sdíleny.<br/><br/>V případě, že přikládáte lékařskou zprávu či jiný dokument, doporučujeme nejprve začernit viditelné osobní údaje a až poté přílohu nahrát k dotazu, aby byla dodržena naprostá anonymita i z vaší strany."
        },
        {
          "title": "Na webu uLékaře.cz jsou ale dotazy zobrazeny, budou tam i moje?",
          "bodyText": "NEBUDOU, dotazy osob, které mají službu aktivní díky tomu, že jsou klienty VoZP, nejsou na stránkách zveřejněny."
        },
        {
          "title": "Je využití služby bezpečné?",
          "bodyText": "ANO, je. Služba je v souladu s obecným nařízením ochrany osobních údajů tzv. GDPR. Všechny požadavky jsou řešeny pouze mezi vámi a určenými osobami služby uLékaře.cz, případně zvoleným zdravotnickým zařízením. Zaměstnavatel dostává pouze obecný report o celkovém využití služby a kategorie řešených zdravotních problémů."
        }
      ]
    },
    "employeeStories": {
      "title": "Príbehy z našej poradne",
      "stories": [
        {
          "name": "Pomohol druhý lekársky názor",
          "perex": "Mamička 7-ročného chlapca si v našej poradni overovala správnosť postupu liečby ošetrujúcej kožnej lekárky, ku ktorej dochádzajú. Jej syna dlhodobo trápila urputná vyrážka, na ktorú nezaberala doterajšia liečba. Bol mu preto predpísaný liek na predpis, o ktorom sa žena pri vyzdvihnutí v lekárni dozvedela, že je určený dospelým. Vďaka tomu, že priložila fotografiu postihnutého miesta, mohla lekárka v našej poradni potvrdiť existujúcu diagnózu aj vhodnosť zvolenej liečby."
        },
        {
          "name": "Spadol jej kameň zo srdca",
          "perex": "Jednej z našich užívateliek jej gynekológ oznámil diagnózu v podobe dvoch skratiek a bez ďalšieho vysvetlenia ju poslal na ďalšie vyšetrenia. Ženu okamžite ovládol strach, že sa za tými strašidelne znejúcimi skratkami skrýva prízrak rakoviny. Lekári z našej poradne ju obaja zhodne upokojili, že sa jedná o prednádorový stav, ktorý je pomerne častý a automaticky neznamená, že trpí onkologickým ochorením. To by muselo potvrdiť ďalšie vyšetrenie. Žena zareagovala s pocitmi vďačnosti a slovami, že \"jej spadol zo srdca veľký kameň\"."
        },
        {
          "name": "Z našej poradne zamieril rovno k lekárovi",
          "perex": "Mladý muž sa na našu poradňu obrátil s otázkou na posúdenie znamienka na bruchu, ktoré sa mu \"nepozdávalo\", pripojil fotografiu daného znamienka a uviedol jeho približné rozmery. Špecialisti v našej poradni len zo snímky síce nemohli určiť jeho povahu, ale bolo z neho dostatočne zrejmé, že znamienko vykazuje istú asymetriu a nerovnosť okrajov. Na základe bezodkladného odporúčania absolvovať špecializované vyšetrenie, bol tento muž objednaný našou sestričkou na najbližší možný termín na dermatológiu v mieste bydliska."
        }
      ]
    },
    "contactUs": {
      "title": "Klientská podpora",
      "subTitle": "Neviete si rady? Potrebujete pomôcť s vyplnením formulára?"
    },
    "covidLink": {
      "title": "Covid infolinka",
      "callUs": "Volajte:",
      "hours": "Po–Pá 8:00–17:00",
      "tooltip": {
        "title": "S čím vám môžeme poradiť?",
        "text": [
          "Príznaky ochorenia",
          "Rizikové skupiny",
          "Koronavírus a tehotenstvo",
          "Testovanie",
          "Preventívne a hygienické opatrenia"
        ]
      }
    },
    "asistLink": {
      "title": "SOS psychická pomoc",
      "subtitle": "Psychologické, právní a finanční poradenství",
      "email": "info@e-a.cz",
      "phone": "+421 950 105 650"
    }
  },
  "hrbPageInactive": {
    "title": "Ľutujeme, služba už nie je dostupná.<br/>Ak máte záujem službu opäť využívať, požiadajte svoje HR/personálne oddelenie.",
    "subtitle": "Službu uLekára.sk môžete využívať súkromne.",
    "getHelp": "Poradiť sa"
  },
  "authorization": {
    "title": "Aktivácia služby",
    "subtitle": "Aby ste mohli začať službu využívať, zadajte svoj firemný e-mail alebo kód, ktorý ste dostali od zamestnávateľa. Ďalej postupujte podľa pokynov.",
    "subtitleEmail": "Aby ste mohli začať službu využívať, zadajte svoj firemný e-mail, ktorý ste obdržali od zamestnávateľa. Ďalej postupujte podľa pokynov.",
    "subtitleCode": "Aby ste mohli začať službu využívať, zadajte kód, ktorý ste obdržali od zamestnávateľa. Ďalej postupujte podľa pokynov.",
    "emailLabel": "E-mail",
    "codeLabel": "Kód",
    "codeHrbError": "Neplatný kód",
    "codeLengthError": "Nesprávny formát. Kód musí obsahovať 2-20 znakov.",
    "or": "alebo",
    "contactTitle": "Neviete si rady?",
    "sendMessage": "Žiadosť na využitie služby uLekára.sk sme odoslali na <strong class='text-primary'>{email}</strong>. Schválenie žiadosti vykonáte kliknutím na odkaz v e-maile.",
    "changeEmail": "Zmeniť e-mail",
    "final": {
      "thankYouTitle": "Aktivácia služby",
      "thankYouSubtitle": "Všetko je nastavené.",
      "infoHeading": "Skvelé! Aktivácia bola úspešná.",
      "infoText": "Užite si svoju službu zadarmo\nnaplno už dnes."
    }
  },
  "checkToken": {
    "generateToken": "Zaslať nový odkaz",
    "expired": {
      "title": "Odkazu vypršala platnosť",
      "perex": "Z bezpečnostných dôvodov majú odkazy obmedzenú platnosť. Skúste si nechať zaslať odkaz nový."
    },
    "invalid": {
      "title": "Odkaz je už neplatný",
      "perex": "Zadaný odkaz už nefunguje. Môže to byť jeho použitím alebo zmenou podmienok."
    },
    "tokenCreated": {
      "title": "Odkaz bol odoslaný.",
      "perex": "Na váš firemný e-mail sme vám zaslali nový odkaz. Aktiváciu dokončíte kliknutím na tento odkaz v e-maile."
    }
  },
  "confirmation": {
    "title": "Potvrdenie e-mailu",
    "subtitle": "Kliknite na odkaz poslaný na e-mail <strong class='text-primary'>{email}</strong> a tým potvrdíte e-mail pre komunikáciu so službou uLekára.sk."
  },
  "hrbRegistration": {
    "title": "Registrace do poradny",
    "perex": "Prevence je důležitou součástí péče o vlastní zdraví. Díky ní můžete už dnes předcházet zdravotním potížím a onemocněním. Rádi vám s tím pomůžeme.",
    "firstSection": "Zaregistrujte se prostřednictvím online formuláře a neomezeně využívejte služby uLékaře.cz.<br/><br/>Jako klient VoZP získáte službu na 3 měsíce zdarma.",
    "checkToken": {
      "error": {
        "title": "Litujeme, ale vaši registraci nebylo možné potvrdit.",
        "subtitle": "Odkaz pro potvrzení je neplatný nebo jeho platnost vypršela. Jděte prosím na stránku <a href=\"https://kp.vozp.cz\">kp.vozp.cz</a> a znovu klikněte na registrační odkaz v klientském portálu."
      }
    },
    "success": {
      "header": "Registrace dokončena",
      "title": "Registrace proběhla úspěšně.",
      "subtitle": "Dále je třeba potvrdit odkaz zaslaný na váš e&#8209;mail <strong class=\"text-primary\">{email}</strong>. Dokončete prosím aktivaci kliknutím na tento odkaz v e&#8209;mailu."
    },
    "unfinishedRegistration": {
      "title": "Pro dokončení registrace je nutné ověřit váš e-mail.",
      "subtitle": "Prosíme o ověření e-mailu pro komunikaci se službou uLékaře.cz. Potvrďte odkaz zaslaný na e-mail."
    },
    "header": {
      "registrationForm": "Registrace",
      "faq": "Časté dotazy"
    },
    "infoList": [
      {
        "text": "<strong>Lékařská online poradna</strong><br/>Naši praktičtí lékaři a specialisté vám poradí v otázkách zdraví. Zeptat se můžete na cokoliv, co vás v souvislosti se zdravím trápí. Odpověď praktického lékaře obdržíte do 6 hod. od položení dotazu, návazné vyjádření specialisty do 48 hod.",
        "icon": "checked"
      },
      {
        "text": "<strong>Objednání k lékaři</strong><br/>Doporučí-li vám naši odborníci osobní návštěvu lékaře, náš zdravotní tým se o vše potřebné postará. Službu objednání můžete využít i samostatně (bez položení dotazu). Objednáváme po celé ČR, místo a termín objednání se odvíjí od vašeho přání.",
        "icon": "checked"
      },
      {
        "text": "<strong>Prevence</strong><br/>Prostřednictvím e-mailových zdravotních výzev vás budeme informovat o novinkách v prevenci a posílat vám inspirativní návody, jak o své celkové zdraví co nejlépe pečovat. V rámci využití naší služby připravujeme také speciální preventivní nabídky.",
        "icon": "checked"
      }
    ]
  },
  "hrbForm": {
    "title": "Využite službu uLekára.sk",
    "problem": {
      "text": "Napíšte, ako sa zdravotný problém prejavuje a ako dlho trvá.",
      "placeholder": "Čím viac informácií nám poskytnete, tým presnejšiu dostanete odpoveď od lekára.",
      "errorText": "Vyplňte, prosím, toto pole."
    },
    "help": {
      "text": "Na čo sa našich lekárov chcete opýtať?",
      "placeholder": "Položte lekárovi otázku.",
      "errorText": "Vyplňte, prosím, toto pole."
    },
    "medication": {
      "text": "Uveďte ďalšie informácie týkajúce sa vášho zdravotného stavu.",
      "placeholder": "Napr. s ktorými ďalšími chorobami sa liečite, ktoré lieky beriete pravidelne, či máte nejaké alergie a aké sú výsledky vyšetrenia.",
      "errorText": "Vyplňte, prosím, toto pole."
    },
    "order": {
      "question": {
        "text": "Aké ťažkosti riešite? Ako vám môžeme pomôcť?",
        "placeholder": "K akému lekárovi potrebujete objednať?",
        "errorText": "Vyplňte, prosím, toto pole."
      }
    },
    "agreements": {
      "iAgree": "Odoslaním formulára súhlasím s ",
      "conditions": "Podmienkami používania",
      "service": "služby uLekára.sk."
    },
    "thankYou": {
      "question": {
        "title": "Ďakujeme. Vaša otázka bola odoslaná.",
        "perex": "Otázku teraz odovzdáme lekárovi a ten na ňu zareaguje.<br/> Odpoveď dostanete v e-maile.",
        "button": "Nová otázka"
      },
      "appointment": {
        "title": "Ďakujeme. Vaša požiadavka bola prijatá.",
        "perex": "Počkajte, prosím, na telefonát zdravotnej sestry",
        "button": "Nová objednávka"
      },
      "prevention": {
        "title": "Vaša registrácia do preventívneho programu uLekára.sk prebehla úspešne.",
        "content": {
          "start": "Na vašom zdraví nám záleží. Pomôžeme vám sa o neho lepšie starať a predchádzať tak chorobám a vážnym zdravotným problémom.",
          "list": [
            "Prostredníctvom e-mailových preventívnych výziev vám budeme pravidelne zasielať tipy, ako posilňovať svoje zdravie aj ktoré preventívne prehliadky a príspevky ponúkané vašou zdravotnou poisťovňou si nenechať ujsť.",
            "Vďaka našim zdravotným výzvam a informáciám budete mať vždy aktuálny prehľad, ako sa starať o seba aj svojich blízkych. Všetok obsah pritom pripravujeme v spolupráci s odborníkmi na dané témy.",
            "V príprave sú aj inšpiratívne články a videá, a najmä kalendár prehliadok a očkovaní pre vaše osobné využitie.",
            "V přípravě jsou také inspirativní články i videa a zejména kalendář prohlídek a očkování pro vaše osobní využití."
          ],
          "questionnaire": {
            "start": "Chcete zistiť, ako ste na tom s prevenciou vo svojom živote a zároveň nám tým pomôcť v príprave ďalších častí preventívneho programu na mieru vašim potrebám?",
            "middle": "Stačí vyplniť jednoduchý dotazník s 10 otázkami:",
            "link": "https://www.survio.com/survey/d/X7L8A2K3B4U9R5I0G"
          },
          "thankYou": "Ďakujeme.<br/><br/>Tím uLekára.sk"
        }
      },
      "registrationVoZP": {
        "title": "Vaše registrace k užívání služby uLékaře.cz proběhla úspěšně.",
        "content": {
          "start": "Na vašem zdraví nám záleží. Pomůžeme vám o něj lépe pečovat a předcházet tak nemocem a vážným zdravotním potížím. Jako klient VoZP můžete službu využívat neomezeně po zkušební dobu 3 měsíců, následně vám bude nabídnuto zvýhodněné předplatné.",
          "list": [
            "Nyní můžete v naší poradně položit jakýkoliv dotaz týkající se vašeho zdravotního stavu. Vždy vám odpoví praktický lékař a následně specialista.",
            "Naše zdravotní sestry vám mohou pomoci s vyhledáním lékaře kterékoliv specializace na základě vašeho přání.",
            "Prostřednictvím e-mailových preventivních výzev vám budeme pravidelně zasílat tipy, jak posilovat své zdraví či které preventivní prohlídky si nenechat ujít.",
            "Díky našim zdravotním výzvám a informacím budete vždy mít aktuální přehled, jak se starat o sebe i své blízké. Veškerý obsah přitom připravujeme ve spolupráci s odborníky na daná témata.",
            "V následujících měsících na webu přibude možnost objednání na preventivní prohlídky a vyšetření a také tematická poradna, která vám umožní zeptat se na vše, co vás v souvislosti s prevencí zajímá. Zároveň vás k lékaři rádi objednáme.",
            "V přípravě jsou také inspirativní články i videa a zejména kalendář prohlídek a očkování pro vaše osobní využití."
          ],
          "questionnaire": {
            "start": "Chcete zjistit, jak na tom s prevencí ve svém životě jste a zároveň nám tím pomoci v přípravě dalších částí preventivního programu na míru vašim potřebám?",
            "middle": "Stačí vyplnit jednoduchý dotazník s 10 otázkami:",
            "link": "https://www.survio.com/survey/d/X7L8A2K3B4U9R5I0G"
          },
          "thankYou": "Děkujeme.<br/><br/>Tým uLékaře.cz"
        }
      }
    }
  },
  "masterCardFAQ": {
    "title": "Časté otázky a odpovede k službe uLekára.sk",
    "perex": "Možno aj&nbsp;vás napadajú otázky súvisiace s&nbsp;využitím služby lekárskej online poradne. Ponúkame vám odpovede na najčastejšie z&nbsp;nich.",
    "list": [
      {
        "title": "Môžem sa opýtať na čokoľvek?",
        "bodyText": "ÁNO, na všetko, čo sa týka fyzického a&nbsp;duševného zdravia."
      },
      {
        "title": "Skutočne objednávate ku všetkým lekárom?",
        "bodyText": "ÁNO, sestričky z&nbsp;uLékaře.cz vás objednajú k&nbsp;praktickému lekárovi aj&nbsp;špecialistom všetkých odborov."
      },
      {
        "title": "Musím zmeniť svojho lekára?",
        "bodyText": "NEMUSÍTE, službu môžete využiť aj napríklad len pre získanie ďalšieho lekárskeho názoru."
      },
      {
        "title": "Dozvie sa niečo môj existujúci lekár?",
        "bodyText": "NEDOZVIE, vaše otázky s&nbsp;nikým nezdieľame. Všetko prebieha online a&nbsp;len medzi vami a&nbsp;lekárom z&nbsp;poradne, ktorý na otázku odpovedá."
      },
      {
        "title": "Budem niečo platiť za využitie služby?",
        "bodyText": "NIE, za využitie lekárskej online poradne alebo objednanie k&nbsp;lekárovi nič neplatíte. Nárok na využitie služby zadarmo získate, ak ste držiteľom prémiovej či firemnej karty Mastercard<sup>®</sup>.<br/><br/><strong>Prémiové karty:</strong><ul><li>Mastercard<sup>®</sup> Gold</li><li>Mastercard<sup>®</sup> Platinum</li><li>Mastercard<sup>®</sup> World</li><li>Mastercard<sup>®</sup> World Elite</li></ul><strong>Firemné karty:</strong><ul><li>Mastercard<sup>®</sup> Business</li><li>Mastercard<sup>®</sup> Corporate</li></ul>"
      },
      {
        "title": "Budem platiť niečo lekárovi, ku ktorému ma objednáte?",
        "bodyText": "Rozhodnutie je na vás. Sestry objednávajú do štátnych i&nbsp;neštátnych zdravotníckych zariadení, hľadajú najvhodnejšieho lekára s&nbsp;ohľadom na termín návštevy a&nbsp;dostupnosť lekára danej odbornosti, všetko podľa vašich preferencií. O&nbsp;prípadnej platbe budete informovaný/á ešte pred samotnou návštevou lekára."
      },
      {
        "title": "Ako je zaistená diskrétnosť?",
        "bodyText": "Vaša otázka, krstné meno a&nbsp;vek vidí iba lekár, ktorý vám odpovedá. K&nbsp;ďalším informáciám uvedeným v&nbsp;rámci vašej požiadavky má prístup iba zdravotnícky tím. Vaše otázky nie sú ďalej s&nbsp;nikým zdieľané.<br/><br/> V&nbsp;prípade, že prikladáte lekársku správu či iný dokument, odporúčame najprv začierniť viditeľné osobné údaje a&nbsp;až potom prílohu nahrať k&nbsp;otázke, aby bola dodržaná úplná anonymita aj&nbsp;z&nbsp;vašej strany."
      },
      {
        "title": "Na webe uLekára.sk sú ale otázky zobrazené, budú tam aj moje?",
        "bodyText": "NEBUDÚ, otázky držiteľov prémiovej či firemnej karty Mastercard<sup>®</sup> nie sú na stránkach zverejňované."
      },
      {
        "title": "Je využitie služby bezpečné?",
        "bodyText": "ÁNO, je. Služba je v&nbsp;súlade so&nbsp;všeobecným nariadením ochrany osobných údajov tzv.&nbsp;GDPR. Všetky požiadavky sú riešené len medzi vami a&nbsp;určenými osobami služby uLekára.sk, prípadne zvoleným zdravotníckym zariadením."
      }
    ]
  },
  "preventionForm": {
    "title": "Povedzte nám o sebe viac",
    "subtitle": "Ak by naši lekári usúdili, že je potrebné váš zdravotný problém riešiť návštevou lekára, potrebujeme o vás poznať ďalšie informácie.",
    "birthDate": {
      "title": "Dátum narodenia",
      "helpText": "Dátum narodenia uveďte v tvare deň, mesiac, rok, napr. 21.1.1999",
      "errorText": "Vyplňte dátum narodenia.",
      "errorTextDate": "Dátum narodenia nie je v správnom formáte.",
      "errorTextBirthDateRange": "Uveďte správny dátum narodenia."
    },
    "gender": {
      "title": "Pohlavie",
      "selectGender": "Vyberte pohlavie",
      "errorText": "Vyberte pohlavie.",
      "male": "Muž",
      "female": "Žena",
      "other": "Iné"
    },
    "language": {
      "title": "Jazyk",
      "selectLanguage": "Vyberte jazyk pre komunikáciu",
      "errorText": "Vyberte jazyk pre komunikáciu."
    },
    "preventiveCheckUp": {
      "title": "Preventívne prehliadky a očkovanie",
      "examinationTitle": "Prosím, vyberte <strong>zdravotné prehliadky</strong>, ktoré ste absolvovali (nepovinné):",
      "examinationDate": "Kedy ste vyšetrenie naposledy absolvoval?",
      "vaccinationDate": "Kedy ste očkovanie naposledy absolvoval/a?",
      "examinationsSubtitle": "Boli súčasťou poslednej kontroly tieto vyšetrenia?",
      "vaccinationTitle": "Prosím, vyberte <strong>očkovanie</strong>, ktoré ste absolvovali (nepovinné):",
      "nameExamination": "Názov vyšetrenia",
      "examinationSelectBtn": "Vyberte zdravotné prehliadky zo zoznamu",
      "vaccinationSelectBtn": "Vyberte očkovanie zo zoznamu.",
      "dateRange": {
        "range_1": "Tento rok",
        "range_2": "Vlani",
        "range_3": "Predvlani",
        "range_4": "Nepamätám si",
        "range_5": "Nikdy"
      },
      "otherTitle": "Názov vyšetrenia",
      "selectYear": "Zadajte rok",
      "iAmNotSure": "Nepamätám si"
    },
    "address": {
      "title": "Adresa (nepovinné)",
      "placeholder": "Zadajte polohu"
    },
    "registeredModal": {
      "title": "Ďakujem",
      "subtitle": "Vaša registrácia do preventívneho programu už prebehla."
    }
  },
  "ulekareContacts": {
    "email": "info@ulekara.sk",
    "phone": "+421&nbsp;950&nbsp;105&nbsp;650",
    "hours": "Po–Pi 8–17&nbsp;h"
  },
  "authorizationPage": {
    "title": "Autorizácia prebehla úspešne",
    "successText": "Úspešne sme overili, že máte nárok na službu zadarmo.",
    "prevention": {
      "title": "Ďakujeme. Autorizácia prebehla úspešne.",
      "subtitle": "Kliknite na odkaz zaslaný na e-mail <strong class=\"text-primary\">{email}</strong>."
    }
  },
  "verification": {
    "title": "Prihlásenie k preventívnemu programu prebehla úspešne.",
    "subtitle": "Ďakujeme za overenie e-mailu."
  },
  "errorModal": {
    "title": "Ajaj, táto stránka sa teraz necíti dobre",
    "subtitle": "<p>Zdá sa, že na našej strane došlo k technickému problému.</p>\n\n<p><strong>Čo môžete skúsiť:</strong></p>\n<ul>\n  <li>Obnovte stránku pomocou Ctrl + F5 (Windows) alebo Cmd + Shift + R (macOS).</li>\n  <li>Odhláste sa a znovu prihláste.</li>\n</ul>\n<br/>\n<p>Nepomohlo to? Otvorte stránku v anonymnom (súkromnom) okne prehliadača.</p>",
    "errorCodeReference": "V komunikácii, prosím, uveďte nasledujúci chybový kód:"
  },
  "renewPassword": {
    "title": "Obnovenie hesla",
    "subtitle": "Vytvorte si nové heslo k účtu. Odporúčame vytvoriť si silnejšie heslo, ktoré obsahuje aspoň jedno číslo a jedno písmeno.",
    "setPassword": "Vytvorte heslo",
    "setPasswordAgain": "Zadajte heslo znova",
    "newPassword": "Nové heslo",
    "changePassword": "Zmeniť heslo",
    "minLengthError": "Heslo musí mať minimálne 5 znakov.",
    "requiredErrorText": "Pole je povinné",
    "generatedError": {
      "start": "Heslo musí",
      "minLength": "mať minimálnu dĺžku {length} znakov",
      "and": "a",
      "require": "obsahovať",
      "oneChar": "písmeno",
      "oneNumber": "číslo",
      "specialChar": "špeciálny znak"
    },
    "sameAsPasswordErrorText": "Heslá sa nezhodujú.",
    "successMessage": "Heslo bolo úspešne zmenené.",
    "invalidToken": {
      "title": "Odkaz nie je platný.",
      "perex": "Vygenerujte si nový odkaz kliknutím na \"zabudnuté heslo\" v mobilnej aplikácii uLékaře.cz."
    },
    "usedToken": {
      "perex": "Tento odkaz už nie je platný, pretože už bol raz použitý."
    },
    "expiredToken": {
      "title": "Odkazu vypršala platnosť.",
      "perex": "Vygenerujte si nový odkaz kliknutím na \"zabudnuté heslo\" v mobilnej aplikácii uLékaře.cz."
    },
    "nextButton": "Přihláste sa do {service}"
  },
  "emailVerification": {
    "successMessage": "Email overený",
    "successMessagePerex": "Váš e-mail sme úspešne overili. Môžete sa prihlásiť.",
    "button": "Pokračujte na {service}",
    "invalidToken": "Odkaz nie je platný.",
    "usedToken": "Tento odkaz už nie je platný, pretože už bol raz použitý.",
    "expiredToken": "Odkazu vypršala platnosť."
  },
  "partnerNavigation": {
    "hello": {
      "title": "Ako začať využívať službu uLekára.sk",
      "items": [
        {
          "icon": "compass",
          "text": "Prihláste sa alebo si založte účet."
        },
        {
          "icon": "glasses",
          "text": "Následne môžete začať využívať našu službu."
        }
      ]
    },
    "helloHrb": {
      "title": "Využite službu uLekára.sk.",
      "items": [
        {
          "icon": "compass",
          "text": "Nájdite svojho zamestnávateľa podľa názvu firmy."
        },
        {
          "icon": "glasses",
          "text": "Vyberte službu, ktorú chcete využiť."
        }
      ]
    },
    "partnerSignpost": {
      "title": " ",
      "subtitle": "Kto hradí službu?",
      "text": "Službu môžete mať zadarmo ako benefit od svojho zamestnávateľa, mesta, kartovej spoločnosti, neziskovej organizácie a ďalších firiem. Pokiaľ si nie ste istý, skúste vyhľadávač v záložke \"Iný benefit\"."
    },
    "tabs": [
      "Iný benefit",
      "Mastercard<sup>®</sup>"
    ],
    "employer": {
      "title": "Nájdite svojho zamestnávateľa podľa názvu.",
      "searchPlaceholder": "Zadajte názov firmy"
    },
    "results": {
      "noResultStart": "Váš zamestnávateľ tu nie je?",
      "noResultContact": "Kontaktujte nás",
      "noResultMiddle": "alebo si",
      "noResultReadMore": "prečítajte o službe viac",
      "noResultEnd": "."
    },
    "partnerTypes": [
      {
        "boxTitle": "Mám službu od zamestnávateľa"
      },
      {
        "prominence": "regular",
        "buttonText": "Vybrať",
        "title": "Kliknite na logo svojej poisťovne.",
        "boxTitle": "Mám službu od poisťovne",
        "partnerGtmAction": "Klik Přechod na pojišťovnu",
        "boxes": [
          {
            "gtmLabel": "VoZP",
            "isExternalLink": "true",
            "image": "partner-vozp.png",
            "link": "kp.vozp.cz"
          },
          {
            "gtmLabel": "OZP",
            "isExternalLink": "true",
            "image": "partner-ozp.png",
            "link": "www.ozp.cz/vkol"
          }
        ]
      },
      {
        "prominence": "prominent",
        "buttonText": "Prejsť na službu",
        "title": "Kliknite na logo pre využitie služby uLekára.sk.",
        "boxTitle": "Mám službu od Mastercard",
        "partnerGtmAction": "Klik Mastercard box",
        "boxes": [
          {
            "gtmLabel": "Mastercard",
            "isExternalLink": "false",
            "image": "logos/mc_logo.png",
            "link": {
              "name": "hrbPage",
              "params": {
                "partnerUrl": "mastercard"
              }
            }
          }
        ]
      },
      {
        "prominence": "regular",
        "buttonText": "Vybrať",
        "title": "Kliknite na logo svojho partnera.",
        "boxTitle": "Mám službu ako benefit",
        "partnerGtmAction": "Klik Přechod na partnera",
        "boxes": [
          {
            "gtmLabel": "Fairsurence",
            "image": "partner-fairsurence.png",
            "isExternalLink": "false",
            "link": {
              "name": "hrbPage",
              "params": {
                "partnerUrl": "spolekpromaterstvi"
              }
            }
          }
        ]
      }
    ],
    "video": {
      "title": "Nikdy nemáme zatvorené a nemusíte klopať."
    }
  },
  "unsupportedBrowser": {
    "title": "Váš prehliadač nie je podporovaný",
    "perex": "Ľutujeme, ale momentálne používate starší internetový prehliadač, ktorý nie je našou službou plne podporovaný, teda nie je možné službu naplno využiť. Pre využitie služby, prosíme použite jeden z nasledujúcich podporovaných prehliadačov, prípadne vykonajte aktualizáciu."
  },
  "login": {
    "banner": {
      "title": "Vaše dáta zostanú v bezpečí.",
      "subtitle": "Neustále zlepšujeme naše služby, aby vaše dáta boli len vaše. To je naša priorita."
    },
    "socials": {
      "facebook": "Prihlásiť sa cez Facebook",
      "google": "Prihlásiť sa cez Google",
      "apple": "Prihlásiť sa cez Apple"
    },
    "title": "Prihlásiť sa",
    "subtitle": "Na využitie služieb uLekára.sk sa prihláste",
    "loginError": "Neplatné prihlasovacie údaje. Skúste to znova.",
    "forgetPassword": "Zabudnuté heslo?",
    "password": {
      "title": "Heslo",
      "requiredError": "Heslo je povinné"
    },
    "remember": "Zapamätať užívateľa",
    "login": "Prihlásiť sa",
    "noAccount": "Ešte nemáte účet?",
    "registration": "Zaregistrujte sa.",
    "registrationHeaderButton": "Zaregistrujte sa"
  },
  "registration": {
    "title": "Registrácia",
    "subtitleFirstStep": "Na využitie služieb uLekára.sk je nutné sa registrovať",
    "subtitle": "Uvedené údaje slúžia pre komunikáciu so zdravotným týmom uLekára.sk.",
    "addData": {
      "title": "Doplnenie údajov",
      "subtitle": "Vaše prihlásenie je úspešné, ale potrebujeme aktualizovať údaje na komunikáciu zo zdravotným týmom uLekára.sk"
    },
    "emailError": "E-mail už máte v uLekára.sk registrovaný.",
    "email": {
      "errorEmailNotExisting": "Vyplňte existujúcu e-mailovú adresu.",
      "errorInvalidDomain": "Nepovolené email doména, použite iný email.",
      "errorText": "Chýba e-mail.",
      "title": "Osobný e-mail"
    },
    "socials": {
      "facebook": "Registrovať cez Facebook",
      "google": "Registrovať cez Google",
      "apple": "Registrovať cez Apple"
    },
    "loginText": {
      "link": "Prihláste sa",
      "suffix": ", prosím.",
      "question": "E-mail bol už pre registráciu použitý."
    },
    "login": {
      "text": "Už máte účet?",
      "link": "Prihláste sa."
    },
    "finishRegistration": "Dokončiť registráciu",
    "legal": {
      "text": "Súhlasím s {termsAndConds}.",
      "termsConditions": "podmienkami užitia",
      "privacyPolicy": "Zásadami ochrany osobných údajov."
    }
  },
  "missingProfileData": {
    "title": "Doplnenie údajov",
    "titleLegal": "Potvrdenie súhlasov",
    "text": "Z prepojeného účtu sa nám nepodarilo získať vašu e-mailovú adresu, ktorú potrebujeme na poskytnutie našich služieb. Doplňte ju prosím nižšie.",
    "textLegal": "Potvrďte, prosím, nasledujúce:"
  },
  "phoneVerification": {
    "title": "Overenie telefónneho čísla",
    "subtitle": "Na vaše telefónne číslo {phone} sme zaslali overovací kód v SMS. Zadajte ho prosím nižšie.",
    "label": "Kód z SMS",
    "changeNumber": "Zmeniť číslo",
    "inputError": "Kód je povinný",
    "codeError": "Zadaný kód nie je platný. Potrebujete poradiť?",
    "sendAgain": "Poslať kód znova",
    "verify": "Overiť",
    "error": {
      "error_timeout": {
        "title": "Počkajte prosím na overovaciu SMS",
        "perex": "Zaznamenali sme opakované požiadavky na zmenu telefónneho čísla. Prosím počkajte, aby sme predišli odoslaniu veľkého počtu správ."
      },
      "error_block": {
        "title": "Váš učet bol dočasne zablokovaný",
        "perex": "Overenie telefónneho čísla bolo pozastavené kvôli podozrivej aktivite. Z bezpečnostných dôvodov sme váš účet dočasne zablokovali. Obráťte sa prosím na našu zákaznícku starostlivosť",
        "callUs": "Zavolajte nám",
        "writeUs": "Napíšte nám"
      }
    }
  },
  "phoneChange": {
    "title": "Zmena telefónneho čísla",
    "sendCode": "Poslať kód"
  },
  "lostPassword": {
    "title": "Zabudnuté heslo",
    "subtitle": "Odkaz pre obnovenie hesla dostanete v případe, že ste týmto e-mailom registrovaný na našom webe alebo v mobilnej aplikácií.",
    "button": "Obnoviť heslo.",
    "linkSentTitle": "Odoslané",
    "linkSentPerex": "E-mail pre obnovenie hesla bol odoslaný na {email}. Pokiaľ ho vo svojom e-maile nenájdete, pozrite sa do zložky „SPAM“.",
    "sendLinkAgain": "Poslať e-mail znova",
    "finishRegistration": "Dokončiť registráciu"
  },
  "profileSection": {
    "menu": {
      "profile": "Môj účet",
      "subscription": "Predplatné",
      "logout": "Odhlásiť sa"
    },
    "badge": {
      "self": "samoplatiteľ",
      "premium": "hradené"
    },
    "freeService": {
      "title": "Služba zadarmo",
      "text": "Služba je často hradená partnermi, zamestnávateľmi a poisťovňami.",
      "button": "Mám nárok?"
    },
    "thankYou": "Službu vám hradí {partnerName}",
    "thankYouPartly": "Na službu vám přispívá {partnerName}",
    "thankYouSelf": "Službu si hradíte samostatne",
    "thankYouHost": "Službu zadarmo zdieľa {host}"
  },
  "dashboard": {
    "menu": {
      "home": "Prehľad",
      "questions": "Poradňa",
      "appointments": "Požiadavky",
      "prevention": "Prevencia",
      "explore": "Objavujte"
    },
    "personalInfoAssurance": {
      "prefix": "Ako s vami budeme komunikovať?",
      "email": "E-mail",
      "phone": "Telefón"
    },
    "deactivatedUser": "<strong>Váš účet bol deaktivovaný.</strong> <span class=\"black--text\">Ak sa domnievate, že neoprávnene, kontaktujte nás: <a href=\"mailto:{email}\">{email}</a> alebo tel. {phone}.</span>",
    "title": "Zdravíme vás! 👋",
    "subtitle": "Ako vám môžeme pomôcť?",
    "needAdvice": "Napísať otázku",
    "needAppointment": "Chcem zadať požiadavku",
    "needHelp": "Potrebujete poradiť?",
    "supportBox": {
      "openTitle": "Dôležité kontakty",
      "title": "Zákaznícka podpora",
      "boxText": "Sme tu pre vás, nech už potrebujete pomoc s čímkoľvek",
      "chat": {
        "title": "Zákaznický chat",
        "textOnline": "Sme online <br /> Nech už máte akúkoľvek otázku alebo problém, ktorý nie je medicínsky. Sme tu pre vás.",
        "textOffline": "Sme offline <br /> Sme online od 8:00 do 17:00 (Po-Pia)",
        "button": "Spustit chat",
        "icon": "chat"
      },
      "customerService": {
        "title": "Zákaznická linka",
        "subtitle": "8:00 - 17:00 (Po-Pia)",
        "buttonEmail": {
          "text": "info@ulekara.sk",
          "subtitle": "Kontaktný e-mail:"
        },
        "buttonPhone": {
          "text": "+421 950 105 650",
          "subtitle": "Platená linka:"
        },
        "linkEmail": "mailto:info@ulekara.sk",
        "linkPhone": "tel:+421 950 105 650",
        "icon": "care",
        "tescoButtonPhone": {
          "text": "+421 800 232 007",
          "subtitle": "Bezplatná linka:"
        },
        "tescoLinkPhone": "tel:+421 800 232 007",
        "tescoButtonPhonePaid": "Platená linka  +421 950 105 650",
        "tescoLinkPhonePaid": "tel:+421 950 105 650"
      },
      "assistanceService": {
        "title": "SOS psychická pomoc",
        "subtitle": "Psychologické poradenstvo",
        "buttonEmail": "info@e-a.cz",
        "buttonPhone": "+421 950 105 650",
        "linkEmail": "mailto:info@e-a.cz",
        "linkPhone": "tel:+421 950 105 650",
        "icon": "happy"
      },
      "covidService": {
        "title": "Covid infolinka",
        "subtitle": "8:0017–:00 (Po–Pá)",
        "button": "+421 950 105 650",
        "linkEmail": "mailto:info@e-a.cz",
        "linkPhone": "tel:+421 950 105 650",
        "icon": "lungs"
      },
      "unavailableOn": "Upozorňujeme, že zákaznícka podpora a služba sprievodca zdravím budú v deň {date} k dispozícii v obmedzenom režime. Vysporiadanie zaslaných požiadaviek sa môže oneskoriť. V prípade všeobecných otázok nám prosím napíšte na uvedenú e-mailovú adresu. \nĎakujeme za pochopenie.",
      "outageActive": "false",
      "outageDateISO": "2026-04-09"
    },
    "freeService": "Mám službu zadarmo?",
    "requestSent": "Dokončite aktiváciu v pracovnom e-maile",
    "hint": {
      "subtitle": "chirurg, spoluzakladateľ uLekára.sk",
      "text": "„Vybavte si všetko rýchlo v pohodlí svojho domova alebo z pracoviska.<br/>Potrebujete poradiť? Rád vám pomôžem ja alebo niekto z mojich 350 kolegov.\"",
      "linkText": "Chci&nbsp;se&nbsp;poradit"
    },
    "questions": {
      "myQuestions": "Moje otázky",
      "updated": "Máme pre vás odpoveď!",
      "resolvers": "Starajú sa o vás",
      "sla": "Odpovieme už do <strong class=\"black--text\">{hour}</strong> h."
    },
    "appointments": {
      "myAppointments": "Moje požiadavky"
    },
    "labTests": {
      "draft": "Vyberte termín a místo odběru",
      "new": "Vaše odběry zpracovává laboratoř.",
      "done": "Máme interpretaci vašich krevních testů!"
    },
    "videoCall": {
      "buttonText": "Naplánovať videohovor",
      "buttonTextMobile": "Videohovor"
    },
    "services": {
      "question": {
        "title": "Poradňa (24/7)",
        "subtitle": "s&nbsp;odpoveďou do&nbsp;{hours}&nbsp;h",
        "b2cSufix": "za&nbsp;{priceCzk}&nbsp;Kč (cca&nbsp;{priceEur}&nbsp;€)",
        "text": "Praktickí lekári a špecialisti sú tu pre vás na jednom mieste.",
        "button": "Potrebujem poradiť"
      },
      "videoCall": {
        "title": "Videohovor",
        "subtitle": "s lekárom",
        "text": "Lekári sa vám na videohovore venujú až 20 minút vo vami vybraný čas.",
        "button": "Naplánovať videohovor"
      },
      "appointment": {
        "title": "Sprievodca zdravím",
        "subtitle": "po celej SR",
        "text": "Sestry vás nasmerujú k riešeniu.",
        "button": "Zadať požiadavku"
      },
      "prevention": {
        "title": "Prevencia",
        "subtitle": "Zdravie vo vašich rukách",
        "text": "Postarajte sa s našou podporou čo najlepšie o svoje zdravie.",
        "existedButton": "Vstúpiť do prevencie"
      },
      "thematic_counseling": {
        "title": "Tématické poradne",
        "text": "Využite naše poradne zamerané na konkrétne témy. Spýtajte sa odborníkov na to, čo vás zaujíma.",
        "button": "Vybrať tému"
      },
      "hints": {
        "service_not_supported_in_this_language": {
          "text": "Službu nie je možné využívať v {language}. Na využitie služby zvoľte v nastavení <a href=\"{link}\" class=\"link--inline\">svojho profilu</a> iný jazyk služby.",
          "cs": "češtine",
          "en": "angličtine",
          "sk": "slovenčine"
        }
      },
      "labTest": {
        "title": "Laboratorní testy",
        "subtitle": "zdraví ve vašich rukou",
        "text": "Postarejte se s naší podporou co nejlépe o své zdraví.",
        "button": "Vyplnit dotazník"
      },
      "videoTherapy": {
        "subtitle": "s terapeutom",
        "title": "Videohovor",
        "text": "Porozprávajte sa diskrétne a online. Odborník sa vám venuje 50 minút.",
        "button": "Vyberte dátum videohovoru",
        "textUnavailable": "Počet terapií bol vyčerpaný. Ďalšie informácie získate na personálnom oddelení."
      }
    },
    "news": "Novinky",
    "recomended": "Odporúčané pre vás",
    "errors": {
      "emailNotVerified": "Prosíme o potvrzení e-mailu uvedeného při registraci. Ať máte uLékaře.cz po ruce!",
      "resendEmail": "Zaslat e-mail znovu."
    },
    "family": {
      "title": "Chcete se zeptat na své zdraví?",
      "myHealth": "Ano, na své zdraví",
      "otherHealth": "Ne, na zdraví někoho z rodiny"
    },
    "emailVerification": {
      "title": "Overenie e-mailovej adresy",
      "subtitle": "Prejdite do svojej e-mailovej schránky <strong>{email}</strong> a kliknite na overovací odkaz v e-maile, ktorý sme vám zaslali.",
      "text": [
        {
          "title": "Nedostali ste správu?",
          "list": [
            {
              "icon": "check_circle",
              "text": "Skontrolujte zložku nevyžiadanej pošty (spam)"
            },
            {
              "icon": "check_circle",
              "text": "Počkajte niekoľko minút a potom skúste poslať e-mail znovu"
            }
          ]
        },
        {
          "title": "Zadali ste nesprávny e-mail?",
          "text": "Prosíme začnite registráciu znovu"
        }
      ],
      "actions": {
        "right": {
          "type": "resend",
          "baseText": "Poslať e-mail znova"
        }
      }
    },
    "help": {
      "text": "Neviete si rady?",
      "hours": "Po-pi 8–17 h"
    }
  },
  "videoCall": {
    "infoStep": {
      "title": "Online sedenie s lekárom",
      "perex": "Dohovorte si termín videohovoru a preberte s lekárom akýkoľvek zdravotný problém, aj bez návštevy ordinácie.",
      "list": {
        "first": "Uistite sa, že máte vyplnené základné údaje a overené telefónne číslo.",
        "second": "Vyberte dátum a čas, ako vám vyhovuje. Hovor stihnete aj počas obedovej pauzy.",
        "third": "V dohodnutý čas sa pripojíte k videohovoru. Lekár sa venuje 20 minút iba vám."
      },
      "legal": [
        "Službu vám sprostredkujeme u poskytovateľa zdravotných služieb, ktorým je spoločnosť:",
        "uLékaře.cz Health Care, s.r.o.<br/>so sídlom Českomoravská 1a, 190&nbsp;00&nbsp;Praha&nbsp;9 IČO:&nbsp;096&nbsp;64&nbsp;777<br/>vedená na&nbsp;Mestskom súde v&nbsp;Prahe pod sp.&nbsp;zn.&nbsp;C&nbsp;339989",
        "Zdravotná služba Videohovor s lekárom nie je hradená z verejného zdravotného poistenia. Náklady na&nbsp;ňu hradí váš zamestnávateľ.",
        "Videohovor s lekárom je zdravotná služba poskytovaná na diaľku formou videohovoru s lekárom, a to len v oblasti internej medicíny."
      ],
      "button": "Vybrať termín videohovoru"
    },
    "formStep": {
      "title": "Skontrolujte základné údaje",
      "legal": {
        "termsConditions": {
          "text": "Súhlasím s {legalText} Videohovor s lekárom poskytovateľa zdravotných služieb uLékaře.cz Health Care, s.r.o.",
          "legalText": "podmienkami poskytnutia služby"
        },
        "personalData": {
          "text": "Vaše osobné údaje spracovávame v súlade so {link}.",
          "legalText": "Zásadami ochrany osobných údajov"
        }
      }
    },
    "iframeStep": {
      "title": "Vyberte si termín"
    }
  },
  "tally": {
    "anxiety": {
      "dashboardBox": {
        "title": "Test míry úzkosti",
        "text": "Dotazník vám ukáže, jak jste na tom s úzkostí",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Jak jste na tom s úzkostí?",
        "timeApproximation": "2 minuty",
        "perex": "Úzkost je kombinace strachu, zlých předtuch a obav. Jedná se o nepříjemný pocit ohrožení a napětí, a to s různou intenzitou. Může připomínat stres.",
        "list": [
          "Vyplňte krátký dotazník a zjistěte své riziko úzkosti.",
          "Ihned nabídneme doporučení nebo pomocnou ruku."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychologie",
          "workplace": "Psychologické poradenství online v uLékaře.cz"
        },
        "button": "Vyplniť dotazník"
      }
    },
    "nicotine": {
      "dashboardBox": {
        "title": "Závislost na nikotinu",
        "text": "Pár otázek odhalí, jestli jste opravdu závislí na nikotinu.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Jste závislí na nikotinu?",
        "timeApproximation": "2 minuty",
        "perex": "Užívání nikotinu není jen zlozvyk – skutečně ohrožuje vaše zdraví. Otestujte se, pokud kouříte cigarety, e-cigarety či iQOS, užíváte VELO apod.",
        "list": [
          "Odpovězte na 6 otázek o nikotinu.",
          "Dozvíte se, jestli trpíte závislostí."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "MUDr. Lenka Dvouletá",
          "specialization": "Pneumologie a ftizeologie",
          "workplace": "Nemocnice Tomáše Bati ve Zlíně"
        },
        "button": "Vyplnit dotazník"
      }
    },
    "wellbeing": {
      "dashboardBox": {
        "title": "Test životní pohody",
        "text": "Jak se skutečně máte? Otestujte svůj wellbeing.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Daří se vám dobře?",
        "timeApproximation": "~2 minuty",
        "perex": "Wellbeing označuje celkový stav fyzického, duševního a emocionálního zdraví. Životní pohodu ovlivňuje zdravotní stav, vztahy a další aspekty.",
        "list": [
          "Odpovězte na 5 krátkých otázek.",
          "Okamžitě dostanete výsledek s tipy, které vám pomohou cítit se lépe."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychologie",
          "workplace": "Psycholožka z uLékaře.cz"
        },
        "button": "Vyplnit dotazník"
      }
    },
    "insomnia": {
      "dashboardBox": {
        "title": "Test nespavosti",
        "text": "Jak jste na tom se spánkem? Otestujte se.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Jak jste na tom se spánkem?",
        "timeApproximation": "~2 minuty",
        "perex": "Nedaří se vám v poslední době usnout? Nebo se v noci budíte? Dlouhodobá nespavost může ovlivnit životní pohodu i zdraví.",
        "list": [
          "Odpovězte během 2 minut na osm krátkých otázek",
          "Obratem uvidíte svůj výsledek včetně praktických doporučení"
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychologie",
          "workplace": "Psycholožka z uLékaře.cz"
        },
        "button": "Vyplnit dotazník"
      },
      "urls": {
        "b2b": "https://tally.so/r/nGDyY2"
      }
    },
    "healthCheck": {
      "dashboardBox": {
        "title": "Test péče o zdraví",
        "text": "Několik otázek ukáže, jak dobře pečujete o zdraví.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Jak pečujete o své zdraví?",
        "timeApproximation": "~2 minuty",
        "perex": "Krátký test ukáže, jak se staráte o své tělo a duši a zda potřebujete více sebepéče.\nOvěřeno praktickým lékařem.",
        "list": [
          "Během pár minut vyplníte jednoduchý test s 10 otázkami.",
          "Ihned se dovíte, jak pečujete o zdraví a co lékař doporučuje „na tělo“."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "mjr. MUDr. Denisa Gottvaldová",
          "specialization": "Praktické lékařství pro dospělé",
          "workplace": "Centrum zdravotních služeb Bechyně"
        },
        "button": "Vyplnit dotazník"
      }
    },
    "alcohol": {
      "dashboardBox": {
        "title": "Vztah k alkoholu",
        "text": "Jak jste na tom s alkoholem? Otestujte se.",
        "button": "Vyplnit test"
      },
      "infoStep": {
        "title": "Jak jste na tom s alkoholem?",
        "timeApproximation": "~2 minuty",
        "perex": "Test vám pomůže posoudit, jestli máte konzumaci alkoholu pod kontrolou...\na nebo pohár brzy přeteče.",
        "list": [
          "U každé otázky vyberte odpověď, která nejlépe vystihuje vaši situaci.",
          "Obratem uvidíte svůj výsledek\nvčetně praktických doporučení."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychologie",
          "workplace": "Psycholožka z uLékaře.cz"
        },
        "button": "Vyplnit dotazník"
      }
    },
    "depression": {
      "dashboardBox": {
        "title": "Test rizika depresie",
        "text": "Je to zlá nálada, alebo depresia? Otestujte sa.",
        "button": "Vyplniť dotazník"
      },
      "infoStep": {
        "title": "Zlá nálada, alebo depresia?",
        "timeApproximation": "~2 minúty",
        "perex": "Cítite sa v poslednom čase vyčerpaní, bez energie a nič vás neteší? Online test rizika depresie vám pomôže zmapovať vaše pocity.",
        "list": [
          "Vyberte odpovede, ktoré najlepšie zodpovedajú vašej súčasnej situácii.",
          "Obratom uvidíte svoj výsledok vrátane praktických odporúčaní."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychológia",
          "workplace": "Psychologička z uLekára.sk"
        },
        "button": "Vyplniť dotazník"
      },
      "urls": {
        "b2b": "https://tally.so/r/npkN0E"
      }
    },
    "liver": {
      "dashboardBox": {
        "title": "Test zdravej pečeně",
        "text": "Otestujte sa, ako dobre sa staráte o svoju pečeň.",
        "button": "Vyplniť test"
      },
      "infoStep": {
        "title": "Dobre sa staráte o svoju pečeň?",
        "timeApproximation": "~3 minúty",
        "perex": "Tento krátky test vám prezradí, ako je na tom vaša pečeň a či potrebuje viac starostlivosti ako doteraz.",
        "list": [
          "Vyberte odpovede, ktoré považujete za správne a hodia sa k vášmu zdraviu.",
          "Obratom uvidíte svoj výsledok vrátane praktických odporúčaní."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Mjr. MUDr. Denisa Gottvaldová z uLekára.sk",
          "specialization": "Praktické lékařství pro dospělé",
          "workplace": "Centrum zdravotních služeb Bechyně"
        },
        "button": "Vyplniť test"
      },
      "urls": {
        "b2b": "https://tally.so/r/wavLZZ",
        "b2c": "https://tally.so/r/mJMQyJ"
      }
    },
    "heart": {
      "dashboardBox": {
        "title": "Máte zdravé srdce?",
        "text": "Niekoľko otázok prezradí, čo potrebuje vaše srdce.",
        "button": "Vyplniť test"
      },
      "infoStep": {
        "title": "Ako je na tom vaše srdce?",
        "timeApproximation": "~3 minúty",
        "perex": "Tento test napovie, či je vaše srdce v dobrom stave, alebo už bije na poplach.",
        "list": [
          "Odpovedzte za 3 minúty na desať krátkych otázok.",
          "Obratom uvidíte svoj výsledok vrátane praktických tipov."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "Dr. Oleksii Bolotskykh",
          "specialization": "Kardiológia pre dospelých",
          "workplace": "Kardiologie na Bulovce, s.r.o."
        },
        "button": "Vyplniť test"
      },
      "urls": {
        "b2b": "https://tally.so/r/mOrap8"
      }
    },
    "movement": {
      "urls": {
        "b2b": "https://tally.so/r/m65KXe"
      },
      "infoStep": {
        "button": "Vyplniť test",
        "garant": {
          "workplace": "Súkromná prax YOTAI, Praha",
          "specialization": "Odborníčka na tanečnú a športovú medicínu",
          "name": "MgA. Klára Lidová, Ph.D.",
          "title": "Garant testu"
        },
        "list": [
          "Odpovedzte za 2 minúty na desať krátkych otázok.",
          "Obratom uvidíte svoj výsledok vrátane praktických odporúčaní."
        ],
        "perex": "Rýchly test prezradí, či sa dostatočne hýbete, alebo vaše telo volá po akcii.",
        "timeApproximation": "~2 minúty",
        "title": "Máte dostatok pohybu?"
      },
      "dashboardBox": {
        "button": "Vyplniť test",
        "text": "Otestujte si svoju kondíciu krátkym online testom.",
        "title": "Pohyb a vy"
      }
    },
    "skin": {
      "dashboardBox": {
        "title": "Ako sa opaľujete?",
        "text": "Zistite svoj fototyp pomocou krátkeho testu.",
        "button": "Urobte si test"
      },
      "infoStep": {
        "title": "Ako dobre sa opaľujete?",
        "timeApproximation": "~2 minúty",
        "perex": "Otestujte, či je vaša pokožka v bezpečí, alebo či pod slnečnými lúčmi ticho trpí.",
        "list": [
          "Odpovedzte za 2 minúty na osem krátkych otázok.",
          "Obratom uvidíte svoj výsledok vrátane praktických tipov."
        ],
        "garant": {
          "title": "Garant testu",
          "name": "MUDr. Tereza Marušiaková",
          "specialization": "Dermatovenerológ",
          "workplace": "Krajská nemocnica Liberec"
        },
        "button": "Vyplniť dotazník"
      },
      "urls": {
        "b2b": "https://tally.so/r/3Xd24d"
      }
    },
    "adhd": {
      "urls": {
        "b2b": "https://tally.so/r/megEKE"
      },
      "infoStep": {
        "button": "Vyplniť dotazník",
        "garant": {
          "workplace": "Centrum psychologických služeb, Ostrava",
          "specialization": "psychológ, psychoterapeut",
          "name": "PhDr. Sylvie Navarová",
          "title": "Garant testu"
        },
        "list": [
          "Odpovedzte na 10 otázok. Žiadne dlhé premýšľanie, stačí prvý pocit.",
          "Na konci testu sa dozviete, čo pre seba urobiť."
        ],
        "perex": "Sú vaše myšlienky ako splašené včely, alebo sa sústredíte ako šachista? Tento krátky test prezradí viac.",
        "timeApproximation": "~3 minúty",
        "title": "Ako dobre sa sústredíte?"
      },
      "dashboardBox": {
        "button": "Urobte si test",
        "text": "Otestujte svoju pozornosť a schopnosť sústrediť sa.",
        "title": "Ako sa sústredíte?"
      }
    },
    "imunity": {
      "dashboardBox": {
        "title": "Test imunity",
        "button": "Vyplniť test"
      },
      "infoStep": {
        "title": "Máte silnú imunitu?",
        "timeApproximation": "~2 minúty",
        "perex": "Otestujte, či vaša imunita funguje ako štít, alebo ju porazí každá choroba.",
        "list": [
          "Odpovedzte za 2 minúty na osem krátkych otázok.",
          "Obratom uvidíte svoj výsledok vrátane praktických tipov."
        ],
        "garant": {
          "title": "Garantka testu",
          "name": "MUDr. Jana Emlerová",
          "specialization": "Alergiológ a klinický imunológ",
          "workplace": "Alergiológia a klinická imunológia GENNET"
        },
        "button": "Vyplniť test"
      },
      "urls": {
        "b2b": "https://tally.so/r/wQZLq1",
        "b2c": ""
      }
    },
    "circulation": {
      "dashboardBox": {
        "title": "Ako sa cítia vaše cievy?",
        "text": "Niekoľko otázok prezradí, ako je na tom váš krvný obeh.",
        "button": "Vyplniť test"
      },
      "infoStep": {
        "title": "Ako posilniť krvný obeh?",
        "timeApproximation": "~2 minúty",
        "perex": "Zistite, či vaše srdce a cievy pracujú na plný výkon, alebo potrebujú trochu podpory.",
        "list": [
          "Odpovedzte na 10 krátkych otázok.",
          "Obratom uvidíte svoj výsledok aj praktické tipy, ako zlepšiť krvný obeh."
        ],
        "garant": {
          "title": "Garantka testu",
          "name": "MUDr. Markéta Hadrabová",
          "specialization": "Všeobecný lekár a hematológ",
          "workplace": ""
        },
        "button": "Vyplniť test"
      },
      "urls": {
        "b2b": "https://tally.so/r/wAZzLz"
      }
    },
    "flexibility": {
      "dashboardBox": {
        "title": "Máte pružné telo?",
        "text": "Otestuje svoju flexibilitu pomocou desiatich otázok.",
        "button": "Vyplniť test"
      },
      "infoStep": {
        "title": "Aké ohybné je vaše telo?",
        "timeApproximation": "~2 minúty",
        "perex": "Zistite, či je vaše telo ako pružina, alebo skôr ako tuhá doska.",
        "list": [
          "Odpovedzte na 10 krátkych otázok.",
          "Prečítajte si svoj výsledok a zistite tipy pre lepšiu pohyblivosť."
        ],
        "garant": {
          "title": "Garantka testu",
          "name": "MgA. Klára Lidová, Ph.D.",
          "specialization": "Odborníčka na tanečnú a športovú medicínu",
          "workplace": "Súkromná prax YOTAI, Praha"
        },
        "button": "Vyplniť test"
      },
      "urls": {
        "b2b": "https://tally.so/r/w78022"
      }
    },
    "digitalhealth": {
      "dashboardBox": {
        "title": "Vaše digitálne zdravie",
        "text": "Zistite, či vám digitálny svet slúži, alebo vládne.",
        "button": "Vyplniť test"
      },
      "infoStep": {
        "title": "Ovládate technológie vy, alebo ony vás?",
        "timeApproximation": "~3 minúty",
        "perex": "Internet, aplikácie, sociálne siete… Skvelí pomocníci, alebo neúnavní zlodeji času?",
        "list": [
          "Odpovedzte na 10 otázok a zistite, ako sa vám darí v digitálnom svete.",
          "Výsledok vám napovie, ako v prípade potreby znovu získať stratenú rovnováhu."
        ],
        "garant": {
          "title": "Garantka testu",
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychologička z uLekára.sk",
          "workplace": "Psychológia"
        },
        "button": "Vyplniť test"
      },
      "urls": {
        "b2b": "https://tally.so/r/obb7QO"
      }
    },
    "sleephealth": {
      "dashboardBox": {
        "title": "Spíte zdravo?",
        "text": "Otestujte, ako kvalitne odpočívate. Postačí 10 vašich odpovedí.",
        "button": "Vyplniť test"
      },
      "infoStep": {
        "title": "Spíte naozaj dobre?",
        "timeApproximation": "~3 minúty",
        "perex": "Zistite, či počas spánku čerpáte energiu, alebo či vaše telo funguje len na autopilota.",
        "list": [
          "Odpovedzte na 10 krátkych otázok.",
          "Prečítajte si svoj výsledok a objavte tipy pre lepší odpočinok a viac energie počas dňa."
        ],
        "garant": {
          "title": "Garantka testu",
          "name": "PhDr. Sylvie Navarová",
          "specialization": "Psychológ, psychoterapeut",
          "workplace": "Centrum psychologických služeb, Ostrava"
        },
        "button": "Vyplniť test"
      },
      "urls": {
        "b2b": "https://tally.so/r/44Q6NO"
      }
    },
    "drinkfree": {
      "dashboardBox": {
        "title": "Alkohol a vy",
        "text": "Ako ste na tom s pitím? Náš test napovie.",
        "button": "Vyplniť test"
      },
      "infoStep": {
        "title": "Ako ste na tom s alkoholom?",
        "timeApproximation": "~3 minúty",
        "perex": "Osem otázok napovie, aký máte vzťah k alkoholu aj čo sa môže zmeniť, keď si od neho dáte pauzu.",
        "list": [
          "Vyberte vždy jednu odpoveď, ktorá vás najviac vystihuje. ",
          "Prečítajte si svoj výsledok. (Upozornenie: Tento test nie je diagnostický nástroj.)"
        ],
        "garant": {
          "title": "Garantka testu",
          "name": "MUDr. Barbora Magdolenová",
          "specialization": "Psychiater",
          "workplace": "Psychiatrická nemocnica Brno"
        },
        "button": "Vyplniť test"
      },
      "urls": {
        "b2b": "https://tally.so/r/kdGPBj"
      }
    },
    "intimateHealth": {
      "dashboardBox": {
        "button": "Vyplniť test",
        "text": "10 otázok ukáže, ako sa staráte o svoje intímne zdravie.",
        "title": "Vaše intímne zdravie"
      },
      "infoStep": {
        "button": "Vyplniť test",
        "garant": {
          "name": "MUDr. Petra Polášková",
          "specialization": "Gynekológ",
          "title": "Garantka testu",
          "workplace": "FertilityPort Prague s.r.o."
        },
        "list": [
          "Vyberte vždy jednu odpoveď, ktorá vás najviac vystihuje.",
          "Na prvý pohľad uvidíte svoj výsledok vrátane praktických odporúčaní."
        ],
        "perex": "Desať otázok, ktoré vám prezradia, ako sa staráte o svoje intímne zdravie – čo už zvládate a čomu by bolo vhodné venovať viac pozornosti.",
        "timeApproximation": "~3 minúty",
        "title": "Ako sa staráte o svoje intímne zdravie?"
      },
      "urls": {
        "b2b": "https://tally.so/r/jay80a"
      }
    },
    "workbalance": {
      "dashboardBox": {
        "text": "10 otázok odhalí, či smerujete k vyhoreniu.",
        "title": "Práca, stres a vy"
      },
      "infoStep": {
        "button": "Vyplniť test",
        "garant": {
          "name": "Mgr. Michaela Štěpánová",
          "specialization": "Psychológia",
          "title": "Garantka testu",
          "workplace": "Psychologička z uLekára.sk"
        },
        "list": [
          "Vyberte vždy jednu odpoveď, ktorá vás najviac vystihuje.",
          "Na prvý pohľad uvidíte svoj výsledok vrátane praktických odporúčaní."
        ],
        "perex": "Krátky test vám pomôže zistiť, ako na tom ste s pracovnou záťažou, so stresom a s energiou. Nie je to diagnostický nástroj a slúži výlučne na sebareflexiu.",
        "timeApproximation": "~3 minúty",
        "title": "Ako zvládate pracovnú záťaž?"
      },
      "urls": {
        "b2b": "https://tally.so/r/lbLDRo"
      }
    },
    "foodstyle": {
      "dashboardBox": {
        "button": "Vyplniť test",
        "text": "Čo o vás prezradí zloženie vášho taniera?",
        "title": "Tanier pod lupou"
      },
      "infoStep": {
        "button": "Vyplniť test",
        "garant": {
          "name": "Mgr. Lucie Burdová",
          "specialization": "Poradenstvo",
          "title": "Garantka testu",
          "workplace": "Nutričná terapeutka"
        },
        "list": [
          "Neodpovedajte podľa ideálu. Odpovedajte podľa reality.",
          "Prečítajte si svoj výsledok vrátane praktických odporúčaní."
        ],
        "perex": "Krátky test vám ukáže, či vaše stravovanie funguje ako palivo, alebo skôr ako núdzová náplasť na hlad.",
        "timeApproximation": "~3 minúty",
        "title": "Jete naozaj zdravo?"
      },
      "urls": {
        "b2b": "https://tally.so/r/MedPD0"
      }
    }
  },
  "profileAuthorization": {
    "chooseSubscription": "Zvoliť predplatné",
    "language": {
      "title": "Nastavenie služby",
      "text": "Vyberte si, v ktorom jazyku chcete službu uLekára.sk využívať.",
      "errorText": "Aktuálny jazyk nie je podporovaný plátcom služby. Vyberte iný jazyk."
    },
    "final": {
      "title": "Registrace prebehla úspešne",
      "text": "Teraz môžete využívať službu uLekára.sk. Naši lekári a zdravotné sestry sú tu pre vás."
    },
    "possiblePartners": {
      "title": "Zdá sa, že máte nárok na službu zadarmo",
      "textHrb": "Potvrďte jedného z nižšie uvedených zamestnavateľov alebo partnerov, ktorý službu hradia. Nemôžete si vybrať? Zmeňte partnera.",
      "changePartner": "Zmeniť partnera"
    },
    "hrbPartner": {
      "title": "Aktivácia služby zadarmo",
      "textBoth": "Pre aktiváciu zadajte firemný e-mail alebo aktivačný kód, ktorý ste obdržali od {partner}.",
      "textEmail": "Pre aktiváciu zadajte firemný e-mail.",
      "textCode": "Pre aktiváciu zadajte aktivačný kód, ktorý ste dostali od {partner}.",
      "tabs": [
        "E-mailom",
        "Kódom"
      ],
      "email": "Firemný e-mail",
      "code": "Aktivačný kód",
      "codeError": "<strong>Tento kód je bohužiaľ neplatný.</strong><br>Správnosť kódu si overte na svojom HR oddelení.<br>Ak je kód správny, radi vám pomôžeme na",
      "emailError": "Neplatný e-mail. Neviete si rady? Kontaktujte nás:  <a href=\"mailto:info@ulekara.sk\">info@ulekara.sk</a>.",
      "invalidEmployeeEmail": "E-mail nie je povolený pre zvoleného zamestnávateľa/partnera.",
      "benefitBlocked": "E-mail bol použitý u iného zamestnávateľa/partnera, aktivácia nie je možná.",
      "clientSupport": "klientskej podpore",
      "startTitle": "Naštartujte službu zadarmo",
      "formTitle": "Zadajte firemný e-mail alebo kód",
      "startUsing": "Zadajte firemný e-mail alebo kód",
      "formDescription": "Vyplňte, prosím, nasledujúce údaje pre overenie nároku na službu zadarmo.",
      "description": {
        "code": "Aktivačný kód",
        "email": "Aktivačný email"
      }
    },
    "emailAuthorization": {
      "title": "Žiadosť o aktiváciu služby zadarmo odoslaná",
      "subtitle": "Na <strong class=\"black--text\"> {email} </strong> sme poslali aktivačný e-mail. Kliknutím na odkaz v e-maile aktivujete službu zadarmo.",
      "text": [
        {
          "title": "Neprišiel e-mail?",
          "list": [
            {
              "text": "Pozrite sa do priečinka spam alebo hromadná pošta."
            },
            {
              "text": "Doručenie môže chvíľu trvať.",
              "text ": "Doručenie môže chvíľu trvať."
            }
          ]
        },
        {
          "title": "Uviedli ste nesprávny e-mail?",
          "link": {
            "type": "router",
            "routerAction": "replace",
            "name": "dashboard",
            "query": {
              "a_step": "authorization"
            },
            "textBefore": "Zmeňte ho",
            "text": "tu"
          }
        }
      ],
      "actions": {
        "left": {
          "type": "resend",
          "class": "light",
          "baseText": "Poslať e-mail znova"
        },
        "right": {
          "type": "continue"
        }
      }
    },
    "authorizationSignpost": {
      "title": "Kto hradí službu?",
      "text": "Mějte služby uLékaře.cz zdarma! Možná vám ji hradí zaměstnavatel nebo někdo z našich partnerů (pojišťovny, karetní společnosti atd.).",
      "employees": "Zamestnávateľ",
      "search": "Hľadajte zamestnávateľa podľa názvu",
      "searchSignText": "Začnite písať názov firmy, v ktorej pracujete. Spoločne ju nájdeme.",
      "searchEmpty": {
        "title": "Pod výrazom “{text}” sa nám nepodarilo nič nájsť",
        "text": "Pokiaľ si myslíte, že by daná spoločnosť nemala v zozname chýbať, môžete nám ju {email}.",
        "emailText": "odporučiť"
      },
      "selfPay": "Službu hradím sám"
    },
    "selfPay": {
      "title": "Službu hradím sám",
      "text": "Ako samoplatca máte k dispozícii:",
      "price": "{priceCzk} Kč (cca {priceEur} €)",
      "priceSufix": "/dotaz",
      "list": [
        {
          "icon": "doctor",
          "text": "Odpoveď lekára do 8 hodín"
        },
        {
          "icon": "shield",
          "text": "Personalizovaný preventívny program"
        },
        {
          "icon": "news",
          "text": "Užitočné zdravotné tipy a články"
        }
      ]
    },
    "mastercard": {
      "title": "Overte si svoju kartu Mastercard<sup>®</sup>",
      "codeInvalidError": "Zadané číslo nie je validné. Skontrolujte, že zadávate 6 čísel svojej prémiovej či firemnej karty Mastercard<sup>®</sup>.",
      "label": "Prvých 6 číslic karty"
    },
    "external": {
      "titleSlot": "Nepodarilo sa nám overiť využitie služby zadarmo.",
      "vozpText": "Ako klient VoZP sa prihláste do klientského portálu VoZP a kliknite na logo uLékaře.cz. Po prvom prihlásení vám budú sprístupnené všetky naše služby.",
      "ozpText": "Klientom OZP je služba uLékaře.cz prístupná 24/7 cez VITAKARTU. Prihláste sa prosím do svojho účtu VITAKARTY.",
      "drmaxText": "Ako klient Dr. Max sa prihláste do Karty výhod a kliknite na logo uLékaře.cz.",
      "mcText": "Potrebujeme overiť prvých 6 čísel vašej karty MasterCard<sup>®</sup> Premium. Nejedná sa o platbu, po úspešnom zadaní budete môcť využiť služby uLékaře.cz zadarmo.",
      "fairsuranceText": "Pre aktiváciu služby zadarmo, prosím zadajte autorizačný kód, ktorý ste dostali z Fairsurance.",
      "eonText": "Služba zdarma pro věrné zákazníky společnosti E.ON už bohužel skončila. Službu uLékaře.cz můžete i nadále využívat po přihlášení do svého profilu.",
      "sporthelpText": "{title}Pre aktiváciu služby zadarmo pre členov športového poistenia SportHelp kliknite na odkaz pre využitie služby, ktorý nájdete vo svojej digitálnej členskej karte v sekcii Lekárska poradňa uLékaře.cz.",
      "defaultErrorText": "Autorizačný odkaz už nie je možné použiť, pretože jeho platnosť vypršala. Ďakujeme vám za pochopenie."
    },
    "chooseDifferentCompany": "Zmeniť partnera"
  },
  "profile": {
    "title": "Môj účet",
    "titleMobile": "Nastavenia",
    "subtitle": "Vyplňte všetky údaje a nastavte si využitie služby podľa seba.",
    "basicData": "Základné údaje",
    "emailNote": "Zmena e-mailovej adresy nie je možná, je potrebné registrovať sa znova s novou e-mailovou adresou.",
    "phoneNote": "Na tomto čísle vás môžu kontaktovať naše sestričky pri riešení vašich požiadaviek.",
    "security": "Zabezpečenie",
    "currentPassword": "Pôvodné heslo",
    "invalidCurrentPassword": "Neplatné pôvodné heslo",
    "currentPasswordUsedInHistory": "Nové heslo nesmie byť rovnaké ako staré.",
    "newPassword": "Nové heslo",
    "additionalInfo": "Doplňujúce údaje",
    "birthDateNote": "Podľa vašeho veku sa lekár lepšie vyjadrí.",
    "address": "Adresa",
    "addressNote": "Podľa adresy vám odporučíme, kam sa objednať.",
    "family": "Moja rodina",
    "aboutApp": "O aplikácii",
    "applicationLock": "Zámok aplikácie",
    "moreOptions": "Ďalšie možnosti",
    "healthInsuranceProvider": {
      "title": "Zdravotná poisťovňa",
      "note": "Nájdeme lekára spolupracujúceho s vašou poisťovňou."
    },
    "applicationLanguage": {
      "title": "Jazyk aplikácie",
      "message": "V tomto jazyku se bude zobrazovať web"
    },
    "serviceLanguage": {
      "title": "Jazyk služby",
      "message": "V tomto jazyku vám bude odpovedať lekár"
    },
    "changeLanguageNotification": {
      "text": "Po uložení zmien sa jazyk webu zmení na",
      "cs": "češtinu",
      "en": "angličtinu",
      "sk": "slovenčinu",
      "uk": "ukrajinčinu",
      "ru": "ruštinu"
    },
    "storeMessage": {
      "success": "Zmeny sú uložené.",
      "error": "Zmeny sa neuložili. Skontrolujte prosím správnosť uvedených údajov.",
      "passwordError": "Zmeny sa neuložili z dôvodu zle zadaného pôvodného hesla."
    },
    "ucb": {
      "title": "Právne dokumenty a oznámenia",
      "text": "Vezmite prosím na vedomie, že UniCredit Bank Czech Republic and Slovakia, a.s. nepreberá žiadnu zodpovednosť za obsah a priebeh služby, ktorá je zamestnancovi poskytnutá. Využitie tejto služby zamestnancom je dobrovoľné a zodpovednosť za dodanie služby vo forme lekárskej rady nesie poskytovateľ služby spoločnosť uLékaře.cz, s.r.o., ktorá zodpovedá za to, že lekársku radu poskytuje výhradne osoba na to spôsobilá podľa platných právnych predpisov České republiky. Zamestnancovi sa odporúča pred využitím služby lekárskej poradne riadne sa oboznámiť s {terms_and_conditions}.",
      "termsAndConditions": "podmienkami použitia služby"
    },
    "removeSection": {
      "title": "Zrušenie účtu",
      "text": "Váš účet bude deaktivovaný. Pokiaľ si to rozmyslíte, môžete deaktiváciu zrušiť prihlásením do svojho účtu. Po 30 dňoch už nebude možné sa k účtu vrátiť.",
      "button": "Zrušiť účet"
    },
    "removeDialog": {
      "title": "Ste si naozaj istí?",
      "areYouSure": {
        "text": "Váš účet bude deaktivovaný. Pokiaľ si to rozmyslíte, môžete deaktiváciu zrušiť prihlásením do svojho účtu. Po 30 dňoch už nebude možné sa k účtu vrátiť.",
        "yes": "Zrušiť účet",
        "no": "Zostať v zdraví",
        "title": "Naozaj chcete zrušiť svoj účet?"
      },
      "list": [
        {
          "icon": "chat-empty",
          "text": "Prídete o svojho sprievodcu prevenciou. Starostlivosť o zdravie teraz bude zložitejšia."
        },
        {
          "icon": "surgeon",
          "text": "Rozlúčite sa s viac ako 350 lekármi a sestričkami z uLekára.sk, ktorí vám pomáhajú."
        },
        {
          "icon": "person-sad",
          "text": "Stratíte cenné odpovede lekárov a prehľad o svojom zdraví."
        }
      ],
      "footer": "Máte otázky alebo potrebujete poradiť? Náš tím zákazníckej starostlivosti je tu pre vás na na {email} alebo {phone}.",
      "cancelButton": "Zostať v zdraví",
      "deleteButton": "Zrušiť účet",
      "confirmTitle": "Váš účet bude zrušený.",
      "confirmText": "Ak si to rozmyslíte, môžete účet obnoviť prihlásením počas nasledujúcich 30 dní pomocou svojich aktuálnych prihlasovacích údajov. <br/>Ak máte akékoľvek otázky, kontaktujte našu zákaznícku podporu na <a href=\"mailto: info@ulekare.cz\">info@ulekare.cz</a> alebo <a href=\"tel:00420227072720\">+420 227 072 720</a>.",
      "feedback": {
        "title": "Prečo odchádzate?",
        "checkboxes": {
          "no_or_low_use": "Službu už nepotrebujem alebo ju využívam málo",
          "disappointed": "Služby nesplnili moje očakávania",
          "technical_issues": "Technické problémy so systémom",
          "price_too_high": "Cena je pre mňa vysoká",
          "better_alternative": "Používam inú službu",
          "other": "Iný dôvod / nechcem uviesť"
        },
        "detailsLabel": "Povedzte nám viac",
        "confirm": "Zrušiť účet",
        "cancel": "Zostať v zdraví"
      }
    },
    "benefits": {
      "consultation_forum": {
        "chip": "Poradňa",
        "tooltip": "Napíšte lekárovi svoju otázku kedykoľvek a odkiaľkoľvek. Odpovie vám online."
      },
      "booking": {
        "chip": "Sprievodca zdravím"
      },
      "prevention_plan": {
        "chip": "Plán prevencie"
      },
      "insurance_contributions": {
        "chip": "Príspevky od poisťovní",
        "tooltip": "Zistite, na aké príspevky máte od poisťovne nárok."
      },
      "health_tests": {
        "chip": "Zdravotné testy",
        "tooltip": "Vyplňte krátky test a zistite viac o svojom zdraví."
      },
      "video_call_therapist": {
        "chip": "Videohovor: terapeut",
        "tooltip": "Objednajte si online sedenie s terapeutom."
      },
      "content_explore": {
        "chip": "Objavujte"
      },
      "helpline_free": {
        "chip": "Bezplatná linka",
        "tooltip": "Sme tu pre vás počas pracovných dní od 8.00 do 17.00."
      },
      "video_call_doctor": {
        "chip": "Videohovor: lekár",
        "tooltip": "Zarezervujte si videohovor s lekárom."
      },
      "assistance_line": {
        "chip": "Asistenčná linka"
      },
      "blood_tests_review": {
        "chip": "Krvné testy + vysvetlenie"
      }
    },
    "benefit": {
      "validTo": "Platnosť do",
      "availableServices": "Dostupné pre vás",
      "title": "Správa služby",
      "subtitle": "Vaše aktuálne nastavenie služby zadarmo",
      "card": {
        "authorize": "Aktívne",
        "prolong": "Platnosť čoskoro uplynie",
        "pending": "Čaká na dokončenie aktivácie služby",
        "ended": "Platnosť uplynula",
        "family": "Aktívny (člen rodiny)",
        "familyExpired": "Spýtajte sa svojho blízkeho na predĺženie služby zadarmo"
      },
      "partnerSuggestions": {
        "title": "Zmena poskytovateľa služby zadarmo",
        "subtitle": "Službu zadarmo vám môže zaplatiť len jedna firma alebo partner.",
        "nosearch": {
          "title": "Nechce sa vám hľadať? Nevadí.",
          "subtitle": "Možno môžete mať službu zadarmo vďaka niektorému z našich 6 partnerov."
        }
      },
      "searchPlaceholder": "Zadajte názov firmy alebo partnera",
      "selectPartner": "Aktivovať službu zadarmo",
      "serviceNotActive": "Služba zadarmo nie je aktívna",
      "b2c": {
        "title": "Nemáte priradenú firmu ani partnera, ktorý vám službu platí.",
        "subtitle": "Zadajte názov firmy alebo partnera a získajte bezplatný prístup k službe. Partnerom môže byť vaša poisťovňa, vydavateľ platobnej či kreditnej karty atď."
      },
      "authorization": {
        "none": "Iná forma aktivácie",
        "email": "Aktivácia pomocou e-mailu",
        "codeOnly": "Aktivácia pomocou kódu",
        "codeAndEmail": "Aktivácia pomocou kódu a e-mailu",
        "code": {
          "finished": {
            "buttonText": "Hotovo"
          }
        }
      },
      "prolong": {
        "buttonText": "Predĺžte si službu zadarmo"
      },
      "authorize": {
        "buttonText": "Aktivujte si službu zadarmo"
      },
      "goback": "Späť",
      "partnerDetected": {
        "title": "Zrejme máte nárok na službu zadarmo. Platí to?",
        "subtitle": "Ak áno, aktivujte si službu zadarmo."
      },
      "family": {
        "buttonText": "Aktuálne nastavenie"
      },
      "ended": {
        "buttonText": "Predĺžiť službu zadarmo"
      },
      "info": {
        "ended": "Znovu aktivujte službu zadarmo",
        "authorize": "Služba zadarmo je aktívna",
        "prolong": "Platnosť služby zadarmo čoskoro uplynie",
        "family": "Služba zadarmo je aktívna vďaka rodinnému zdieľaniu"
      },
      "manage": {
        "buttonText": "Spravovať nastavenia služby"
      },
      "showMore": "Zobraziť viac",
      "showLess": "Zobraziť menej"
    },
    "multifactor": {
      "label": "Dvojfaktorové overenie",
      "off": "Vypnuté",
      "offInfo": "Vypnuté dvojfaktorové overovanie",
      "sms": "Overenie cez SMS",
      "smsInfo": "Na váš telefón bude pri prihlásení zaslaný overovací kód.",
      "email": "Overenie e-mailom",
      "emailInfo": "Pri pokuse o prihlásenie vám príde na e-mail overovací kód."
    },
    "appSecurity": "Zabezpečenie aplikácie"
  },
  "passwordRenewal": {
    "title": "Aktualizujte si heslo.",
    "subtitle": "Je potrebné, aby ste si aktualizovali heslo, pretože platnosť vášho hesla vypršala.",
    "currentPassword": "Aktuálné heslo:",
    "newPassword": "Nové heslo:",
    "passwordRules": "Vaše heslo musí mať aspoň 12 znakov a obsahovať aspoň jedno písmeno, číslo a špeciálny znak (-=%*+./![]@#$^&()?;) a nesmiete použiť to isté heslo, ktoré ste použili v minulosti.",
    "confirmation": "Potvrdenie nového hesla",
    "passwordsDontMatch": "Heslá sa nezhodujú",
    "button": "Zmeniť heslo",
    "thankYouTitle": "Heslo bolo zmenené",
    "thankYouSubtitle": "Vaše heslo bolo úspešne zmenené. Ďakujeme vám za spoluprácu!"
  },
  "subscription": {
    "signpost": {
      "title": "Kto mi službu hradí?",
      "b2cButton": "Budem si ju hradiť sám",
      "b2bButton": "Zamestnávateľ alebo iná spoločnosť"
    }
  },
  "questions": {
    "answerDisclaimer": "Vezmite, prosím, na vedomie, že vyššie uvedená odpoveď má iba informatívny charakter. Ide o&nbsp;všeobecné rady a informácie z&nbsp;oblasti zdravia, ochorení či iných zdravotných ťažkostí. Vyššie uvedené informácie nemožno považovať za určenie individuálnej diagnózy, stanovenie liečebného plánu či plánu prevencie, a to najmä s&nbsp;ohľadom na obmedzené možnosti online komunikácie. Vzhľadom k&nbsp;tomu, že informácie od používateľa nemusia byť úplné a telesné vyšetrenie nie je možné, odpovede jednotlivých lekárov sa môžu v&nbsp;detailoch líšiť v&nbsp;závislosti od ich skúseností a klinickej praxe. Využitie služby v&nbsp;žiadnom prípade nenahrádza osobné vyšetrenie lekárom. V prípade zdravotných ťažkostí Vám odporúčame vyhľadať lekársku či inú odbornú starostlivosť podľa povahy Vašich ťažkostí. Odpoveď lekára mohla byť preložená pomocou prekladača, následne ju vždy dôkladne overuje zdravotník.",
    "title": "Poradňa",
    "subtitle": "Majte prehľad o svojich otázkach alebo sa spýtajte našich lekárov.",
    "noQuestion": {
      "title": "Ešte čakáme na vašu prvú otázku.",
      "subtitle": "S čím vám pomôžeme?",
      "infoList": [
        {
          "text": "Rýchlo sa dozviete, či sa s náhlym zdravotným problémom môžete poradiť sami alebo či je nutné vyhľadať lekársku pomoc.",
          "icon": "suitcase"
        },
        {
          "text": "Lekár z poradne vás nasmeruje na vhodné vyšetřenie alebo k správnemu špecialistovi.",
          "icon": "surgeon-question"
        },
        {
          "text": "Naši odborníci vám pomôžu zorientovať sa v lekárskej správe alebo laboratórnych výsledkoch.",
          "icon": "stop"
        },
        {
          "text": "Žiadne obavy, pomôžeme s riešením zdravotných problémov i vašim blízkym.",
          "icon": "temperature"
        }
      ]
    },
    "newQuestion": "Nová otázka",
    "newSolved": "V riešení",
    "waitingForAnswer": "Čakajú na odpoveď",
    "history": "História otázok",
    "detail": {
      "title": "Detail otázky",
      "sent": "Odoslané",
      "questionFormTitle": "Popis zdravotného problému",
      "healthFormTitle": "Zdravotný stav",
      "attachments": "Prílohy",
      "helped": "Pomohla vám odpoveď?"
    },
    "evaluation": {
      "title": "Ďakujeme za vašu reakciu",
      "text": "Pomáhate nám zlepšovať naše služby. Chcete nám zdeliť niečo ďalšieho?",
      "label": "Ďalšie komentáre a pripomienky",
      "placeholder": "Ako môžeme službu vylepšiť?",
      "ok": "Odpoveď mi pomohla",
      "nok": "Odpoveď mi nepomohla"
    },
    "thankYou": {
      "title": "Vaša otázka bola úspešne odoslaná",
      "subtitle": "(Služba bude doručovaná v {language} jazyku)",
      "cs": "českom",
      "en": "anglickom",
      "sk": "slovenskom",
      "text": "Teraz sa jej venuje praktický lekár a akonáhle odpovie na vaše otázky, upozorníme vás e- mailom."
    },
    "status": {
      "waitingGpAnswer": "Vaša otázka čaká na zodpovedanie praktickým lekárom.",
      "waitingSpecialistAnswer": "Vaša otázka čaká na zodpovedanie špecialistom.",
      "answered": "Vaša otázka je zodpovedaná.",
      "transferToAppointment": "Vaša otázka bola prevedená na požiadavku. Budeme vás kontaktovať.",
      "declined": "Vaša otázka bola odmietnutá.",
      "emergency": "Vaša otázka je zodpovedaná. Môže sa jednať o život ohrozujúci stav, bezodkladne vyhľadajte najbližšiu pohotovosť."
    },
    "askedQuestions": "Položené otázky"
  },
  "appointments": {
    "title": "Moje požiadavky",
    "subtitle": "Majte prehľad o vašich požiadavkach.",
    "statuses": {
      "newDoctor": "Vyhľadali sme lekára.",
      "newZZ": "Našli sme, kde vám pomôžu!"
    },
    "noAppointments": {
      "title": "Zatiaľ nemáte žiadne požiadavky.",
      "subtitle": "Ako služba funguje?",
      "infoList": [
        {
          "text": "Vyplňte a odošlite svoju požiadavku.",
          "icon": "hospital"
        },
        {
          "text": "Nasledujúci pracovný deň vás kontaktuje zdravotná sestra, preberie s vami ďalší postup a pomôže vám nájsť riešenie.",
          "icon": "nurse"
        },
        {
          "text": "V rámci možností sa pokúsime overiť dostupnosť termínu vyšetrenia alebo vám pošleme overené kontakty na dostupných lekárov.",
          "icon": "clock"
        }
      ]
    },
    "newAppointment": "Nová požiadavka",
    "activeAppointments": "Aktívne požiadavky",
    "visitAppointments": "Nezabudnite navštíviť lekára",
    "evaluateAppointments": "Ohodnoťte návštevu lekára",
    "history": "História požiadaviek",
    "evaluation": {
      "ok": "Spokojnosť s návštevou",
      "nok": "Nespokojnosť s návštevou",
      "noVisit": "Návšteva lekára neprebehla"
    },
    "detail": {
      "title": "Detail požiadavky",
      "sent": "Odoslaná",
      "date": "Termín objednania: ",
      "visitAt": "Kedy sa dostaviť: ",
      "facility": "Zdravotnícke zariadenie: ",
      "address": "Adresa: ",
      "doctor": "Lekár: ",
      "phone": "Telefón: ",
      "note": "Poznámka: ",
      "dateMandatory": "Vyššie uvedený termín je záväzný!",
      "unableToVisitInfo": "Ak sa na dohovorenú návštevu lekára nemôžete dostaviť, volajte prosím {phone} alebo píšte na <a href=\"mailto:{email}\">{email}</a>",
      "thankYou": "Veríme, že vám nami odporúčaný lekár pomôže v riešení vašich zdravotných problémov. Dajte nám prosím vedieť, či všetko dobre dopadlo. Ďakujeme!",
      "additionalQuestion": "Mám doplňujúcu otázku",
      "changeDate": "Zmeniť termín",
      "cancelAppointment": "Zrušiť požiadavku",
      "website": "Web: ",
      "helped": "Ako hodnotíte službu?",
      "noVisit": "Neprebehla"
    },
    "thankYou": {
      "title": "Vaša požiadavka bola úspešne odoslaná",
      "subtitle": "(Služba bude doručovaná v {language} jazyku)",
      "cs": "českom",
      "en": "anglickom",
      "sk": "slovenskom",
      "text": "Zdravotná sestra vás bude kontaktovať nasledujúci pracovný deň z čísla +421 950 105 650.",
      "others": {
        "text": "Zdravotná sestra si vyžiada tieto informácie o osobe, ktorej sa požiadavka týka:",
        "items": [
          {
            "icon": "register",
            "text": "rodné číslo a poisťovňa"
          },
          {
            "icon": "person-happy",
            "text": "aktuálny zdravotný stav"
          },
          {
            "icon": "news",
            "text": "absolvované vyšetrenia a žiadanky"
          },
          {
            "icon": "clock",
            "text": "časová dostupnosť"
          }
        ]
      }
    },
    "status": {
      "waiting": "Vaša požiadavka čaká na spracovanie. Vyčkajte, ozveme sa vám.",
      "lookingForDoctor": "Pracujeme na požiadavke.",
      "orderedForTime": "Vaša návšteva lekára je dohodnutá na {datetime} h.",
      "orderedForOpeningHours": "Požiadavka vybavená.",
      "sendContact": "Odoslaný kontakt na lekára.",
      "done": "Uzavreté",
      "cancelled": "Objednávka bola zrušená."
    },
    "previousAppointments": "História požiadaviek"
  },
  "prevention": {
    "title": "Začnite s prevenciou. Zdravie je vaše.",
    "subtitle": "Vyplňte niekoľko údajov a získajte prevenciu na mieru. Pomôžeme vám predchádzať zdravotným obtiažam a ochoreniam.",
    "birthDateNote": "Vek je len číslo. My ho potrebujeme vedieť, aby sme vám poskytli správnu starostlivosť.",
    "healthInsuranceProviderNote": "Pre zobrazenie príspevkov poisťovne.",
    "personalization": {
      "banner": {
        "title": "Prevencia šitá na mieru",
        "subtitle": "Doplňte o sebe pár údajov a&nbsp;prevenciu vám ihneď prispôsobíme.",
        "button": "Získať prevenciu na mieru"
      },
      "title": "Personalizácia prehliadok dľa veku",
      "text": "Vypnutím sa zobrazia aj preventívne prehliadky, ktoré sa štandardne absolvujú v neskoršom veku."
    },
    "start": "Začať s prevenciou",
    "thankYou": {
      "title": "A je to! Ďakujeme za vyplnenie všetkých údajov.",
      "text": "Vďaka preventívnej starostlivosti môžete predchádzať zdravotným problémom a chorobám. Tipy a novinky týkajúce sa starostlivosti o zdravie nájdete pravidelne vo svojom e-maily."
    },
    "summary": {
      "title": "Prevencia",
      "subtitleDesktop": "Pomôžeme vám predchádzať zdravotným obtiažam a ochoreniam.",
      "subtitleMobile": "Predchádzajte zdravotným obtiažam.",
      "showAll": "Ukázať všetko",
      "intervalEnds": "Končiaci predpísaný interval",
      "planned": "Naplánované",
      "plannedOn": "Naplánované na {time}",
      "timeline": {
        "title": "Nasleduje",
        "tooltip": "Tu uvidíte najbližšie končiace predpísané intervaly prehliadok a očkovaní. Objednajte sa včas."
      },
      "examinations": {
        "title": "Preventívne prehliadky",
        "tooltip": "Uľahčíme vám orientáciu v informáciách a v termínoch vašich prehliadok."
      },
      "vaccinations": {
        "title": "Očkovanie",
        "tooltip": "Uľahčíme vám orientáciu v informáciách a v termínoch vašich očkovaní."
      },
      "others": {
        "title": "Ostatné"
      },
      "tallyTests": {
        "title": "Tematické zdravotné testy"
      }
    },
    "list": {
      "examinations": {
        "recommended": "Povinné prehliadky",
        "optional": "Dobrovoľné prehliadky"
      },
      "vaccinations": {
        "recommended": "Povinné očkovania",
        "optional": "Dobrovoľné očkovania"
      }
    }
  },
  "payment": {
    "title": "Vyberte platbu",
    "priceSum": "Celkom: {price} Kč",
    "priceAfterDiscount": "Cena služby po slevě: {price} Kč",
    "priceWithPartnerDiscount": "Cena se slevou {discountPercent} % {partnerName}: {price} Kč",
    "voucher": "Kód vášho voucheru",
    "voucherGroup": "Poukaz {region}",
    "voucherApply": "Aplikovať",
    "pay": "Zaplatiť ({price} Kč)",
    "payment_created": "Platba zatiaľ nebola uhradená.",
    "payment_confirmed": {
      "title": "Dotaz odoslaný!",
      "subtitle": "Skvelé, váš dotaz je na ceste a čoskoro sa vám ozveme s odpoveďou na váš problém. Nebojte sa, všetko vyriešime! Dôverujte nám!"
    },
    "payment_canceled": "Platba bola zrušená.",
    "payment_rejected": "Vaša platba bola zamietnutá.",
    "payment_create_error": "Platba zlyhala. Skúste to znova.",
    "payment_timeouted": "Platba zlyhala. Skúste to znova.",
    "payment_in_progress": "Čakáme na uhradenie vašej platby.",
    "payment_wait": {
      "title": "Čakáme na overenie platby.",
      "subtitle": "Akonáhle bude platba overená, predáme dotaz lekárom."
    },
    "chooseDifferent": "Vyberte si iný spôsob"
  },
  "labTests": {
    "rowTitle": "Vaše krevní testy",
    "answerDisclaimer": "Vezměte, prosím, na vědomí, že výše uvedená odpověď má pouze informativní charakter. Jedná se o&nbsp;obecné rady a informace z&nbsp;oblasti zdraví, nemocí či jiných zdravotních obtíží. Výše uvedené informace nemohou být považovány za určení individuální diagnózy, stanovení léčebného plánu či plánu prevence, a to zejména s&nbsp;ohledem na omezené možnosti online komunikace. Vzhledem k&nbsp;tomu, že informace od uživatele nemohou být úplné a tělesné vyšetření není možné, odpovědi jednotlivých lékařů se mohou v&nbsp;detailech lišit v&nbsp;závislosti na jejich zkušenostech a klinické praxi. Využití služby v&nbsp;žádném případě nenahrazuje osobní vyšetření lékařem. V případě zdravotních obtíží Vám doporučujeme vyhledat lékařskou či jinou odbornou péči podle povahy Vašich potíží. Odpověď lékaře mohla být přeložena pomocí překladače, poté ji vždy důkladně ověřuje zdravotník.",
    "detail": {
      "title": "Detail laboratorního testu",
      "sent": "Položeno",
      "questionFormTitle": "Popis zdravotního problému",
      "healthFormTitle": "Zdravotní stav",
      "attachments": "Přílohy",
      "helped": "Pomohla vám odpověď?"
    },
    "status": {
      "draft": {
        "title": "Absolvujte odběr v laboratoři",
        "text": "Náš lékař obdrží z odběrového místa výsledky vašich testů.",
        "actionText": "Přejít do Unilabs"
      },
      "new": "Čekáme na výsledky laboratorních testů.",
      "answered": "Hotovo! Přečtěte si výsledky s vysvětlením."
    }
  },
  "loginBanner": {
    "title": "Sme vašim sprievodcom na ceste za zdravím.",
    "infoList": [
      {
        "icon": "doctor",
        "text": "Praktický lekári a špecialisti odpovedajú na dotazy."
      },
      {
        "icon": "nurse",
        "text": "Sestry vás nasmerujú k riešeniu."
      },
      {
        "icon": "shield",
        "text": "Zabezpečené prostredie máte plne vo svojich rukách."
      }
    ],
    "show": "Ako služba funguje?",
    "hide": "Close"
  },
  "cookiesConsent": {
    "acceptAll": "Prijať všetko",
    "basic": {
      "title": "Náš web funguje ako lekár",
      "perex": "Náš web využíva súbory cookies, a funguje tak ako lekár, ktorý sa pýta, aby vám mohol čo najlepšie pomôcť. My takto zbierame {technical}, {analytical} a {marketing} informácie, aby sme sa mohli neustále zlepšovať, a lepšie tak pomáhať vám všetkým. Súhlasíte?",
      "technical": "technické",
      "analytical": "analytické",
      "marketing": "obchodné",
      "customize": "Nastavenie"
    },
    "settings": {
      "title": "Nastavenie súborov cookies",
      "description": "Pri návšteve našej webovej stránky www.ulekare.cz stránka získa alebo uloží informácie na vašom prehliadači, a to väčšinou vo forme súborov cookies. Môžu to byť informácie týkajúce sa vás, vašich preferencií a zariadení, ktoré používate. Väčšinou to slúži na vylepšovanie stránky, aby fungovala podľa vašich očakávaní. Informácie vás spravidla neidentifikujú ako jednotlivca, ale celkovo môžu pomôcť prispôsobovať prostredie vašim potrebám. Rešpektujeme vaše právo na súkromie, a preto sa môžete rozhodnúť, že niektoré súbory cookies nebudete akceptovať a to podľa voľby nižšie. Nezabúdajte ale na to, že zablokovaním niektorých súborov cookies môžete ovplyvniť, ako stránka funguje a aké služby sú vám ponúkané.",
      "link": "Prehlásenie o cookies nájdete {hereLink}.",
      "items": {
        "technical": {
          "title": "Technické cookies",
          "bodyText": "Sú nevyhnutné na to, aby naše stránky fungovali, takže nie je možné ich vypnúť. Väčšinou sú nastavené ako odozva na akcie, ktoré ste vykonali, ako je požiadavka služieb týkajúcich sa bezpečnostných nastavení, prihlasovanie, vyplňovanie formulárov atp. Prehliadač môžete nastaviť tak, aby blokoval súbory cookies alebo o nich posielal upozornenia. Tieto súbory cookies neukladajú žiadne identifikovateľné informácie."
        },
        "functional": {
          "title": "Funkčné cookies",
          "bodyText": "S týmito súbormi cookies je stránka výkonnejšia a osobnejšia. Môžeme ich nastavovať my alebo poskytovatelia tretej strany, ktorých služby na stránkach používame. Ak tieto súbory cookies nepovolíte, je možné, že niektoré alebo všetky tieto služby nebudú fungovať správne."
        },
        "analytics": {
          "title": "Analytické cookies",
          "bodyText": "Tieto súbory cookies slúžia na zlepšenie fungovania webových stránok. Umožňujú nám rozpoznať a zistiť počet návštevníkov a sledovať, ako používajú webové stránky. Pomáhajú nám zlepšovať spôsob, akým webové stránky fungujú. Tieto cookies nezhromažďujú informácie, ktoré by dokázali identifikovať vašu osobu."
        },
        "marketing": {
          "title": "Marketingové cookies",
          "bodyText": "Používajú sa na sledovanie preferencií používateľa webových stránok za účelom zacielenia reklamy, tj. zobrazenie marketingových a reklamných oznámení (aj na stránkach tretích strán) v súlade s týmito preferenciami. <strong>Marketingové súbory cookies využívajú nástroje externých spoločností. Tieto marketingové cookies budú použité iba na základe vášho súhlasu.</strong>"
        }
      },
      "save": "Uložiť nastavenia"
    },
    "youtube": {
      "text": "Na zobrazenie videa potrebujeme potvrdiť používanie cookies.Viac informácií nájdete {cookiePolicyLink}.",
      "cookiePolicyLinkText": "zásadách používania cookies",
      "accept": "Súhlasím"
    }
  },
  "thematic_counselling": {
    "dashboard": {
      "title": "Zaostrené na prevenciu",
      "hint": {
        "b2b": "Ako predchádzať nádorovým ochoreniam? {desktopBreakline}Ktoré preventívne vyšetrenia sú vhodné? Pýtajte sa.",
        "b2c": "Ako predchádzať nádorovým ochoreniam? {desktopBreakline}Ktoré preventívne vyšetrenia sú vhodné? Pýtajte sa zadarmo."
      },
      "mobileBannerButton": "Vstoupit do tematické poradny",
      "onco-prevention": {
        "title": "Ako na onkologickú prevenciu?",
        "short": "Chceme vám pomôcť s obavami z vážnej choroby. S našimi lekármi je cesta k informáciám jednoduchá.",
        "long": "Bojíte sa, že máte v rodine zvýšené riziko vzniku rakoviny?<br>Ktoré preventívne vyšetrenia sú vhodné?<br>Čo všetko sa dá zistiť z rôznych testov?<br>Naši lekári vám s tým radi pomôžu.",
        "footer": "⏱  Špecialisti v tejto poradni vám odpovedajú do 48h",
        "button": "Spýtať sa lekára",
        "profileSectionButton": "Poradiť sa"
      },
      "final": {
        "title": "Vaša otázka bola úspešne odoslaná",
        "text": "Teraz sa jej venuje náš odborník a hneď ako odpovie na vaše otázky, upozorníme vás e-mailom.",
        "button": "Hotovo"
      },
      "doctors": [
        {
          "name": "MUDr. František Rolinek",
          "specializations": [
            "Praktické lekárstvo pre dospelých"
          ],
          "institution": "MUDr. František Rolinek - ordinácia, Brno",
          "image": "TMP/mudr_frantisek_rolinek.jpeg"
        },
        {
          "name": "MUDr. Lenka Rudolfová",
          "specializations": [
            "Praktické lekárstvo pre dospelých"
          ],
          "institution": "Poliklinika AGEL, Praha",
          "image": "TMP/mudr_lenka_rudolfova.jpeg"
        }
      ]
    }
  },
  "TMP": {
    "fb": {
      "error": "Ospravedlňujeme sa za nepríjemnosti, ale teraz nie je možné sa prihlásiť cez účet na Facebooku. Vzniknuté technické problémy riešime s užívateľskou podporou Facebooku a pracujeme na ich odstránení. Skúste sa, prosím, znovu prihlásiť zajtra alebo zvoľte inú metódu pre prihlásenie/registráciu. Ďakujeme za pochopenie."
    }
  },
  "placeholders": {
    "date": {
      "year": "RRRR",
      "month": "MM",
      "date": "DD"
    },
    "time": {
      "hour": "hh",
      "minute": "mm"
    }
  },
  "putinSucks": {
    "helloImage": "hello-ua-tp-figure.svg",
    "helloImageAlt": "Lékařská poradna pro občany Ukrajiny",
    "dataProcessing": {
      "personalDataTitle": "Souhlas se zpracováním mých osobních údajů, včetně osobních údajů zvláštní kategorie"
    },
    "menu": {
      "question": "Poradit se",
      "helpWith": "Jak služba funguje?",
      "logoText": "Stojíme za Ukrajinou"
    },
    "subTitle": "Lékařská poradna pro občany Ukrajiny",
    "perex": "Léčíte se s lupénkou, avšak neúspěšně? Chcete o své nemoci vědět něco dalšího? Nebo máte kožní problémy a podezření, že by mohlo jít o lupénku? Pojďte vyplnit dotazník a zeptat se našich kožních lékařů v poradně uLékaře.cz.",
    "doctorInfo": {
      "text": "“Bez obav se na nás obraťte s jakýmkoliv zdravotním problémem, který potřebujete v České republice řešit. Velmi rádi vám poradí naši lékaři a sestry, kteří hovoří ukrajinsky a rusky. Uděláme vše, co bude v našich silách, abychom pomohli vám a vašim rodinám.“",
      "name": "MUDr. Soňa Boušková",
      "position": "Chief Medical Officer uLékaře.cz"
    },
    "infoTitle": "Jak služba funguje?",
    "infoListHeader": [
      {
        "icon": "check_circle",
        "text": "Poradíme bezplatne po celej Slovenskej republike."
      },
      {
        "icon": "check_circle",
        "text": "Lékaři a sestry se o vás postarají ve vašem rodném jazyce."
      },
      {
        "icon": "check_circle",
        "text": "Službu jsme pro vás zjednodušili, stačí vám e-mail a telefon."
      }
    ],
    "infoList": [
      {
        "icon": "ua/register",
        "text": "popište vaši potřebu do formuláře níže"
      },
      {
        "icon": "ua/mail",
        "text": "lékař vám odpoví e-mailem"
      },
      {
        "icon": "ua/objednavky",
        "text": "s nasmerovaním vám pomôžu sestry"
      }
    ],
    "question": "Vyplnit dotazník",
    "rules": "Pravidla poradny \"Linka o migréně\"",
    "form": {
      "title": "Dotazník",
      "thankYou": {
        "title": "Jsme rádi, že vám můžeme pomoci",
        "perex": "<p> Lekár sa vám ozve prostredníctvom e-mailu, prípadne vás bude kontaktovať sestra. </p>"
      }
    },
    "footer": {
      "perex": "V uLékaře.cz věříme, že zdraví je vaše. Prostřednictvím technologie, lidského přístupu a lékařské expertízy pomáháme lidem řídit si své zdraví."
    },
    "alertInfo": "Služba uLékaře.cz nenahrazuje záchrannou službu. <strong class='text-primary'>Při akutních potížích <a href='tel:155'>volejte linku 155</a>.</strong>"
  },
  "unavailableClinics": {
    "title": "Aplikáciu pre vás práve aktualizujeme",
    "description": "Ospravedlňujeme sa za krátkodobý výpadok služby. V súčasnej chvíli nasadzujeme nové vylepšenia aplikácie. O chvíľu budeme späť."
  },
  "releaseNotes": {
    "title": "Vitajte vo svojej zóne<br>zdravia uLekára.sk",
    "perex": "Dlhý život v zdraví máte na dosah, stačí urobiť prvý krok. S nami sa prevencia stane prirodzenou súčasťou vášho dňa, jednoducho a prehľadne. Ideme na to?",
    "content": [
      {
        "icon": "date-question",
        "text": "Kedy ste boli naposledy u praktického lekára a kedy tam máte ísť znova? Vyplňte termín a my sa postaráme, aby vám nič neušlo."
      },
      {
        "icon": "payment",
        "text": "Vedeli ste, že na prevencii môžete ušetriť za každého člena rodiny? Máme prehľad všetkého, čo vám preplatí vaša zdravotná poisťovňa."
      },
      {
        "text": "Postaráme sa za vás o absolvované aj nadchádzajúce termíny.",
        "icon": "report"
      }
    ],
    "primaryButtonText": "Začať s prevenciou",
    "secondaryButtonText": "Otestovať sa",
    "csas": {
      "title": "Co je v domě, to je pro mě!",
      "perex": "Na pražské centrální pobočce jsme otevřeli ordinaci praktického lékaře v Centru zdraví. Vítáme všechny zaměstnance České spořitelny a jejich rodiny.",
      "content": [
        "Klientský přístup, diskrétnost a milí lékaři, kteří vás skutečně vyslechnou. A pomohou.",
        "Postaráme se i o vaše blízké. Péče všem zůstává bez ohledu na vaše zaměstnání.",
        "Za dobrým praktikem se vyplatí dojet. Ordinaci najdete přímo u metra Budějovická."
      ],
      "primaryButtonText": "Chci se registrovat"
    }
  },
  "healthInsuranceProviderBenefits": {
    "dashboard": {
      "title": "Príspevky poisťovne",
      "text": "Zistite, aké benefity má pre vás vaša poisťovňa."
    },
    "title": "Vyberte svoju poisťovňu",
    "privateInsuranceProviders": "Súkromné poisťovne",
    "publicInsuranceProviders": "Verejné poisťovne",
    "showDetail": "Zobraziť podrobnosti",
    "hideDetail": "Skryť podrobnosti",
    "buttonText": "Uložiť poisťovňu a zobraziť",
    "empty": {
      "title": "Žiadne príspevky",
      "text": "Vybraná poisťovňa bohužial príspevky&nbsp;neponúka"
    },
    "fullInfo": {
      "base": "Kompletnú ponuku a podmienky príspevkov nájdete na {link}.",
      "linkText": "stránkach poisťovne"
    },
    "footer": {
      "updated": "Aktualizované {date}",
      "changeCompanyInSettings": "Zmeniť poisťovňu v nastavení",
      "changeCompany": "Zmeniť poisťovňu"
    }
  },
  "explore": {
    "title": "Objavujte",
    "searchTitle": "Späť na Objavujte",
    "subtitle": "Prečítajte si zdravotné tipy, doporučenia, alebo príbehy",
    "stories": {
      "title": "Rychlé tipy"
    },
    "articles": {
      "title": "Články",
      "searchTitle": "Články o tématu",
      "titleDetail": "Detail článku",
      "allChip": "Vše",
      "shareText": "Posielam zaujímavý článok od uLékaře.cz",
      "footer": {
        "title": "Napadla vás pri čítaní otázka, ktorú chcete položiť lekárovi?",
        "textQuestion": "Radi odpovieme na akúkoľvek otázku ohľadom vášho zdravia, zdravia vášho blízkeho či tohto článku.",
        "textQuestionOrder": "Radi odpovieme na akúkoľvek otázku ohľadom vášho zdravia, zdravia vášho blízkeho či tohto článku."
      }
    },
    "consultations": {
      "title": "Odpovědi lékařů",
      "titleNoTags": "Podobné dotazy",
      "searchTitle": "Dotazy o tématu",
      "titleDetail": "Detail dotazu",
      "allChip": "Aktuálně",
      "answering": "Odpovídá",
      "answeringDoctor": "Odpovídá lékař",
      "more": "Další",
      "answers": "Odpovědi",
      "disclaimer": {
        "title": "Nebojte, vaše dotazy nezveřejníme.",
        "subtitle": "Tato databáze obsahuje pouze dotazy uživatelů, kteří se zeptali mimo klientskou zónu a souhlasili se zveřejněním."
      }
    },
    "search": {
      "emptyTitle": "Pod výrazem “{query}” se nám nepovedlo nic najít",
      "placeholder": "Hledejte články, témata..."
    },
    "podcasts": {
      "title": "Podcasty"
    }
  },
  "invitation": {
    "dashboard": {
      "title": "Pozvite rodinu",
      "text": "Služba uLekára.sk pre vašu rodinu. Zadarmo.",
      "buttonText": "Zdieľať pozvánku"
    },
    "title": "Zdravie pre celú rodinu",
    "text": "Pozvite členov svojej rodiny úplne zadarmo. Dáte im tak možnosť nosiť vo vrecku cez 350 lekárov a sestier dostupných 24/7.",
    "list": [
      {
        "icon": "link",
        "text": "Skopírujte odkaz na zdieľanie služby"
      },
      {
        "icon": "rodina",
        "text": "Pošlite ho svojim blízkym."
      },
      {
        "icon": "confetti",
        "text": "Po registrácii sa aktivuje služba zadarmo"
      }
    ],
    "shareLink": "Odkaz na zdieľanie",
    "copyCode": "Skopírovať odkaz",
    "codeCopied": "Skopírované",
    "familyTitle": "Správa rodiny",
    "remove": "Odobrať",
    "shareTitle": "Služba uLekára.sk zadarmo.",
    "shareText": "{personName} s vami zdieľa službu uLekára.sk v rámci rodiny. Budete ju mať zadarmo. Stačí sa zaregistrovať cez odkaz.",
    "emptyMemberName": "Člen rodiny"
  },
  "languageSwitcher": {
    "cz": "Čeština",
    "sk": "Slovenčina",
    "en": "English",
    "uk": "Українська",
    "ru": "Русский язык",
    "hu": "Magyar"
  },
  "medicalProcedure": {
    "editReport": "Upraviť",
    "markAsDone": "Označiť za splnené",
    "notes": "Vaše poznámky",
    "notesPlaceholder": "Pridajte svoje osobné poznámky ...",
    "uploadFiles": "Nahrajte súbory",
    "information": "Informácie",
    "content": {
      "content1": "Čo ma čaká?",
      "content2": "Ako sa mám pripraviť?",
      "content3": "Je prehliadka hradená?",
      "content4": "Ako na to?",
      "content5": "Kedy robiť vyšetrenie?",
      "content6": "Čo keď nájdem niečo znepokojivé?",
      "content7": "Ako sa prenáša?",
      "content8": "Existuje nejaká prevencia?",
      "content9": "Akú vakcínu mám zvoliť?"
    },
    "boxes": {
      "recommended": "Doporučené",
      "male": "Mužom",
      "female": "Ženám",
      "from": "od",
      "interval": "Interval",
      "showDetail": "Zobraziť detail",
      "letsStart": "Poďme začať",
      "noRecords": "Nevyplnené"
    },
    "examination": {
      "title": "Detail prehliadky",
      "add": "Zaznamenať prehliadku",
      "listTitle": "Moje prehliadky",
      "newFormPerex": "Zapíšte si dátum prehliadky. Môžete si taktiež uložiť poznámky a súbory (foto, lekárske správy atď.).",
      "editFormPerex": "Tu si môžete upraviť dátum, poznámky a spravovať súvisiace súbory.",
      "optional": "Dobrovolná prehliadka",
      "recommended": "Povinná prehliadka",
      "type": "Prehliedka",
      "nextBy": "Ďalšia prehliadka do",
      "next": "Ďalšia prehliadka",
      "last": "Posledná prehliadka",
      "new": "Nová prehliedka",
      "date": "Dátum prehliadky",
      "time": "Čas prehliadky",
      "past": "Absolvovaná",
      "pastMulti": "Absolvované",
      "future": "Nadchádzajúce",
      "missedNotification": "Bol prekročený predpísaný interval prehliadky.",
      "emptyNotification": "Tu si můžete zapisovať a spravovať svoje prehliadky.",
      "errorDateEmpty": "Vyplňte prosím dátum prehliadky.",
      "errorDateBoundsPast": "Vyplňte prosím dátum už absolvovanej prehliadky.",
      "errorDateBoundsFuture": "Termín musí byť v budúcnosti.",
      "todayDateCheckboxLabel": "Prehliadka prebehla dnes",
      "errorTimeRequired": "Vyplňte prosím čas prohlídky",
      "manageReports": "Moje prehliadky",
      "emptyPlaceholder": {
        "title": "Zaznamenajte si prvú prehliadku",
        "perex": "Udržať si prehľad vo svojich prehliadkach nebolo nikdy jednoduchšie"
      }
    },
    "vaccination": {
      "title": "Detail očkovania",
      "add": "Zaznamenať očkovanie",
      "listTitle": "Moje očkovanie",
      "newFormPerex": "Zapíšte si dátum očkovania. Môžete si taktiež uložiť poznámky a súbory (foto, lekárske správy atď.).",
      "editFormPerex": "Tu si môžete upraviť dátum, poznámky a spravovať súvisiace súbory.",
      "optional": "Dobrovolné očkovanie",
      "recommended": "Povinné očkovanie",
      "type": "Očkovanie",
      "nextBy": "Ďalšie očkovanie do",
      "next": "Ďalšie očkovanie",
      "last": "Posledné očkovanie",
      "new": "Nové očkovanie",
      "date": "Dátum očkovania",
      "time": "Čas očkovania",
      "past": "Absolvované",
      "pastMulti": "Absolvované",
      "future": "Nadchádzajúce",
      "missedNotification": "Bol prekročený predpísaný interval očkovania.",
      "emptyNotification": "Tu si môžete zapisovať a spravovať svoje očkovania.",
      "errorDateEmpty": "Vyplňte prosím dátum očkovania.",
      "errorDateBoundsPast": "Vyplňte prosím dátum už absolvovaného očkovania.",
      "errorDateBoundsFuture": "Termín musí byť v budúcnosti.",
      "todayDateCheckboxLabel": "Očkovanie prebehlo dnes",
      "errorTimeRequired": "Vyplňte prosím čas očkování",
      "manageReports": "Moje očkovanie",
      "emptyPlaceholder": {
        "title": "Zaznamenajte si prvé očkovanie",
        "perex": "Udržať si prehľad vo svojich očkovaniach nebolo nikdy jednoduchšie"
      }
    },
    "trash": {
      "title": "Naozaj chcete záznam vymazať?",
      "text": "Záznam vrátane prípadných poznámok a príloh nenávratne vymažte.",
      "keep": "Ponechať",
      "delete": "Vymazať záznam"
    }
  },
  "intervals": {
    "months": {
      "single": "mesiac",
      "plural": "mesiacov",
      "semi": "mesiace"
    },
    "years": {
      "single": "rok",
      "plural": "rokov",
      "semi": "roky"
    }
  },
  "aeskulab": {
    "title": "Žiadosť o interpretáciu výsledkov laboratórnych testov",
    "text": "Jednoduchým spôsobom môžete získať písomnú interpretáciu výsledkov svojho vyšetrenia, ktoré prebehlo v laboratóriu Unilabs. Vaše výsledky posúdi buď interný lekár, alebo klinický genetik. V rámci jednej zakúpenej interpretácie poskytne svoje stanovisko iba jeden z nich.",
    "buttonText": "Vyplniť  žiadosť",
    "howItWorks": {
      "title": "Ako to funguje?",
      "items": [
        {
          "icon": "chat",
          "perex": "Odošlite žiadosť s priloženým pdf dokumentom s výsledkami laboratórnych testov."
        },
        {
          "icon": "mail",
          "perex": "Do 24 hodín vám pošleme interpretáciu výsledkov testov prostredníctvom e-mailu."
        },
        {
          "icon": "calendar/date-31",
          "perex": "Ak bude treba, môžete si následne dohodnúť telefonický hovor so zdravotnou sestrou."
        }
      ]
    },
    "form": {
      "thankYou": {
        "title": "Ďakujeme za vašu žiadosť",
        "perex": "Vaše laboratórne výsledky a všetky údaje sme práve odoslali na spracovanie.\nInterpretáciu výsledkov testov dostanete do 24 hodín prostredníctvom e-mailu."
      },
      "personalData": {
        "text": "Zoznámil/-a som sa so {link} poskytovateľa zdravotných služieb uLékaře.cz Health Care",
        "link": "zásadami spracovania osobných údajov"
      },
      "termsConds": {
        "text": "Zoznámi/-al som sa s {link} a so {cookies} a súhlasím s nimi.",
        "link": "podmienkami používania platformy uLékaře.cz",
        "cookies": "zásadami používania súborov cookie platformy uLékaře.cz"
      }
    },
    "formTitle": "Formulár žiadosti",
    "email": "health.care@ulekare.cz",
    "phone": "+420&nbsp;253&nbsp;253&nbsp;155",
    "errorAuthorization": "Váš odkaz je neplatný, kontaktujte prosím oddelenie starostlivosti o zákazníkov <a href=\"https://sk.unilabs.online/faq\" target=_blank\">sk.unilabs.online</a>.",
    "formButtons": {
      "text": "Použijeme údaje z webu sk.unilabs.online",
      "others": "Pýtam sa na inú osobu"
    },
    "emergency": "Služba uLékaře.cz nenahrádza záchrannú službu. Pri akútnych problémoch <a href=\"tel:155\" class=\"link--inline black--text\">volajte linku 155</a>.",
    "footer": {
      "copyright": "&copy; {thisYear} uLékaře.cz Health Care, s.r.o.",
      "leftText": "Poskytovateľ zdravotných služieb uLékaře.cz Health Care, s.r.o. Prevádzku webových stránok zaisťuje spoločnosť uLékaře.cz, s.r.o.",
      "rightText": "Unilabs je prevádzkovateľ služby sk.unilabs.online a najväčší poskytovateľ laboratórnych služieb a diagnostiky na Slovensku."
    }
  },
  "dateInput": {
    "errors": {
      "invalidFormatDate": "Vyplňte prosím dátum v správnom formáte medzi {min} a {max}",
      "invalidFormatMonth": "Vyplňte prosím mesiac v správnom formáte medzi {min} a {max}",
      "labTests": {
        "errorUnder18": "Nie je možné podať žiadosť o interpretáciu laboratórnych výsledkov u detí. Interpretáciu poskytujeme u dospelých starších ako 18 rokov v odboroch interné lekárstvo a klinická genetika."
      }
    }
  },
  "timeInput": {
    "errors": {
      "invalidFormat": "Vyplňte prosím čas v správnom formáte medzi 0:00 a 23:59",
      "required": "Vyplňte prosím čas"
    }
  },
  "feedback": {
    "text": "Vaše hodnotenie je náš vitamín. Zlepšujeme zdravie tejto aplikácie aj&nbsp;vďaka vám.",
    "label": "Máte nejaké nápady na zlepšenie?",
    "placeholder": "Tu nám ich môžete prezradiť...",
    "thankYou": {
      "title": "Ďakujeme za spätnú väzbu",
      "text": "Urobíme maximum, aby sme vám uľahčili starostlivosť o&nbsp;zdravie."
    },
    "menu": "Spätná väzba",
    "panelButton": "Vyplniť spätnú väzbu"
  },
  "newsletterAgreement": {
    "dashboard": {
      "title": "Zdravie e-mailom",
      "text": "Novinky a zľavy vám pošleme do e-mailu."
    },
    "title": "Pošleme vám zdravie do schránky",
    "perex": "Tu začína vaša cesta k dlhodobému zdraviu.",
    "content": [
      {
        "icon": "confetti",
        "text": "Pravidelné tipy, ako si udržať životnú pohodu."
      },
      {
        "icon": "care",
        "text": "Zaujímavé zľavy na pomocníkov, ktorí utužujú zdravie."
      },
      {
        "icon": "news",
        "text": "Upozornenie na nové články, ktoré vás baví čítať."
      }
    ],
    "footer": {
      "text": "Kliknutím na tlačidlo \"Odoberať\" súhlasíte so {link}.",
      "linkText": "zaslaním marketingových oznámení"
    }
  },
  "bloodReport": {
    "infoStep": {
      "title": "Vaše zdraví s vysvětlivkami",
      "perex": "Posviťte si na své zdraví. Krevní testy a podrobný komentář lékaře vám pomohou porozumět vašemu tělu.",
      "list": [
        {
          "icon": "register",
          "text": "Popíšete svůj aktuální zdravotní stav, aby doporučení lékařů sedělo přímo na tělo."
        },
        {
          "icon": "calendar/date-31",
          "text": "Doporučíme vám vhodný test. Čas a místo odběru si vyberete podle sebe."
        },
        {
          "icon": "doctor",
          "text": "Výsledky dorazí z v laboratoře. Náš lékař vám je srozumitelně vysvětlí."
        }
      ],
      "legal": [
        "Služba Interpretace laboratorních výsledků je zdravotní službou poskytovanou {link} na dálku, a to pouze v oboru vnitřního lékařství.",
        "Zdravotní služba Interpretace laboratorních výsledků není hrazena z veřejného zdravotního pojištění. Její cenu hradí Váš zaměstnavatel.",
        "Vaše osobní údaje zpracováváme v souladu se {link}."
      ],
      "legalLinkTexts": [
        "nezávislými poskytovateli zdravotních služeb",
        {},
        "Zásadami ochrany osobních údajů"
      ],
      "serviceText": "\n      Službu Vám zprostředkujeme u následujících poskytovatelů zdravotních služeb:<br/>\n      <br/>\n      provedení odběru krve a zhotovení laboratorních výsledků:<br/>\n      Unilabs Diagnostics k.s.<br/>\n      se sídlem Evropská 2589/33b, Dejvice, 160&nbsp;00&nbsp;Praha&nbsp;6<br/>\n      IČO: 604&nbsp;70&nbsp;488<br/>\n      vedená u&nbsp;Městského soudu v&nbsp;Praze pod sp.&nbsp;zn.&nbsp;A&nbsp;76193<br/>\n      <br/>\n      interpretace laboratorních výsledků:<br/>\n      uLékaře.cz Health Care, s.r.o.<br/>\n      se sídlem Českomoravská 2408/1a, Libeň, 190&nbsp;00&nbsp;Praha&nbsp;9<br/>\n      IČO: 096&nbsp;64&nbsp;777<br/>\n      vedená u Městského soudu v Praze pod sp.&nbsp;zn.&nbsp;C&nbsp;339989\n      ",
      "agreements": {
        "termsAndConditions": {
          "text": "Souhlasím s {link} poskytovatele zdravotních služeb uLékaře.cz Health Care, s.r.o.",
          "linkText": "Podmínkami poskytnutí služby Interpretace laboratorních výsledků"
        }
      }
    },
    "finalStep": {
      "title": "Co vás čeká dál?",
      "text": "Děkujeme za informace. Pomohou lékařům správně vyhodnotit výsledky vašich testů. Nyní vás předáme do rukou Unilabs – naší partnerské laboratoře.",
      "button": "Přejít do Unilabs",
      "list": [
        {
          "title": "Krok 1",
          "text": "Vyberete si laboratorní test"
        },
        {
          "title": "Krok 2",
          "text": "Rezervujete místo a termín, přijdete na odběr"
        },
        {
          "title": "Krok 3",
          "text": "Doručíme vám výsledky s vysvětlením lékaře"
        }
      ]
    }
  },
  "addressInput": {
    "country": "Štát",
    "postcode": "PSČ",
    "street": "Ulica a číslo domu"
  },
  "videocall": {
    "chooseDate": "Vyberte si dátum",
    "confirmReservation": "Potvrdiť rezerváciu",
    "reservationProgressing": "Potvrdzovanie prebieha",
    "dayOfWeek": [
      "Ne",
      "Po",
      "Ut",
      "St",
      "Št",
      "Pi",
      "So"
    ],
    "month": [
      "Január",
      "Február",
      "Marec",
      "Apríl",
      "Máj",
      "Jún",
      "Júl",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    "thankYou": {
      "info": "Všetky potrebné informácie sme vám poslali e-mailom.",
      "success": "Videohovor bol úspešne naplánovaný 🎉",
      "close": "Zavrieť"
    }
  },
  "videoTherapy": {
    "infoStep": {
      "perex": "Pracovné, partnerské či psychické problémy s vami preberie Mgr. Michaela Štěpánová. Čaká vás 50-minútové online sedenie v súkromí.",
      "title": "Nie je vám dobre na duši?",
      "list": {
        "third": "Potvrdené? V e-maile nájdete odkaz, cez ktorý sa pripojíte \n s terapeutom k videohovoru.",
        "second": "Vyberte deň a čas, kedy by ste sa radi stretli s terapeutom online.",
        "first": "Najskôr skontrolujte svoje osobné a kontaktné údaje."
      },
      "legal": [
        "Službu Vám sprostredkuje poskytovateľ nezdravotných služieb, ktorým je spoločnosť:",
        "uLekára.sk, \nso sídlom Českomoravská 1a, 190 00 Praha 9, IČO: 05341051, \nvedená na Mestskom súde v Prahe pod sp. zn. C 262183",
        "Službu Videohovor s terapeutom hradí Váš zamestnávateľ.",
        "Služba Videohovor s terapeutom je nezdravotnou službou poskytovanou na diaľku formou videohovoru."
      ],
      "therapist": {
        "image": "mgr_vera_kudlickova_duskova.png",
        "name": "Mgr. Věra Kudličková Dušková",
        "specialization": "Psychologička z uLekára.sk",
        "workplace": "Psychológia"
      }
    },
    "formStep": {
      "legal": {
        "termsConditions": {
          "text": "Súhlasím s {legalText} Videohovor s terapeutom poskytovaného službou uLekára.sk"
        }
      }
    }
  },
  "homepage": {
    "hero": {
      "title": "<span>Zdraví</span><br/><span>zamestnanci.</span><br/><span style=\"opacity: .6\">Od&nbsp;hlavy&nbsp;po päty.</span>",
      "bottomText": "<div><span>Pomáhame vašim zamestnancom</span><br/>\n<span>prežiť život v zdraví. Tým zvyšujeme produktivitu</span><br/>\n<span>a znižujeme náklady vašej firmy.<span/></div>"
    },
    "header": {
      "nav": {
        "login": "Prihlásiť sa",
        "link": [
          "Čo robíme",
          "Prečo uLekára.sk",
          "Referencie",
          "Naša služba"
        ]
      }
    },
    "data": {
      "title": "<span class=\"translucent\">Zdravie je biznis</span><br />\n      každej firmy.",
      "card": [
        {},
        {
          "animationData": "data_02.json",
          "caption": "Život v zdraví",
          "header": "Zamestnanci starnú.",
          "paragraph": [
            "Po 50. roku života trávia zamestnanci viac času v čakárňach a ordináciách.",
            "Firmy však potrebujú zamestnancov, ktorí sú fyzicky a duševne zdraví až do vysokého veku. ",
            "Službou uLekára.sk pomôžete svojim ľuďom oddialiť nástup choroby alebo zachytiť chorobu včas."
          ]
        },
        {
          "animationData": "data_03.json",
          "caption": "Vplyvy na naše zdravie",
          "header": "Zdravie nie je náhoda.",
          "paragraph": [
            "Zdravie najviac ovplyvňujú naše návyky a správanie, oveľa viac ako zdravotná starostlivosť.",
            "Svoju úlohu zohráva aj pracovné a životné prostredie, genetika, sociálno-ekonomické faktory, ako je vzdelanie, zamestnanie, vzťahy.",
            "So službou uLekára.sk máte k dispozícii účinný nástroj na motiváciu zamestnancov k zdravšiemu životu."
          ]
        }
      ]
    },
    "circle": {
      "card": [
        {
          "icon": "circle-placeholder-first.svg",
          "title": "Meriame údaje",
          "desktop": [
            "Zdravie neodhadujeme, zdravie meriame.",
            "Podnikom pomáhame naplňovať ich ciele v oblasti sociálnej zodpovednosti v rámci ESG a uľahčujeme prípravu reportingu."
          ],
          "cta": {
            "href": "https://sites.google.com/ulekare.cz/zdravijevase/v%C5%A1e-o-esg",
            "label": "Viac o ESG"
          }
        },
        {
          "icon": "circle-placeholder-second.svg",
          "title": "Vzdelávame",
          "desktop": [
            "Posilňujeme znalosti HR oddelenia a manažmentu o dôležitosti zdravia a pohody zamestnancov. Komunita zdravých firiem otvára svoje dvere všetkým HR, ktorí hľadajú podporu nielen v starostlivosti o firemné zdravie.",
            "Komunita zdravých firiem otvára svoje dvere všetkým HR, ktorí hľadajú podporu nielen v starostlivosti o firemné zdravie."
          ],
          "mobile": [
            "Posilňujeme znalosti HR oddelenia a manažmentu o dôležitosti zdravia a pohody zamestnancov. Komunita zdravých firiem otvára svoje dvere všetkým HR, ktorí hľadajú podporu nielen v starostlivosti o firemné zdravie."
          ],
          "cta": {
            "label": "Viac o komunite"
          }
        },
        {
          "icon": "circle-placeholder-third.svg",
          "title": "Aktívne riešime",
          "desktop": [
            "Na základe údajov a potrieb vašej firmy podnikneme praktické kroky, ktoré vás priblížia k lepšiemu firemnému zdraviu. Pripravíme pre vás balík služieb, od online poradenstva cez objednávanie, videohovor s lekárom až po Dni zdravia.",
            "Následná edukácia v oblasti prevencie zdravia je založená aj na údajoch, ktoré získate z pravidelného reportingu."
          ],
          "mobile": [
            "Na základe údajov a potrieb vašej firmy podnikneme praktické kroky, ktoré vás priblížia k lepšiemu firemnému zdraviu. Pripravíme pre vás balík služieb, od online poradenstva cez objednávanie, videohovor s lekárom až po Dni zdravia."
          ],
          "cta": {
            "label": "Viac o službe"
          }
        }
      ],
      "altText": "Kruh zdravia"
    },
    "community": {
      "main": {
        "header": {
          "caption": "Komunita zdravých firiem",
          "heading": "Nový level HR:",
          "description": "odborníci na zdravie."
        }
      },
      "card": [
        {
          "img": "hobzova.png",
          "name": "Lucie Hobžová, Asahi Europe & International",
          "position": "HR Operations Lead"
        },
        {
          "img": "solcova.png",
          "name": "Šárka Šolcová, ZF Automotive Czech",
          "position": "Country LTOR Expert"
        },
        {
          "img": "svobodova.png",
          "name": "Jiřina Svobodová, J&T Banka",
          "position": "Špecialista na benefity"
        },
        {
          "img": "ryskova.png",
          "name": "Petra Ryšková, Axa",
          "position": "Senior HR Business Partner CEE"
        },
        {
          "img": "valtera.png",
          "name": "Jan Valtera, AB InBev",
          "position": "Health and Wellbeing Project Manager"
        },
        {
          "img": "volfova.png",
          "name": "Lenka Volfová, Inštitút biostatistiky a analýz, s.r.o.",
          "position": "HR Manager a Business Partner"
        },
        {
          "img": "kruzikova.png",
          "name": "Lenka Kružíková, Innogy Česká republika a.s.",
          "position": "Senior Manager, Human Resources"
        }
      ],
      "more": "Viac o komunite"
    },
    "service": {
      "card": [
        {
          "heading": "Nástroj pre zamestnancov",
          "text": "Lekárska poradňa online, pomoc sestričiek s objednaním k lekárovi, inteligentný kalendár prevencie a ďalšie služby – starostlivosť o zdravie majú zamestnanci poruke.",
          "cta": {
            "label": "Viac o službe"
          }
        },
        {
          "heading": "Cenné dáta pre HR",
          "text": "Vďaka využívaniu služby uLekára.sk zistíte, s čím vaši ľudia potrebujú pomôcť. Na základe získaných informácií pripravíme firme riešenie priamo na telo.",
          "cta": {
            "href": "/sluzba",
            "label": "Viac o službe"
          }
        }
      ]
    },
    "claim": [
      {
        "text": [
          "Znižujeme <span class=\"text--black translucent\"> absenciu </span>",
          "<span class=\"text--black translucent\"> a firemné náklady. </span>"
        ]
      },
      {
        "text": [
          "<span class=\"text--black translucent\"> Zvyšujeme </span> skóre ESG",
          "<span>a produktivitu práce.</span>"
        ]
      },
      {
        "text": [
          "<span class=\"text--black translucent\">Zlepšujeme pohodu</span>",
          "<span>a zdravie zamestnancov.</span>"
        ]
      }
    ],
    "vision": {
      "people": [
        {
          "name": "Martin Pospíšil",
          "position": "CEO",
          "blurb": "Či má vaša firma dvadsať, alebo 20-tisíc zamestnancov, či pracujete hlavou, alebo rukami, uLekára.sk vám pomáha plánovať zdravie vašich zamestnancov. O firmy sa staráme už od roku 2018.",
          "video": "vision_martin"
        },
        {
          "name": "Magda Blažková",
          "position": "B2B manager",
          "blurb": "Či má vaša firma dvadsať, alebo 20-tisíc zamestnancov, či pracujete hlavou, alebo rukami, uLekára.sk vám pomáha plánovať zdravie vašich zamestnancov. O firmy sa staráme už od roku 2018.",
          "video": "vision_magda"
        },
        {
          "name": "Tomáš Šebek",
          "position": "Spoluzakladateľ",
          "blurb": "Či má vaša firma dvadsať, alebo 20-tisíc zamestnancov, či pracujete hlavou, alebo rukami, uLekára.sk vám pomáha plánovať zdravie vašich zamestnancov. O firmy sa staráme už od roku 2018.",
          "video": "vision_tomas"
        },
        {
          "name": "Tereza Čiháková",
          "position": "HR generalist",
          "blurb": "Či má vaša firma dvadsať, alebo 20-tisíc zamestnancov, či pracujete hlavou, alebo rukami, uLekára.sk vám pomáha plánovať zdravie vašich zamestnancov. O firmy sa staráme už od roku 2018.",
          "video": "vision_tereza"
        },
        {
          "name": "Danica Fričová",
          "position": "Všeobecný lekár",
          "blurb": "Či má vaša firma dvadsať, alebo 20-tisíc zamestnancov, či pracujete hlavou, alebo rukami, uLekára.sk vám pomáha plánovať zdravie vašich zamestnancov. O firmy sa staráme už od roku 2018.",
          "video": "vision_danica"
        }
      ]
    },
    "contact": {
      "title": "<span class=\"translucent\">Poďme prebrať</span><br />\n        zdravie vašej firmy.",
      "persona": {
        "img": "martin-cuba.png",
        "name": "Martin Čuba",
        "subtitle": "Zdravím, tu je Martin.",
        "text": "Dohodneme si nezáväznú konzultáciu,<br />\n        počas ktorej vám radi a bezplatne poradíme<br />\n        s meraním firemného zdravia<br />\n        a so zvýšením produktivity."
      },
      "email": "partner@ulekara.sk",
      "phone": "tel:+420603841995",
      "phoneDisplay": "+420 603 841 995",
      "form": {
        "companyName": {
          "label": "Názov spoločnosti",
          "placeholder": "Vaša firma sro",
          "error": "Uveďte názov spoločnosti."
        },
        "contactName": {
          "label": "Kontaktná osoba",
          "placeholder": "Ján Zdravý",
          "errorDigits": "Meno nesmie obsahovať iné znaky ako písmená.",
          "error": "Uveďte svoje meno a priezvisko."
        },
        "email": {
          "label": "Pracovný e-mail",
          "placeholder": "firemni@mail.cz",
          "error": "Zadajte e-mail v správnom formáte."
        },
        "phoneNumber": {
          "label": "Telefónne číslo",
          "placeholder": "123 456 789",
          "error": "Číslo nesmie obsahovať iné znaky ako číslice."
        },
        "consentLabel": "Súhlasím so <a class=\"text--primary\" style=\"color: #3ca091 !important;\" href=\"https://www.ulekare.cz/suhlas-so-spracuvanim-osobnych-udajov-na-ucely-hr-informacii\" target=\"_blank\">spracovanim osobných údajov</a> na informačné účely v oblasti ľudských zdrojov.",
        "submit": "Odoslať",
        "footer": "Kliknutím na tlačidlo ‚Odoslať‘ súhlasíte s tým, že vás môžeme v priebehu nasledujúcich 6 mesiacov kontaktovať s ponukami vhodnými pre vaše podnikanie.\n         <a\n          href=\"https://app.ulekara.sk/zasady-spracovania-osobnych-udajov\"\n          class=\"text--primary\"\n          style=\"color: #3ca091 !important;\"\n          data-section=\"kontakt\"\n          >Prečítajte si viac o ochrane súkromia.</a>",
        "thankYou": "Ďakujeme, že beriete zdravie svojich zamestnancov vážne.",
        "thankYouSubtext": "Ozveme sa vám počas nasledujúcich pracovných dní.",
        "mobile": {
          "thankYou": "Ďakujeme za váš záujem.",
          "thankYouSubtext": "Ozveme sa vám najneskôr nasledujúci pracovný deň.",
          "backToForm": "Späť na formulár"
        }
      },
      "letsTalk": {
        "heading": "Zaujíma vás, čo vieme?\nZavolajte mi alebo napíšte.",
        "link": "Kontakty"
      },
      "mail": {
        "subject": "Na zdraví Vašich zamestnancov nám záleží, čoskoro sa Vám ozveme",
        "content": "Pekný deň,<br/><br/>\nďakujeme za Váš záujem o službu Zdravie a prevencia vo firme. Sme radi, že sa staráte o zdravie svojich zamestnancov. Ozveme sa Vám najneskôr nasledujúci pracovný deň.<br/><br/>\nS pozdravem<br/><br/>\nMartin Čuba, Business Development Manager<br/>\ne-mail: <a href=\"mailto:partner@ulekara.sk\">partner@ulekara.sk\ntel.: <a href=\"tel:00420602413933\">+420 603 841 995</a><br/>",
        "footer": {
          "copyright": "uLekára.sk"
        }
      }
    },
    "iso": {
      "header": {
        "text": "viac než 200 ďalších"
      },
      "point": [
        "Prechádzame pravidelným externým auditom na bezpečnosť údajov",
        "Údaje sú šifrované a pravidelne zálohované",
        "Riadime prístup k citlivým informáciám a používame dvojfázové overenie",
        "Pravidelne absolvujeme školenia o GDPR a bezpečnosti informácií"
      ],
      "partner": [
        {
          "img": "cs.svg",
          "alt": "Česká spořitelna"
        },
        {
          "img": "aimtec.svg",
          "alt": "Aimtec"
        },
        {
          "img": "ikea.svg",
          "alt": "Ikea"
        },
        {
          "img": "tmobile.svg",
          "alt": "T-Mobile",
          "id": "tmobile"
        },
        {
          "img": "etnetera.svg",
          "alt": "Etnetera",
          "hideOnMobileSecond": "1"
        }
      ],
      "badge": [
        {
          "img": "isofirst.svg",
          "alt": "ISO 9001"
        },
        {
          "img": "isosecond.svg",
          "alt": "ISO/IEC 27001"
        }
      ]
    },
    "footer": {
      "value": [
        "Ľudskosť.",
        "Nadšenie.",
        "Odbornosť.",
        "Inovácie."
      ],
      "about": "Vytvárame tie najzdravšie pracovné prostredia po celom svete a poskytujeme špičkovú starostlivosť o zdravie riadenú údajmi. \n       Pomáhame firmám dlhodobo a systematicky udržiavať zdravie ich zamestnancov.",
      "copyright": "uLékaře.cz, s.r.o.",
      "nav": {
        "link": [
          {
            "href": "https://app.ulekara.sk/podmienky-pouzivania",
            "label": "Podmienky používania"
          },
          {
            "href": "https://app.ulekara.sk/zasady-spracovania-osobnych-udajov",
            "label": "Zásady spracovania osobných údajov"
          },
          {
            "href": "https://app.ulekara.sk/cookies",
            "label": "Vyhlásenie o súboroch cookie"
          }
        ]
      },
      "aside": {
        "link": [
          {},
          {},
          {
            "href": "https://www.linkedin.com/company/ulek%C3%A1ra-sk",
            "label": "LinkedIn",
            "img": "linkedin.svg"
          },
          {
            "href": "https://www.youtube.com/@ulekarecz397",
            "label": "YouTube",
            "img": "youtube.svg"
          }
        ]
      },
      "logo": {
        "alt": "uLekára.sk"
      }
    }
  },
  " profile": {
    "benefits": {
      "content_explore": {
        "chip": "Objavujte"
      }
    }
  },
  "profil": {
    "benefit": {
      "card": {
        "family": "Aktívny (člen rodiny)"
      }
    }
  },
  "servicePage": {
    "header": {
      "consultation": "Čo robíme",
      "forCompanies": "Pre firmy",
      "articles": "Články",
      "references": "Hovoria o nás",
      "submenu": {
        "consultations": "Odpovede lekárov",
        "thematicCounselling": "Tematické poradne",
        "diseases": "Choroby",
        "firstAid": "Prvá pomoc",
        "contact": "Kontakt",
        "career": "Kariéra"
      },
      "login": "Prihlásiť sa"
    },
    "hero": {
      "title": "Starostlivosť o zdravie online, rýchlo a s úsmevom",
      "subtitle": "Lekársky názor nonstop a starostlivosť o vaše zdravie, akú si zaslúžite. Pretože zdravie je vaše.",
      "registerButton": "Zaregistrujte sa zadarmo",
      "whatWeHelpWithButton": "S čím môžeme pomôcť?"
    },
    "consultation": {
      "title": "Lekárska poradňa online",
      "opinionCard": {
        "title": "Názor lekára bez klopania na ordináciu",
        "subtitle": "Dobre, že sa pýtate…",
        "perex": "Od vyrážky až po vážne ochorenie, od praktického lekára až po špecialistu ktoréhokoľvek odboru. Tím 350+ lekárov a špecialistov nonstop poruke Žiadny problém pre nás nie je banalita.",
        "button": "Položte prvú otázku"
      },
      "videocallCard": {
        "title": "Videohovor s lekárom, keď pár riadkov nestačí",
        "subtitle": "Už čoskoro v aplikácii",
        "perex": "Žiadne dochádzanie a čakanie na termín, stačí si dohodnúť videohovor. Naši lekári sa tešia na stretnutie s vami."
      },
      "specialistCard": {
        "title": "Druhá odpoveď priamo od špecialistu",
        "perex": "Vašou otázkou sa bude hneď zaoberať praktický lekár alebo pediater, prípadne sa k nej vyjadrí aj špecialista. Odpovedajú lekári zo všetkých odborov."
      }
    },
    "prevention": {
      "title": "Preventívna starostlivosť o zdravie",
      "calendarCard": {
        "title": "Prehľadný kalendár vášho zdravia",
        "subtitle": "Kedy máte ďalšiu prehliadku?",
        "perex": "S kalendárom uLekára.sk máte svoje zdravie pod kontrolou. Všetky prehliadky a očkovania nájdete na jednom mieste, ďalší termín vyšetrenia postrážime.",
        "button": "Pridajte prehliadky do kalendára"
      },
      "savingsCard": {
        "title": "Prevencia aj pre vašu peňaženku",
        "perex": "Čo prepláca vaša poisťovňa? Zistite, na aké príspevky máte nárok, a zostaňte o krok vpred pred chorobou."
      },
      "googleCard": {
        "title": "Už žiadne googlenie, všetko na jednom mieste",
        "perex": "Zastavte sa po dávku overených informácií, ktoré vám vlejú zdravie do žíl. Napísané lekármi, zrozumiteľne a prakticky pre každý deň."
      }
    },
    "order": {
      "title": "Sprievodca zdravím",
      "subtitle": "Zatiaľ iba pre firmy",
      "dateCard": {
        "title": "Rýchlo a s úsmevom",
        "subtitle": "Pomôžeme vám zorientovať sa v zdravotnej starostlivosti.",
        "perex": "Hľadanie vhodného lekára, zháňanie kontaktov a zisťovanie možností nechajte na nás. Naše zdravotné sestry vám poradia, kam sa obrátiť, čo potrebujete k vyšetreniu a v prípade možností sa pokúsia overiť dostupnosť termínu.",
        "button": "Vyskúšajte sprievodcu zdravím"
      },
      "mapCard": {
        "title": "Skúsení a milí lekári po celom Slovensku",
        "perex": "Nájsť pediatra v Bratislave? Objednať rodičov k ortopédovi v Košiciach? Pomôžeme s termínom prehliadky bez ohľadu na to, kde žijete."
      },
      "nurseCard": {
        "title": "Milá zdravotná sestra na telefóne",
        "perex": "Stačí vyplniť jednoduchý formulár. Naša sestra sa spojí s vaším zamestnancom, vysvetlí mu ďalší postup a pomôže nájsť riešenie. Dostupnosť vyšetrení sa môže líšiť podľa odbornosti a regiónu. Robíme maximum pre to, aby sme klientom pomohli urobiť ďalší krok k starostlivosti."
      }
    },
    "whatWeHelpWith": {
      "title": "S čím vám môžeme pomôcť?",
      "list": [
        "Mám na koži zvláštnu škvrnu, odfotil som si ju a chcem, aby mi niekto povedal, čo to je.",
        "Nemám čas čakať kvôli jednej maličkosti. A ešte sú na mňa často nepríjemní.",
        "Dcéra má horúčky a červené pupienky. Sú to kiahne alebo šiesta choroba?",
        "Môj lekár mi to poriadne nevysvetlil a dal mi správu, ktorej nerozumiem.",
        "Bola som u troch lekárov a každý mi povedal niečo iné. Potrebujem mať jasno.",
        "V novom meste potrebujem nájsť všeobecného lekára a zubára. Nechcem ich hľadať sám."
      ]
    },
    "howItWorks": {
      "title": "Ako to funguje?",
      "items": [
        "Na vašu zdravotnú otázku odpovie všeobecný lekár alebo pediater. Môže sa to týkať vás alebo vášho blízkeho.",
        "Potrebujem názor špecialistu? Odpovie vám odborník v akejkoľvek oblasti.",
        "Mal by vás vidieť odborník? Pomáhame vám urobiť ďalší krok k starostlivosti.",
        "Služba uLekára.sk zostáva naďalej vaším sprievodcom pri preventívnej starostlivosti o zdravie. Máte ju kedykoľvek poruke."
      ]
    },
    "video": {
      "title": "Prevencia je našou srdcovou záležitosťou",
      "subtitle": "Aby u lekára bolo dobre.",
      "perex": "Pomáhame ľuďom riadiť ich zdravie a dožiť sa v zdraví čo najvyššieho veku. Prepájame odbornosť lekárov s ľudským prístupom a technológiami, aby ste svoje zdravie mali vo svojich rukách. Doslova.",
      "button": "Pridajte sa k nám"
    },
    "stories": {
      "title": "Príbehy z našej poradne",
      "items": [
        {
          "name": "Tereza",
          "position": "učiteľka",
          "story": "”Máte úžasný systém, super notifikácie. Skutočne prepracované procesy. <br /> A ešte k tomu príjemní ľudia na telefóne! Ďakujeme vám za túto krásnu klientsku skúsenosť. ♡ <br />Držím vám palce, aby sa vám darilo!”<br />"
        },
        {
          "name": "Martin",
          "position": "podnikateľ",
          "story": "“Dobrý deň, veľmi pekne vám ďakujem za sprostredkovanie vyšetrenia. Táto služba je niečo úžasné. Dôležité však je, že služba funguje perfektne, rýchlo a spoľahlivo. Využil som ju už niekoľkokrát a rovnako aj moji rodinní príslušníci. Prajem všetkým, ktorí sa na službu pozerajú, aby sa im práca aj naďalej darila aspoň tak dobre ako doteraz. Ešte raz vám ďakujem.”"
        },
        {
          "name": "Alena",
          "position": "asistentka",
          "story": "”Dobrý deň, veľmi pekne ďakujem lekárkam za ich rýchle, ale aj ústretové a krásne vysvetľujúce profesionálne odpovede, ktoré jasne odrážajú ich vysokú kvalifikáciu a skúsenosti. Prosím, odovzdajte im moje poďakovanie s odpoveďou, ktorá, dúfam, poteší, a prianím pekného víkendu. Ďakujem veľmi pekne!”"
        },
        {
          "name": "Roman",
          "position": "remeselník",
          "story": "Veľmi pekne ďakujem za odpovede oboch paní doktoriek a v neposlednom rade veľká vďaka veľmi ochotnej a profesionálnej pani sestričke. Jej prístup bol veľmi empatický, príjemne ma prekvapilo, aká účinná môže byť „obyčajná“ telefonická konzultácia, ak je na druhej strane niekto, kto má záujem problém riešiť. Ďakujem."
        }
      ]
    },
    "partners": "Partneri",
    "footer": {
      "list": [
        "Ľudskosť",
        "Nadšenie",
        "Odbornosť",
        "Inovácie"
      ],
      "text": "Celý tím uLekára.sk verí, že zdravie je vaše. Spájame ľudský prístup s lekárskymi odbornými znalosťami, pomáhame ľuďom riadiť ich zdravie a firmám motivovať ich zamestnancov. Tím 350+ lekárov všetkých špecializácií pomáha mesačne približne 15-tisíc ľuďom. Naši online lekári sú k dispozícii 24 hodín 7 dní v týždni. uLekára.sk nájdete na webe aj v mobilnej aplikácii."
    },
    "issn": {
      "text": "© 2007-{currentYear} uLékaře.cz, s.r.o. | ISSN 1802-5544",
      "links": [
        {
          "text": "Podmienky používania"
        },
        {
          "text": "Zásady spracovania osobných údajov"
        },
        {
          "text": "Vyhlásenie o súboroch cookie"
        }
      ]
    }
  },
  "secondFactor": {
    "subtitleEmail": "Dvojfaktorové overenie cez e-mail",
    "label": "Zadajte kód, ktorý vám prišiel na overenie prihlásenia.",
    "rememberDevice": "Na tomto zariadení nevyžadovať",
    "sendAgain": "Odoslať kód znovu",
    "verify": "Overiť kód",
    "subtitleSms": "Dvojfaktorové overenie cez SMS",
    "error": {
      "input": "Zadajte kód.",
      "invalidCode": "Neplatný kód"
    }
  },
  "forms": {
    "Question": {
      "patient": {
        "title": "Základné informácie",
        "whoisAsking": {
          "self": {
            "label": "Na seba"
          },
          "other": {
            "label": "Na niekoho iného"
          },
          "label": "Na koho sa pýtate?"
        },
        "firstName": {
          "self": {
            "label": "Meno",
            "help": "Zadajte svoje skutočné meno na komunikáciu so zdravotníckym zariadením."
          },
          "other": {
            "label": "Meno inej osoby",
            "help": "Zadajte svoje skutočné meno na komunikáciu so zdravotníckym zariadením."
          }
        },
        "lastName": {
          "self": {
            "label": "Priezvisko",
            "help": "Zadajte svoje skutočné meno na komunikáciu so zdravotníckym zariadením."
          },
          "other": {
            "label": "Priezvisko inej osoby",
            "help": "Zadajte svoje skutočné meno na komunikáciu so zdravotníckym zariadením."
          }
        },
        "birthNumber": {
          "self": {
            "label": "Rodné číslo",
            "help": "Vaše rodné číslo je potrebné na komunikáciu so zdravotníckymi zariadeniami."
          },
          "other": {
            "label": "Rodné číslo",
            "help": "Rodné číslo je potrebné na komunikáciu so zdravotníckymi zariadeniami."
          }
        },
        "birthDate": {
          "self": {
            "label": "Dátum narodenia"
          },
          "other": {
            "label": "Dátum narodenia tejto osoby"
          }
        },
        "gender": {
          "self": {
            "label": "Pohlavie",
            "help": "Vyberte pohlavie"
          },
          "other": {
            "label": "Pohlavie",
            "help": "Vyberte pohlavie",
            "placeholder": "Vyberte pohlavie"
          }
        },
        "phone": {
          "self": {
            "label": "Telefónne číslo",
            "help": "V prípade potreby vám zavolá zdravotná sestra"
          },
          "other": {
            "label": "Telefónne číslo tejto osoby",
            "help": "V prípade potreby vám zavolá zdravotná sestra"
          }
        },
        "address": {
          "self": {
            "label": "Adresa",
            "help": "Adresa nám pomôže nájsť vhodného lekára."
          },
          "other": {
            "label": "Adresa",
            "help": "Adresa nám pomôže nájsť vhodného lekára."
          }
        }
      },
      "questionBasic": {
        "title": "Popíšte zdravotný problém",
        "questionWhat": {
          "label": "Popíšte zdravotný problém a všetky jeho prejavy. Čím podrobnejší popis, tým presnejšia odpoveď lekára."
        },
        "questionHowWhen": {
          "label": "Čím problém začal a kedy (dátum)? Opakuje sa? Ako sa vyvíja v čase?"
        },
        "questionPastExamination": {
          "label": "Prebehlo lekárske vyšetrenie as akým záverom? Uskutočnila sa liečba, vrátane domácej? Prosím popíšte, aká a či pomohla."
        },
        "healthIssueQuestion": {
          "label": "Na čo sa chcete opýtať? Položte lekárovi otázku, ktorá sa týka popísaného problému."
        },
        "questionSolutionCountry": {
          "label": "V ktorej krajine chcete pomôcť?"
        },
        "attachments": {
          "label": "Priložte fotografie, lekárske správy a prípadné výsledky vyšetrenia.",
          "help": "Jeden súbor môže mať veľkosť max. 20 MB, všetky súbory celkom max. 100 MB. Prosíme o súbory vo formátoch .jpg, .png, pdf, MP3, .avi alebo mp4."
        }
      },
      "questionAdditional": {
        "title": "Doplňujúce informácie pre lekára",
        "questionAnotherSickness": {
          "self": {
            "label": "Liečite sa na nejaké chronické/iné ochorenie?"
          },
          "other": {
            "label": "Lieči sa na nejaké chronické/iné ochorenia?"
          }
        },
        "questionAnotherSicknessDetails": {
          "self": {
            "label": "Prosím napíšte, s ktorým ochorením sa liečite."
          },
          "other": {
            "label": "Prosím napíšte, s ktorým ochorením sa lieči."
          }
        },
        "questionMedications": {
          "self": {
            "label": "Užívate pravidelne nejaké lieky alebo liečivé prípravky? Napr. antikoncepciu, inzulín, antidepresíva...?"
          },
          "other": {
            "label": "Užíva pravidelne nejaké lieky alebo liečivé prípravky? Napr. antikoncepciu, inzulín, antidepresíva...?"
          }
        },
        "questionMedicationsDetails": {
          "self": {
            "label": "Prosím vypíšte názvy a dávkovanie užívaných liekov alebo liečivých prípravkov."
          },
          "other": {
            "label": "Prosím vypíšte názvy a dávkovanie liekov alebo liekov, ktoré užíva."
          }
        },
        "questionAllergies": {
          "self": {
            "label": "Máte nejaké alergie, najmä na lieky alebo iné liečivé prípravky?"
          },
          "other": {
            "label": "Má nejakú alergiu, najmä na lieky alebo lieky?"
          }
        },
        "questionAllergiesDetails": {
          "self": {
            "label": "Prosím napíšte, na čo ste alergický a ako sa to prejavuje."
          },
          "other": {
            "label": "Prosím napíšte, na čo má alergiu a ako sa prejavuje."
          }
        },
        "questionLifestyle": {
          "self": {
            "label": "Čo môže ovplyvňovať váš zdravotný stav? Napr. fajčenie, alkohol, nadváha, nezdravý životný štýl, namáhavé povolanie, stres..."
          },
          "other": {
            "label": "Čo môže ovplyvňovať zdravotný stav tohto človeka? Napr. fajčenie, alkohol, nadváha, nezdravý životný štýl, namáhavé povolanie, stres..."
          }
        },
        "questionContact": {
          "label": "Ak lekár odporučí osobnú návštevu, chcete, aby vás kontaktovala zdravotná sestra a ponúkla vám pomoc s objednávkou?",
          "yes": "Áno, želám si, aby ma kontaktovala zdravotná sestra.",
          "no": "Nie, nechcem, aby mi zdravotná sestra zavolala."
        }
      }
    },
    "Order": {
      "patient": {
        "title": "Základné informácie",
        "whoisAsking": {
          "label": "Koho sa požiadavka týka?",
          "self": {
            "label": "Pre mňa"
          },
          "other": {
            "label": "Pre inú osobu"
          }
        },
        "firstName": {
          "self": {
            "label": "Meno",
            "help": "Zadajte svoje skutočné meno na komunikáciu so zdravotníckym zariadením."
          },
          "other": {
            "label": "Meno inej osoby",
            "help": "Zadajte svoje skutočné meno na komunikáciu so zdravotníckym zariadením."
          }
        },
        "lastName": {
          "self": {
            "label": "Priezvisko",
            "help": "Zadajte svoje skutočné meno na komunikáciu so zdravotníckym zariadením."
          },
          "other": {
            "label": "Priezvisko inej osoby",
            "help": "Zadajte svoje skutočné meno na komunikáciu so zdravotníckym zariadením."
          }
        },
        "birthNumber": {
          "self": {
            "label": "Rodné číslo",
            "help": "Vaše rodné číslo je potrebné na komunikáciu so zdravotníckymi zariadeniami."
          },
          "other": {
            "label": "Rodné číslo",
            "help": "Vaše rodné číslo je potrebné na komunikáciu so zdravotníckymi zariadeniami."
          }
        },
        "birthDate": {
          "self": {
            "label": "Dátum narodenia"
          },
          "other": {
            "label": "Dátum narodenia inej osoby"
          }
        },
        "gender": {
          "self": {
            "label": "Pohlavie",
            "help": "Vyberte pohlavie"
          },
          "other": {
            "label": "Pohlavie",
            "help": "Vyberte pohlavie"
          }
        },
        "phone": {
          "self": {
            "label": "Telefónne číslo",
            "help": "V prípade potreby vám zavolá zdravotná sestra."
          },
          "other": {
            "label": "Telefónne číslo",
            "help": "V prípade potreby vám zavolá zdravotná sestra"
          }
        },
        "address": {
          "self": {
            "label": "Adresa",
            "help": "Adresa nám pomôže nájsť vhodného lekára."
          },
          "other": {
            "label": "Adresa inej osoby",
            "help": "Adresa nám pomôže nájsť vhodného lekára."
          }
        },
        "orderHealthInsurance": {
          "self": {
            "label": "Zdravotná poisťovňa",
            "help": "Hľadáme lekára, ktorý spolupracuje s touto poisťovňou."
          },
          "other": {
            "label": "Poisťovňa",
            "help": "Hľadáme lekára, ktorý spolupracuje s touto poisťovňou."
          }
        }
      },
      "orderBasic": {
        "title": "Sprievodca zdravím",
        "orderWhat": {
          "label": "S čím potrebujete pomôcť?",
          "placeholder": "Napríklad poradiť, kam sa obrátiť…"
        },
        "orderSpecialist": {
          "label": "Aký typ lekára alebo špecialistu hľadáte?"
        },
        "attachments": {
          "label": "Priložte formulár žiadosti alebo lekársku správu, ak ju máte.",
          "help": "Jeden súbor môže mať veľkosť max. 20 MB, všetky súbory spolu max. 100 MB. Poskytnite súbory vo formátoch .jpg, .png, pdf, MP3, .avi alebo mp4."
        },
        "orderLocality": {
          "label": "V ktorej  lokalitě chcete problém riešiť?"
        },
        "orderTimeAvailability": {
          "label": "Ak bude trieba, na aký termín si prajete objednať?"
        },
        "orderContact": {
          "label": "Ako chcete pomôcť s požiadavkou?",
          "yes": "Uprednostňujem, aby ste objednávku vybavili za mňa.",
          "no": "Uprednostňujem zaslanie kontaktov."
        }
      }
    },
    "goPrev": "Predchádzajúce",
    "goNext": "Ďalej",
    "submit": "Odoslať"
  },
  "getApp": "Stiahnuť aplikáciu",
  "healthbox": {
    "landing": {
      "whySection": {
        "items": [
          {},
          {},
          {
            "perex": "Aktuálne články s overenými informáciami, ktoré píšu priamo lekári a špecialisti – prakticky a zrozumiteľne, aby každý porozumel svojmu telu a zdraviu."
          }
        ]
      }
    }
  },
  "orderForm": {
    "thankYou": {
      "title": "Požiadavka bola zadaná.",
      "perex": "Ďakujeme za vašu požiadavku, hneď ako bude vybavená, dostanete upozornenie."
    }
  },
  "common": {
    "ok": "Pokračovať"
  },
  "medicalProcedures": {
    "prevention": [
      {
        "id": "1f4a68b9-205e-48ed-8382-e792dfa29341",
        "icon": "doctor",
        "title": "Praktický lekár",
        "perex": "Preventívna prehliadka u praktického lekára je vo svojej podstate najdôležitejšou súčasťou zdravotnej starostlivosti. Náplň Preventívne prehliadky sa odvíjajú od vašeho veku, ochorenia a rizikových faktorov.",
        "expectation": "Lekár orientačne vyšetrí zrak, sluch a kožu, skontroluje očkovanie, zmeria krvný tlak, vyšetrí srdce, pľúca, štítnu žľazu, brucho a skontroluje stav ciev na dolných končatinách. Analyzuje vzorku ranného moču testačným papierikom. Hlavne u mužov lekár urobí vyšetrenie per rectum (konečníkom). \nV 18, 30, 40 rokoch veku a potom opakovane vždy po 2 rokoch sa tiež odeberá krv na vyšetrenie tukov, cukrov, funkcie obličiek, ochorenie srdca a obehovej sústavy. \nOd 40 rokov veku lekár kontroluje EKG každé 4 roky. \nOd 50 rokov veku sa vyšetruje stolica na okultné (skryté) krvácanie, tzv. TOK. \nLekár predpisuje žiadanky na screeningové a ďalšie potrebné vyšetrenia.",
        "preparation": "Pred odberom krvi je treba byť nalačno od polnoci predchádzajúceho dňa a ráno sa napiť len čistej vody. Odber ranného moču je možné urobiť doma stredným prúdom do sterilnej nádoby. Je vhodné sa vopred objednať, aby lekár mohol vystaviť žiadanky na odber krvi a ďalšie vyšetrenie. Na prehliadku si vyhraďte približne 30 minút.",
        "isItPaid": "Preventívna kontrola u praktického lekára je hradená z verejného zdravotného poistenia. Na vyšetrenie sa chodí 1× za 2 roky."
      },
      {
        "id": "891f7c68-bae0-4040-9907-333177a0ac1a",
        "icon": "tooth",
        "title": "Zubný lekár",
        "perex": "Preventívne zubné prehliadky sú dôležité pre udržanie zdravého chrupu. Predíďte komplikáciám, ktoré sú zo začiatku často bezpríznakové.",
        "expectation": "Zubný lekár skontroluje stav chrupu, slizníc, ďasien a parodontu. Zhodnotí stav ústnej hygieny, v prípade potreby odstraní zubný kameň alebo doporučí profesionálnu deňtálnu hygienu. K odhaleniu kazov a ďalších patológií sa robí RTG (skusový) snímok chrupu, prípadne 1× za 2 roky OPG (panoramatický) snímok chrupu.",
        "preparation": "Pred návštěvou lekára si vyčistite zuby, a to vrátane medzizubných priestorov. Na prehliadku si vyhraďte 15–⁠30 minút.",
        "isItPaid": "Preventívna kontrola u zubného lekára je hradená z verejného zdravotného poistenia. Máte nárok na 1 vyšetrenia ročne."
      },
      {
        "id": "0f1bf426-6f77-40d4-933b-f5a1ee275be8",
        "icon": "female-reproductive-system",
        "title": "Gynekológia",
        "perex": "Vyšetrenie, počas ktorého lekár skontroluje pohlavné orgány ženy, posledný dátum menštruácie a urobí cytologické vyšetrenie.",
        "expectation": "Na prehliadke sa robí kontrola osobnej rodinnej anamnézy, lekár obvykle požaduje dátum poslednej menštruácie. Pohlavné orgány sa vyšetrujú pohľadom, pohmatom, robí sa tiež ultrazvuk. Súčasťou preventívnej prehliadky je i cytologické vyšetrenie, teda ster z krčka maternice a kontrola či prípadné poučenie ohľadom samovyšetrenia prsníkov.",
        "preparation": "Ideálne pred návštevou lekára urobiť hygienu intimných partií.\nNa prehliadku si vyhraďte 15–30 minút.",
        "isItPaid": "Preventívna kontrola u gynekológa je hradená z verejného zdravotného poistenia, máte nárok na 1 prehliadku za rok."
      },
      {
        "id": "362e63be-2a2b-4e69-ba01-a2eb5397eb79",
        "icon": "breasts",
        "title": "Vyšetrenie prsníkov",
        "perex": "Vyšetrenie prsníkov a podpazušia, ktoré slúži k včasnému odhaleniu nádorového ochorenia. ",
        "expectation": "Vyšetrenie mamografom je bezpečnou a efektívnou metódou. Umožňuje rentgenové snímkovanie vo vysokej kvalite, s minimálnou dávkou žiarenia. Vyšetrenie prebieha v stoji, prsia sú stlačené prístrojom, aby bolo vidieť čo najviac tkáne. Všetko vám vysvetlí laborantka, ktorá snímky urobí. Lekár skontroluje urobené snímky a vyhodnotí ich. Doplnkovou metódou pre mladšie ženy alebo pri potrebe dovyšetrenia je ultrazvukové vyšetrenie prsníkov a podpazušia.\nVyšetrenie ultrazvukovou sondou je bezpečná a bezbolestná metóda, výsledok je vidieť ihneď. Vyšetrenie sa robí poležiačky, je úplne bezbolestné a bezpečné. Lekár prechádza ultrazvukovou sondou po prsiach a všetko eviduje na obrazovke. ",
        "preparation": "Príprava nie je treba, doporučuje sa nepoužívať telové krémy a tuhé antiperspiranty.Vyšetrenie trvá zhruba 20 minút.",
        "isItPaid": "Ženám do 40 rokov veku sa doporučuje ultrazvukové vyšetrenie a máte na neho nárok 1× za 2 roky u gynekológa.\nNad 40 rokov veku je mamografické vyšetrenie hradeňé poisťovňou a máte na neho nárok 1× za 2 roky. "
      },
      {
        "id": "f129ba70-51b5-4820-bc79-6a89072d1ae4",
        "icon": "rectum",
        "title": "Kolonoskopia",
        "perex": "Je vyšetrenie hrubého čreva a konečníku pomocou endoskopického prístroja, ktorý tiež môže odoberať vzorky zo slizníc. ",
        "expectation": "Kolonoskopia je preventívna a zároveň liečebná metóda, slúžiaca k odhaleniu včasných zmien na sliznici hrubého čreva, odberu kúsku tkáne pre dôkladnejšie vyšetrenie a tiež odstránenie niektorých útvarov. Vyšetrenie sa robí endoskopom, ktorý sa zavádza konečníkom do hrubého čreva. Vyšetrenie prebieha v súkromí so zachovaním dôstojnosti pacienta. Vyšetrenie môže byť pre niekoho nepríjemné či ľahko bolestivé, preto sa obvykle pred výkonom podávajú lieky na ukľudnenie, je možné ho podstúpiť i v celkovej anestézii. Po vyšetrení pacient chvíľu zostáva v zdravotníckom zariadeňí.",
        "preparation": "Je doporučená diéta týždeň pred vyšetrením, 3 dni pred výkonom len kašovitá strava, deň pred kolonoskopiou len tekutiny a preháňací roztok, ktorý pomôže črevo vyčistiť od zbytkov stravy a stolice. Na vyšetrenie je treba žiadanku. Je treba vyšetriť krvný obraz a zrážanlivosť krvi, u pacientov užívajúcich lieky na riedeňie krvi je treba túto skutočnosť prebrať s ošetrujúcim lekárom a liečbu upraviť.Vyšetrenie trvá približne 20–30 minút.",
        "isItPaid": "Od 50 rokov veku je hradená z verejného zdravotného poistenia, máte na neho nárok každých 10 rokov, pokiaľ je prvá kolonoskopia bez nálezu. Žiadanku vydáva praktický lekár, u žien taktiež gynekológ."
      },
      {
        "id": "1b8fefd5-9ca2-4d5e-afd4-9dbe46c456d4",
        "icon": "eye",
        "title": "Očné vyšetrenie",
        "perex": "Pri preventívnom očnom vyšetrení sa očný lekár zameriava hlavne na odhalenie závažných vád, ktoré nebolia a človek o nich nevie.",
        "expectation": "Kontroluje sa celé oko i štruktúry okolo neho ako sú spojivky a viečka. Lekár skontroluje zrakovú ostrosť, zistí,či nepotrebujete okuliare, zmeria vnútroočný tlak, vyšetrí očné pozadie. Zvláštnu pozornosť je treba venovať pacientom s vysokým tlakom a cukrovkou a tým, ktorí majú v rodine očné choroby ako napr. šedý a zelený zákal. Pomocou ďalších prístrojov môže podrobnejšie zistiť refrakčné vady, ktoré s očami súvisia, môže odhaliť aj iné ochorenie. Vyšetrenie je bezbolestné, vcelku nenáročné.",
        "preparation": "Príprava na vyšetrenie nie je potrebná. Vyšetrenie trvá približne 30 minút.",
        "isItPaid": "Preventívne vyšetrenie očí je hradené z verejného zdravotného poistenia v akomkoľvek veku."
      },
      {
        "id": "467fff1e-a3fe-4403-ba24-670816ec556c",
        "icon": "testicles",
        "title": "Samovyšetrenie semenníkov",
        "perex": "Rakovina semenníkov sa najčastejšie vyskytuje u mužov vo veku 15–35 rokov a nádory veľmi rýchlo vznikají a rastú. Liečiť sa dá, ale je treba včasné odhalenie, preto je treba hlavne v tomto veku samovyšetrenie nezanedbávať.",
        "how": "Semenníky sa najlepšie vyšetrujú po teplej sprche, keď je koža miešku uvoľnená. Semenníky prehliadnite a tiež prehmatajte. Pohľadom i pohmatom overte, že sa nezmenila veľkosť, tvar, a že nie sú nejaké zmeny na koži, poprípade nepribudla hrčka. Prehmatajte každý semenník zvlášť obomi rukami. Súčasťou semenníkov sú nadsemenníky, môžu pri samovyšetrení miasť. Tie by mali byť na oboch stranách súmerné. ",
        "when": "Vyšetrenie je vhodné robiť aspoň raz mesačne, obzvlášť vo veku 15–35 rokov. Môžete si na samovyšetrenie určiť vždy jedeň deň v mesiaci.",
        "findConcerningQuestion": "V prípade zmien veľkosti, farby, pri bolesti, nahmataní hrčky či iných zmenách navštívte urológa, poprípade praktického lekára."
      },
      {
        "id": "df6a924b-8b1f-44be-a564-c055c11b8a27",
        "icon": "breasts-self-care",
        "title": "Samovyšetrenie prsníkov",
        "perex": "Samovyšetrenie prsníkov je jednou z najjednoduchších metód, ako včas zachytiť možný výskyt karcinómu. Vyšetrenie je jednoduché a zaberie vám len pár minút.",
        "how": "Pri vyšetrení sa postavte pred zrkadlo, u žien s objemnými prsiami je jednoduchšie vyšetriť sa poležiačky. Skontrolujte odlišnosti na pohľad spredu, zboku i v predklone. Samotné prehmatanie robte s rukou zdvihnutou na tej strane, kde sa vyšetrujete, opačnou rukou prehmatávajte prsník – ľavá ruka kontroluje pravý prsník a naopak. Skontrolujte, či sa nezmenila veľkosť prsníkov, ich tvar, prehliadnite bradavky, ľahko stlačte. Pozrite sa, či nemáte výtok. Prsia prehmatajte zhora dole, potom od hrudnej kosti do strán, krúživým pohybom a klínovito od bradavky do všetkých strán. Nezabudnite na oblasť pod kľúčnou kosťou a na podpazušie. ",
        "when": "Vyšetrenie robte po skončení menštruačného cyklu, piaty až desiaty deň cyklu. Pokiaľ menštruáciu nemáte, zvoľte si pre samovyšetrenie jedeň deň v mesiaci.",
        "findConcerningQuestion": "Pri sebemenších pochybnostiach navštívte svojho gynekológa, poprípade praktického lekára."
      },
      {
        "id": "c109b192-3a5b-4bc3-9125-ddddcea8a822",
        "icon": "prostate",
        "title": "Vyšetrenie prostaty",
        "perex": "Vyšetrenie lekárom urológom, ktorý skontroluje mužské pohlavné orgány. Urobí tiež kontrolu prostaty, krvi (PSA), moču, poprípade ejakulátu či hladiny testosterónu. ",
        "expectation": "Vyšetrenie za účelom kontroly mužských pohlavných orgánov. Robí sa pohľadom a poklepom na močový mechúr a v oblasti chrbta. Prostatu lekár vyšetruje cez konečník. Kontroluje sa tiež krv (na nádorový ukazovateľ PSA) a moč, poprípade ejakulát či hladina testosterónu. Súčasťou urologickej prehliadky môže byť i ultrazvukové vyšetrenie. Vyšetrenie môže byť trochu nepríjemné, ale nie je bolestivé.",
        "preparation": "Ideálne pred návštevou lekára urobiť hygienu intimných partií.\nNa prehliadku si vyhraďte zhruba 20 minút.",
        "isItPaid": "Preventívne vyšetrenie prostaty je hradené z verejného zdravotného poistenia, a to 1x za 3 roky od 50 rokov veku. Vhodné je dochádzať 1× ročne od 50 rokov veku raz za rok, ale doporučuje sa už o trochu skôr, od 40 rokov veku."
      },
      {
        "id": "ec177bfa-7bbf-40f2-a68c-22ab20737315",
        "icon": "dermatology",
        "title": "Vyšetrenie znamienok",
        "perex": "Vyšetrenie kožným lekárom, ktorý kontroluje znamienka pohľadom, poprípade pomocou dermatoskopu. Pri podozrení na pozitívny nález lekár odosiela tkanivo na histologické vyšetrenie (pod mikroskopom).",
        "expectation": "Kožný lekár skontroluje kožu celého tela, hlavne znamienka. V prípade podozrivého útvaru vyšetrí znamienko špeciálnym optickým prístrojom, dermatoskopom. Tento prístroj sníma znamienka v oveľa väčšom rozmere, funguje ako lupa. Je možné ich mať prepojené s počítačom a je tak možné porovnávať snímky z minulosti. Pokiaľ je znamienko podozrivé z možného nádorového bujenia, lekár môže znamienko vyrezať a poslať na histologické vyšetrenie pod mikroskopom. Výsledky sa riešia obvykle na nasledujúcej návšteve, pokiaľ je treba, tak telefonicky. Niekedy sa odstraňujú i znamienka, ktoré vadia z estetického pohľadu, alebo sú v mieste veľkého dráždenia, napríklad pod opaskom, ramienkom podprsenky a podobne.",
        "preparation": "Príprava na vyšetrenie nie je treba. Vyšetrenie trvá približne 20 minút, pri vyrezávaní znamienok je návšteva dlhšia.",
        "isItPaid": "Preventívne vyšetrenie znamienok nie je hradené z verejného zdravotného poistenia, ale poisťovne môžu prispievať. Cena vyšetrenia je rôzna, informujte sa priamo v ordinácii dermatológa. Preventívna prehliadka sa doporučuje raz za rok."
      },
      {
        "id": "f268c41e-244e-42f6-a079-5d44d189b8bf",
        "icon": "brush",
        "title": "Dentálna hygiena",
        "perex": "Dentálna hygiena je prevenciou zubného kazu, parodontitídy (zápalu ďasien) a infekcie v ústach. Pri vyšetrení sa odstraňuje predovšetkým zubný kameň, povlak a pigment na zuboch.",
        "expectation": "Dentálny hygienista skontroluje stav chrupu, a hlavne parodontu (závesného aparátu zubov). Odstraní povlak a pigment zo zubov a podďasnových priestorov do 3 mm. Odstraní zubný kameň, zuby profesionálne vyčistí, vyleští a prípadne urobí fluoridíciu. Súčasťou návštevy hygienisty je kontrola, edukácia a nácvik správneho čstenia a použitia dentálnych pomôcok. Práve vďaka tomu sa znižuje riziko vzniku chorôb dutiny ústnej, zubov a ďasien, vrátane parodontitídy.",
        "preparation": "Pred návštevou si vyčistite zuby, a to vrátane medzizubných priestorov. Doporučujeme si so sebou vziať i používané dentálne pomôcky. \nNa prehliadku si vyhraďte 30–60 minút.",
        "isItPaid": "Dentálna hygiena nie je hradená z verejného zdravotného poistenia, ale poisťovne môžu prispievať. Informujte sa priamo v ordinácii. Doporučená je návšteva 2× ročne."
      }
    ],
    "vaccination": [
      {
        "id": "77812777-eb63-42d8-a61e-1006038a4bdc",
        "icon": "vaccine",
        "name": "Tetanus",
        "perex": "Tetanus alebo stuhnutosť šije je závažné ochorenie, ktoré je častou príčinou úmrtí predovšetkým v rozvojových krajinách. Toto ochorenie spôsobuje baktéria Clostridium tetani, ktorá sa bežne vyskytuje v čreve človeka a zvierat, predovšetkým u hospodárskych zvierat.\nV dnešnej dobe už takmer vymizol vďaka preočkovanosti populácie.",
        "prevention": "Účinnou prevenciou proti ochoreniu tetanom je očkovanie. Prvá dávka sa aplikuje deťom v rámci kombinovanej vakcíny. V dospelosti sa preočkováva do 59 rokov každých 10-15 rokov, od 60 rokov sa doporučuje každých 10 rokov.",
        "vaccineChoice": "Doporučujeme vakcínu Vacteta, ktorá je hradená z verejného zdravotného poistenia. "
      },
      {
        "id": "39ee715f-b4d8-4f76-9cc8-14ff327c0d07",
        "icon": "vaccine",
        "name": "Čierny kašeľ",
        "perex": "Čierny kašeľ je vysoko nákazlivé ochorenie spôsobené baktériou Bordetella pertussis. Môžeme sa tiež stretnúť s názvom „dávivý kašeľ“ či „pertuse“. Vyskytuje sa celosvetovo. Najrizikovejšie sú neočkované deti do 6 rokov veku, ale nákaza sa môže objaviť v ktoromkoľvek veku.",
        "prevention": "Najúčinnejšia prevencia proti ochoreniu čierneho kašľa je očkovanie. Vakcinácia spadá do povinného očkovacieho kalendára detí. Očkuje sa väčšinou v kombinovanej vakcíne, je doporučené preočkovanie aspoň raz za život.",
        "vaccineChoice": "Doporučujeme vakcínu Adacel, ktorá je u detí hradená z verejného zdravotného poistenia. Niektoré poisťovne môžu na očkovanie prispievať."
      },
      {
        "id": "1c9d2dc9-bdd6-488d-968e-4626579aeb45",
        "icon": "vaccine",
        "name": "Chrípka",
        "perex": "Chrípka je nákazlivé vírové ochorenie, ktoré postihuje každoročne veľkú časť populácie. Ohrození sú najviac starší ľudia, deti a chronicky chorí. Medzi symptómy patrí veľká únava, horúčka, kašeľ, bolesť tela, kĺbov a hlavy. Chrípka sa vyskytuje prevažne v zimnom období a lieči sa zhruba 1–2 týždne. ",
        "prevention": "Účinnou prevenciou ochorenia chrípky, je posilovať vlastný imunitný systém pomocou vyváženej zdravej stravy, dostatočného prísunu vitamínov, pitný režim, primeraný pohyb, kvalitný spánok, otužovanie a hygiena. Dopomáha taktiež každoročné očkovanie proti chrípke.",
        "vaccineChoice": "Doporučujeme vakcínu Vaxigrip Tetra, ktorú si pacient hradí sám. Niektoré poisťovne môžu prispievať na očkovanie."
      },
      {
        "id": "c9827908-b47c-4fe1-b4ad-fdaa154a74de",
        "icon": "vaccine",
        "name": "Kliešťová encefalitída",
        "perex": "Kliešťová encefalitída je vírové ochorenie, ktoré napadá nervový systém človeka. Česká republika je podľa vysokého výskytu ochorenia považovaná za rizikovú.",
        "prevention": "Ako prevenciu je vhodné sa pri pobyte v prírode chrániť vhodným odevom, používať repelenty a urobiť po pobyte kontrolu tela, či nie je kliešť prisatý.\nÚčinnou prevenciou proti ochoreniu kliešťovou encefalitídou je očkovanie. Ideálne sa očkuje v zimnom období, pred nástupom jari. Očkovanie je v 3 dávkach, potom nasleduje preočkovanie po 3 a po 5 rokoch.\nPrekonanie ochorenia zaisťuje imunitu, u mladších ľudí však nemusí byť imunita celoživotná, u starších sa predpokladá, že je. Hladina protilátok sa môže skontrolovať krvným odberom. ",
        "vaccineChoice": "Doporučujeme vakcínu FSME-IMMUN, ktorú si pacient hradí sám. Niektoré poisťovne môžu prispievať na očkovanie."
      },
      {
        "id": "d83a0b4c-ff51-40d6-8df4-8521e7c0055f",
        "icon": "vaccine",
        "name": "Pneumokok",
        "perex": "Pneumokokové ochorenie je veľmi závažné. Baktéria Streptococcus pneumoniae môže vyvolať zápal pľúc, infekciu oraganizmu, zápal mozgových blán alebo zápaly stredného ucha u detí.",
        "prevention": "Účinnou prevenciou proti ochoreniu pneumokokom je očkovanie. Do 59 rokov sa očkuje 1 dávka, 1 dávka sa tiež očkuje v rozmedzí 60–64 rokov, a po 65. roku sa očkujú 2 dávky.\nDoporučuje sa tiež posilovať vlastný imunitný systém, dbať na zdravý životný štýl a vyhýbať sa väčším kolektívom, predovšetkým v dobe respiračných ochorení. ",
        "vaccineChoice": "Doporučujeme vakcínu Prevenar 13, ktorú si pacient hradí sám. Niektoré poisťovne môžu prispievať na očkovanie."
      },
      {
        "id": "645eddeb-539d-4374-a300-234cd724bb94",
        "icon": "vaccine",
        "name": "Meningokok B",
        "perex": "Meningokokové ochorenie môže spôsobiť zápal mozgových blan, sepsiu organizmu, vysoké horúčkovité ochorenie, až smrť. V Českej republike je výskyt nákazy nízky, ale úmrtnosť vysoká. Riziko je predovšetkým u detí do 5 rokov veku a mladých ľudí do 25 rokov veku. Celkovo existuje 13 sérotypov meningokokového ochorenia.",
        "prevention": "Účinnou prevenciou proti ochoreniu meningokovou infekciou je očkovanie. Jedná sa o dvojdávkovú vakcínu s intervalom aspoň jeden mesiac, preočkovanie závisí na type vakcíny.\nDoporučuje sa tiež posilovať vlastný imunitný systém, dbať na zdravý životný štýl, dostatok spánku a odpočinku, eliminovať stres, fajčenie a podobne.",
        "vaccineChoice": "Doporučujeme vakcínu Bexsero, ktorú si pacient hradí sám. Niektoré poisťovne môžu prispievať na očkovanie."
      },
      {
        "id": "7a1affc9-805a-4935-9f52-6dc627bbf4c5",
        "icon": "vaccine",
        "name": "Meningokok A, C, Y, W-135",
        "perex": "Meningokokové ochorenie môže spôsobiť zápal mozgových blán, sepsiu organizmu, vysoké horúčkovité ochorenie, až smrť. V Českej republike je výskyt nákazy nízky, ale úmrtnosť vysoká. Riziko je predovšetkým u detí do 5 rokov a mladých ľudí do 25 rokov. Celkovo existuje 13 sérotypov meningokokového ochorenia.",
        "prevention": "Účinnou prevenciou proti ochoreniu meningokovou infekciou je očkovanie. Vakcína sa podáva v jednej dávke.\nDoporučuje sa tiež posilovať vlastný imunitný systém, dbať na zdravý životný štýl, dostatok spánku a odpočinku, eliminovať stres, fajčenie a podobne.",
        "vaccineChoice": "Doporučujeme vakcíny Menveo alebo Nimenrix, ktoré si pacient hradí sám. Niektoré poisťovne môžu prispievať na očkovanie."
      },
      {
        "id": "3b6bf48f-9cb6-4d9e-b2be-6b72b103d648",
        "icon": "vaccine",
        "name": "Vírusová žltačka A ",
        "perex": "Vírusová žltačka typu A je akútne infekčné ochorenie pečene spôsobené vírusom, známe tiež pod názvom „choroba špinavých rúk\". Vyskutuje sa po celom svete, predovšetkým v krajinách s nízkym hygienickým štandardom. V týchto krajinách sú rizikové hlavne deti, ktoré však bývajú často bez príznakov. U dospelej populácie je infekcia významnejšieho charakteru, ochorenie je však bez trvalých následkov. ",
        "prevention": "Prevenciou môže byť dostatočná osobná hygiena a kvalitné zdroje potravín a vody. Účinnou prevenciou proti ochoreniu žltačkou je očkovanie, podáva sa v dvoch dávkach s odstupom jednoho roku.\nDá sa očkovať i v kombinácii s vakcínou proti hepatitíde typu B, teda A+B dohromady.",
        "vaccineChoice": "Doporučujeme vakcíny Havrix 1440 alebo Vaqta Adult, ktoré si pacient hradí sám.\nPre očkovanie proti žltačke A + B doporučujeme vakcínu Twinrix Adult, ktorú si pacient hradí sám. Niektoré poisťovne môžu prispievať na očkovanie. "
      },
      {
        "id": "6a17b093-b6a3-4f38-9b49-2435267d0101",
        "icon": "vaccine",
        "name": "Vírusová žltačka B",
        "perex": "Vírusová žltačka typu B je závažné infekčné ochorenie pečene spôsobené vírusom. Ochorenie je chronické a môže zapríčiniť cirhózu pečene či rakovinu. Vírus hepatitídy typu B je oveľa nákazlivejší než vírus HIV. Výskyt ochorenia je po celom svete. Priebeh ochorenia je náročný a dlhší než u žltačky typu A.",
        "prevention": "Účinnou prevenciou proti ochoreniu žltačkou typu B je očkovanie. Prvá dávka sa aplikuje už v novorodeneckom veku, ďalšie 2 dávky sa očkujú s odstupom 1 a 6 mesiacov. Očkovať sa môžu i dospelí, ktorí v detsve očkovanie nepodstúpili. Dá sa očkovať tiež v kombinácii s vakcínou proti hepatitíde typu A, teda A + B dohromady.",
        "vaccineChoice": "Doporučujeme vakcínu Engerix B-20, ktorá je hradená z verejného zdravotního poistenia. \nPre očkovanie proti žltačke A + B doporučujeme vakcínu Twinrix Adult, ktorú si pacient hradí sám. Niektoré poisťovne môžu prispievať na očkovanie. "
      },
      {
        "id": "c0d340b9-8279-4cfa-a918-ca9f0b40db65",
        "icon": "vaccine",
        "name": "Osýpky, ružienka, príušnice",
        "perex": "Osýpky, príušnice a ružienka sú veľmi nakažlivé vírusové ochorenie.",
        "prevention": "Účinnou prevenciou je očkovanie. Aplikuje sa už v detskom veku v rámci povinného očkovania, robí sa kombinovanou formou vakcíny proti osýpkam, príušniciam a ružienke. \nV dospelosti je možné preočkovanie jednou dávkou, pokiaľ ste v profesionálnom riziku, cestujete alebo ste boli v kontakte s nakazeným.",
        "vaccineChoice": "Doporučujeme vakcíny MMR alebo Priorix, ktoré sú u detí hradené z verejného zdravotního poistenia. Samoplatcom môžu niektoré poisťovne na očkovanie prispievať"
      },
      {
        "id": "d206f02a-78a5-4e55-abe9-699de87259f2",
        "icon": "vaccine",
        "name": "Ovčie kiahne",
        "perex": "Ovčie kiahne sú infekčné ochorenie, ktoré je vysoko nákazlivé. Ochorenie sa objavuje najčastejšie v detskom veku a máva obvykle miernejší priebeh. U tehotných žien je však nákaza nebezpečná. \nOchorenie sa objavuje predovšetkým v zimnom období, v Českej republike je najčastejším infekčným ochorením.",
        "prevention": "Efektívna prevencia proti ovčím kiahňam je očkovanie. Očkovanie môže znížiť pravdepodobnosť vzniku pásového oparu počas života. \nPodávajú sa dve dávky s odstupom minimálne šesť týždňov.",
        "vaccineChoice": "Doporučujeme vakcínu Varilix, ktorú si pacient hradí sám. Niektoré poisťovne môžu prispievať na očkovanie."
      },
      {
        "id": "815351d8-b0ea-4c5c-832b-0c6ff3e36320",
        "icon": "vaccine",
        "name": "HPV infekcia",
        "perex": "HPV infekcia patrí k najrozšírenejším sexuályím ochoreniam. Je známych viac než sto typov HPV vírusov, asi 40 z nich postihuje pohlavné orgány. Veľa nakazených je takmer bez príznakov infekcie, a tak ľahko šíria vírus ďalej.",
        "prevention": "Efektívna prevencia proti HPV nákazám je dodržovanie zdravého životného štýlu, eliminácia stresu, fajčenia a nechráneného sexu. Ďalej je namieste vyhnúť sa striedaniu sexuálnych partnerov a dlhodobému užívaniu hormonálnej antikoncepcie. \nÚčinnou prevenciou je tiež očkovanie, ktoré je určené mužom i ženám. Ideálne je vakcínu aplikovať ešte pred zahájením sexuálneho života. Očkovanie prebieha v troch dávkach, a to i u dospelých, ktorí neboli očkovaní v detstve.",
        "vaccineChoice": "Doporučujeme vakcíny Gardasil alebo Gardasil 9, ktoré si pacient hradí sám. Niektoré poisťovne môžu prispievať na očkovanie."
      },
      {
        "id": "94a7f086-8aee-418a-a1b4-5f6de0396aa1",
        "icon": "vaccine",
        "name": "COVID-19",
        "perex": "COVID-19 je vysoko nákazlivé ochorenie, spôsobené novým typom koronavírusu alebo SARS-CoV-2. Výskyt tohto ochorenia je celosvetový. Ochorenie sa u nakazených prejavuje rôzne, u väčšiny prebieha vcelku mierne až so stredným priebehom, bez nutnosti hospitalizácie.",
        "prevention": "Efektívnou prevenciou pred ochorením COVID-19 je dostatočná hygiena rúk, vyhýbať sa väčšiemu kolektívu ľudí, chrániť sa respirátorom a posilovať vlastný imunitný systém. K prevencii môže pomôcť i očkovanie, ktoré v prípade nakazenia môže zmierniť priebeh ochorenia. Očkuje sa jednou až dvomi dávkami (v závislosti na type vakcíny), tretia dávka je podávaná s odstupom minimálne ďalších piatich mesiacov. Štvrtá dávka sa doporučuje hlavne osobám starším 60 rokov a rizikovým pacientom, a to s odstupom minimálne 4 mesiace od predchádzajúcej dávky.",
        "vaccineChoice": "Doporučujeme vakcíny Comirnaty, Spikevax, Janssen, Vaxzevria alebo Novavax. Vakcíny sú hradené z verejného zdravotního poistenia."
      }
    ]
  },
  "selfReactivated": {
    "title": "Vitajte späť!",
    "perex": "Váš účet je opäť aktívny a teší nás, že s nami zostávate na ceste k lepšiemu zdraviu. Ak budete čokoľvek potrebovať, náš zákaznícky servis vám rád pomôže na <a href=\"mailto:info@ulekara.sk\">info@ulekara.sk\n</a> alebo na čísle <a href=\"tel:00421950105650\">+421 950 105 650</a>.",
    "primaryButtonText": "Pokračovať s uLekára.sk"
  },
  "ePrescription": {
    "title1": "Ako funguje vystavenie",
    "perex": "Lekár v rámci vašej otázky zhodnotí váš zdravotný stav. Na základe toho môže odporučiť sprostredkovanie eReceptu. Nárok na eRecept nevzniká automaticky – lekár ho vystaví len vtedy, ak je to bezpečné a vhodné. Služba uLekára.sk eRecepty priamo nevystavuje, ale prepojíme vás s poskytovateľom zdravotných služieb, ktorý môže eRecept vystaviť. Pred samotným vystavením eReceptu vám zavolá zdravotná sestra, aby overila potrebné údaje. Vystavenie eReceptu nie je možné počas víkendov a štátnych sviatkov.",
    "disclaimer": {
      "b2b": "Lekár môže navrhnúť sprostredkovanie eReceptu. Na jeho získanie je nutný hovor so sestrou. Na vystavenie nevzniká nárok. {disclaimerLink}",
      "b2c": "Lekár môže navrhnúť sprostredkovanie eReceptu. Na jeho získanie je nutný hovor so sestrou. Na vystavenie nevzniká nárok.  {disclaimerLink}"
    },
    "disclaimerLink": "Viac",
    "list": [
      {
        "title": "Keď eRecept nedostanete",
        "subtitle": "Napríklad, ak:",
        "body": [
          "V otázke chýbajú informácie o vašom zdravotnom stave potrebné na sprostredkovanie eReceptu.",
          "Je nutné osobné vyšetrenie lekárom.",
          "Prípad je zložitejší alebo neštandardný.",
          "Predpísanie lieku si vyžaduje lekára inej špecializácie ako všeobecného lekára.",
          "Neprebehne potrebné overenie údajov.",
          "Žiadosť sa týka niekoho ďalšieho (eRecept nemožno žiadať pre partnera, rodiča, dieťa ani inú osobu)."
        ]
      },
      {
        "title": "Ako to prebieha",
        "body": [
          "Vo svojom účte položíte otázku (môžete napísať, že máte záujem o sprostredkovanie eReceptu).",
          "Lekár posúdi informácie, ktoré ste uviedli.",
          "Ak je to vhodné, odporučí sprostredkovanie eReceptu.",
          "Pred vystavením eReceptu vás bude kontaktovať zdravotná sestra, aby overila vaše údaje.",
          "Ak nie je možné vystaviť eRecept, dostanete odporúčanie, čo máte robiť ďalej – napríklad navštíviť praktického lekára alebo špecialistu."
        ]
      },
      {
        "title": "Čo to pre vás znamená",
        "body": [
          "V našej poradni existuje možnosť sprostredkovania eReceptu.",
          "Nemožno ho získať automaticky – lekár musí vždy posúdiť, či je vhodné ho vystaviť.",
          "eRecept nedostanete obratom – počítajte s krátkym časom na spracovanie.",
          "Chceme vám pomôcť, ako najlepšie vieme, ale nikdy nie na úkor správnej a bezpečnej starostlivosti."
        ]
      },
      {
        "title": "Ako je to s eReceptom v zahraničí",
        "subtitle": [
          "Vyzdvihnutie liekov so slovenským eReceptom v zahraničí nie je možné."
        ],
        "footer": "Lieky predpísané na eRecept nie sú hradené zo zdravotného poistenia a musíte si ich uhradiť v plnej výške."
      }
    ],
    "title2": "eReceptu v uLekára.sk",
    "questionDisclaimer": {
      "b2b": "Lekár môže navrhnúť sprostredkovanie eReceptu. Na jeho získanie je nutný hovor so sestrou. Na vystavenie nevzniká nárok. {disclaimerLink}",
      "b2c": "Lekár môže navrhnúť sprostredkovanie eReceptu. Na jeho získanie je nutný hovor so sestrou. Na vystavenie nevzniká nárok.  {disclaimerLink}"
    },
    "orderDisclaimer": {
      "b2b": "E-recept môžeme sprostredkovať na základe odporúčania lekára v našej poradni. V rámci služby sprievodca zdravím to nie je možné. {disclaimerLink}",
      "b2c": "E-recept môžeme sprostredkovať na základe odporúčania lekára v našej poradni. V rámci služby objednania to nie je možné. {disclaimerLink}"
    },
    "questionDisclaimerLink": "Viac",
    "orderDisclaimerLink": "Spýtajte sa lekára",
    "title": "Ako funguje vystavenie eReceptu v uLekára.sk"
  },
  "tallyTest": {
    "latestTest": {
      "pill": "NOVÝ TEST"
    }
  },
  "questionPriceInfo": {
    "b2b": "Za položenie dotazu zaplatíte {price} {currency}, odpoveď lekára dostanete do {hours} h.",
    "b2bDiscount": "Za položenie dotazu zaplatíte {price} {currency} (zľava {discountPercent} % od {partnerName}), odpoveď lekára dostanete do {hours} h.",
    "b2c": "Za položenie dotazu zaplatíte {price} {currency}, odpoveď lekára dostanete do {hours} h. {termsLink}",
    "b2cLink": "Podrobné informácie"
  }
}